const fi = {
  language: 'fi',
  aiChat: {
    title: 'Glow Intelligence',
    close: 'Sulje',
    resize: 'Muuta paneelin leveyttä',
    move: 'Siirrä vetämällä tai nuolinäppäimillä',
    send: 'Lähetä',
    stop: 'Pysäytä',
    placeholder: 'Kysy, miten Glow toimii…',
    empty: 'Kysy mitä tahansa siitä, miten Glow toimii.',
    disclaimer:
      'Vastaukset ovat tekoälyn tuottamia ja voivat olla virheellisiä. Assistentilla ei ole pääsyä lähetystietoihisi.',
    error: 'Vastauksen muodostamisessa tapahtui virhe.',
    retry: 'Yritä uudelleen',
    helpful: 'Hyödyllinen',
    notHelpful: 'Ei hyödyllinen',
    commentLabel: 'Lisää kommentti',
    commentOptional: 'valinnainen',
    commentPlaceholder: 'Mikä tässä vastauksessa oli hyvää tai huonoa?',
    feedbackThanks: 'Kiitos palautteestasi.',
    beta: 'Beta',
    thinking: 'Miettii…',
    tools: {
      glossary: {
        running: 'Haetaan termiä {{detail}} sanastosta…',
        used: 'Termi {{detail}} haettiin sanastosta'
      },
      fallback: {
        running: 'Haetaan tietoja…',
        used: 'Tiedot haettu'
      }
    },
    newChat: 'Uusi keskustelu',
    language: 'Vastauskieli',
    copyAnswer: 'Kopioi vastaus',
    sources: 'Lähteet',
    sourceUpdated: 'Päivitetty {{date}}',
    app: { 'internal-frontend': 'Glow', 'customer-frontend': 'Asiakasportaali', tracking: 'Seuranta' },
    copied: 'Kopioitu',
    history: {
      open: 'Keskusteluhistoria',
      back: 'Takaisin keskusteluun',
      empty: 'Ei aiempia keskusteluja.',
      error: 'Keskustelujen lataaminen epäonnistui.',
      loadError: 'Keskustelun lataaminen epäonnistui.',
      delete: 'Poista keskustelu ”{{title}}”',
      deleteConfirm: 'Poistetaanko keskustelu ”{{title}}”?',
      deleteYes: 'Poista',
      deleteCancel: 'Peruuta',
      deleteError: 'Keskustelun poistaminen epäonnistui.'
    },
    suggestions: {
      dispatch: 'Miten määritän lähetyksiä reitille?',
      statuses: 'Mitä lähetysten eri tilat tarkoittavat?',
      recurring: 'Miten luon toistuvan reitin?',
      deviation: 'Mitä tarkoittaa, kun lähetyksellä on poikkeama?'
    }
  },
  userRoles: {
    admin: 'Admin',
    planner: 'Normaali',
    read_only_planner: 'Lukuoikeus',
    plus_planner: 'Plus',
    partner: 'Partneri',
    customer: 'Asiakas',
    customs_agent: 'Tulliagentti',
    support: 'Tuki',
    handler: 'Käsittelijä'
  },
  emptyStates: { notFoundTitle: 'Ei tuloksia' },
  application: {
    requiredLocation: 'Sijainti on pakollinen tieto',
    save: 'Tallenna',
    all: 'Kaikki',
    assigned: 'Määrätty',
    created: 'Luotu',
    selected: 'Valittu',
    filter: 'Suodata',
    reset: 'Nollaa',
    cluster: 'Klusteri',
    update: 'Päivitä',
    required: '*Pakollinen kenttä',
    lastUpdated: 'Viimeksi päivitetty',
    requiredShort: '*Pakollinen tieto',
    endsNextDay: 'päättyy seuraavana päivänä',
    search: 'Etsi',
    logOut: 'Kirjaudu ulos',
    courier: 'Lähetti',
    drivers: 'Lähetit',
    consignments: 'Lähetykset',
    status: 'Tila',
    address: 'Osoite',
    move: 'Siirrä',
    estimatedDepartureTime: 'ETD',
    adjusted: 'Tarkistaa',
    actual: 'Nykyinen',
    tracking: 'Seuranta',
    trackingPage: 'Vastaanottajan seurantasivu',
    phoneNumberShort: 'Puhelin',
    allSelected: 'Kaikki valitut',
    someSelected: '{{count}} valittu',
    noneSelected: 'Ei valittuja',
    appBuild: 'Sovellusversio',
    lastLogin: 'Viimeisin kirjautuminen',
    device: 'Laite',
    model: 'Malli',
    os: 'Käyttöjärjestelmä',
    units: 'Yksiköt',
    yes: 'Kyllä',
    no: 'Ei',
    notSelected: 'Ei valittu',
    sms: 'SMS',
    httpErrorToString: 'HTTP virhe: koodi {{status}} {{statusText}}',
    anErrorOccurred: 'Tapahtui virhe!',
    noAccessTitle: 'Ei pääsyä',
    noAccessMessage: 'Sinulla ei ole oikeutta käyttää tätä toimintoa',
    autoComplete: 'Etsi paikkoja...',
    autoCompleteWithoutDots: 'Etsi paikkoja',
    totalWeight: 'Kokonaispaino',
    totalVolume: 'Kokonaisvolyymi',
    validDeviationCode: 'Anna kelvollinen arvo',
    columns: 'Sarakkeet',
    title: {
      siteName: 'Glow',
      root: 'Tervetuloa',
      planner: 'Reitin suunnittelutyökalu',
      admin: 'Ylläpito',
      settings: 'Asetukset',
      plannerLive: 'Suunnittelutyökalu - Live',
      plannerLiveSlot: 'Suunnittelutyökalu - Live - Toimitusajankohta',
      plannerCouriers: 'Suunnittelutyökalu - Lähetit',
      templateRouteRules: 'Suunnittelutyökalu - Reittisääntöjen hallinta',
      plannerUnits: 'Suunnittelutyökalu - Yksiköt',
      plannerImport: 'Suunnittelutyökalu - Tuo',
      plannerUnresolved: 'Suunnittelutyökalu  - Selvittämätön',
      plannerCoordinates: 'Suunnittelutyökalu - Aseta koordinaatit',
      plannerConsignments: 'Suunnittelutyökalu  - Lähetykset',
      plannerSearch: 'Suunnittelutyökalu   - Etsi',
      plannerPlanning: 'Suunnittelutyökalu  - Sunnittelu',
      waybills: 'Suunnittelutyökalu - Rahtikirjat',
      deliveryNotes: 'Suunnittelutyökalu - Lähetteet',
      plannerInvoicing: 'Suunnittelutyökalu  - Laskutus',
      plannerCreateBillingOrder: 'Suunnittelutyökalu - Luo laskutustilaus',
      plannerEditBillingOrder: 'Suunnittelutyökalu - Muokkaa laskutustilausta',
      plannerCreateCreditNote: 'Suunnittelutyökalu - Luo hyvityslasku',
      plannerCopyToBillingOrder: 'Suunnittelutyökalu - Kopioi laskutustilaukseksi',
      plannerVehicle: 'Suunnittelutyökalu - Vehicles',
      report: 'Raportit',
      customerDepartmentLive: 'Live-näkymä',
      recipient: 'Lähetyksen seuranta - seuranta - Bring',
      instant: 'Kuriiri',
      instantBooking: 'Tilaus',
      h2Booking: 'H2 Tilaus',
      orderConfirmation: 'Tilausvahvistus',
      customerPortal: 'Asiakasportaali',
      financial: 'Rahoitusoikeudet',
      readAny: 'Lukuoikeus kaikkeen',
      instantMap: 'Pikakartta',
      instantMap2: '$t(application.title.instantMap)',
      recurringOrder: 'Vakio tilaukset',
      corrections: 'Tilauksen virheiden korjaus',
      jobs: 'Työpaikkojen seuranta',
      holidays: 'Lomat',
      shipmentLabels: 'Osoitekortit',
      addresses: 'Osoitteet',
      shd: 'SHD',
      preadvice: 'Ennakkoilmoitus',
      apollo: 'Apollo',
      routeReceiptList: 'Kuittauslista',
      routesOverview: 'Reittikatsaus',
      loadList: 'Lastauslista',
      pickupOrders: 'Noutotilaukset',
      customerBooking: 'Asiakastilaus',
      manageReturns: 'Hallinnoi palautuksia',
      preAdviceFollowup: 'Hallitse ennakkoilmoitusta',
      integrations: '$t(apolloAdmin.title)',
      parcelHub: '$t(parcelHubAdmin.title)',
      recurring: 'Suunnittelutyökalu - Vakiot'
    },
    language: { en: 'Englanti', nb: 'Norja', sv: 'Ruotsi', dk: 'Tanska', fi: 'Suomi', fr: 'Ranska' },
    country: {
      AllCountry: 'Kaikki maat',
      Country: 'Maa',
      AD: 'Andorra',
      AT: 'Itävalta',
      BE: 'Belgia',
      BA: 'Bosnia ja Hertsegovina',
      BG: 'Bulgaria',
      HR: 'Kroatia',
      CZ: 'Tšekki',
      DK: 'Tanska',
      GB: 'Yhdistynyt kuningaskunta',
      EE: 'Viro',
      FO: 'Färsaaret',
      FI: 'Suomi',
      FR: 'Ranska',
      DE: 'Saksa',
      GI: 'Gibraltar',
      GR: 'Kreikka',
      HU: 'Unkari',
      IS: 'Islanti',
      IE: 'Irlanti',
      IT: 'Italia',
      LV: 'Latvia',
      LT: 'Liettua',
      LU: 'Luxemburg',
      MK: 'Pohjois-Makedonia',
      MT: 'Malta',
      MC: 'Monaco',
      ME: 'Montenegro',
      NL: 'Alankomaat',
      NO: 'Norja',
      PL: 'Puola',
      PT: 'Portugali',
      RO: 'Romania',
      RU: 'Venäjä',
      SM: 'San Marino',
      RS: 'Serbia',
      SK: 'Slovakia',
      SI: 'Slovenia',
      ES: 'Espanja',
      SE: 'Ruotsi',
      CH: 'Sveitsi',
      UA: 'Ukraina'
    },
    timeDistance: 'Suunniteltu aika ja välimatka',
    driverReturnToAddress: 'Älä anna palautusosoitetta',
    distance: 'Välimatka',
    helpLink: '(Mikä tämä on?)',
    none: 'Ei mitään',
    noOptions: 'Ei vaihtoehtoja',
    groups: 'Ryhmät',
    departments: 'Osastot',
    selectAll: 'Valitse kaikki',
    totalCustomerPrice: 'Asiakashinta yhteensä',
    totalUnitPrice: 'Yksikköhinta yhteensä',
    notFound: 'Ei löytynyt'
  },
  serviceLevel: {
    label: 'Alenna palvelutasoa',
    ingress:
      'Aseta oletussähköpostiosoite, johon voidaan lähettää ilmoitus tilauksen rekisteröinnistä, noudosta ja/tai toimituksesta.',
    notSet: 'Ei valittu',
    none: 'Pois päältä',
    standard: 'Vakiotaso',
    premium: 'Premium'
  },
  dropdown: {
    nrSelected: '{{count}} valittu',
    nrSelected_other: '{{count}} valittua',
    selectedCustomers: '{{count}} asiakas',
    selectedCustomers_other: '{{count}} asiakkaat',
    allCustomers: 'Kaikki asiakkaat',
    filterCustomers: 'Suodata asiakkaat',
    selectedDepartments: '{{count}} osasto',
    selectedDepartments_other: '{{count}} osastot',
    allDepartments: 'Kaikki osastot',
    filterDepartments: 'Suodata osastot',
    selectedServiceCodes: '{{count}} palvelu',
    selectedServiceCodes_other: '{{count}} palvelut',
    allServiceCodes: 'Kaikki palvelut',
    filterServiceCodes: 'Suodatinpalvelut',
    selectedVasCodes: '{{count}} vas',
    selectedVasCodes_other: '{{count}} vases',
    allVasCodes: 'Kaikki VAS-palvelut',
    filterVasCodes: 'Suodata VAS-palvelut',
    selectedDestinations: '{{count}} määränpää',
    selectedDestinations_other: '{{count}} määränpäät',
    filterSelfBillingUnitIds: 'Suodata itselaskutusyksiköiden tunnukset',
    allSelfBillingUnitIds: 'Kaikki itselaskutusyksiköiden tunnukset',
    selectedSelfBillingUnitIds: '{{count}} itselaskutusyksikön tunnus',
    selectedSelfBillingUnitIds_other: '{{count}} itselaskutusyksikön tunnusta'
  },
  button: {
    actions: 'Toiminnot',
    edit: 'Muokkaa',
    back: 'Takaisin',
    cancel: 'Peruuta',
    confirm: 'Vahvista',
    done: 'Valmis',
    clear: 'Tyhjennä',
    close: 'Sulje',
    save: 'Tallenna',
    saveAndPublish: 'Tallenna ja julkaise',
    delete: 'Poista',
    export: 'Vie',
    new: 'Luo uusi',
    search: 'Etsi',
    add: 'Lisää',
    remove: 'Poista',
    assign: 'Määritä',
    fullEdit: 'Muokkaa tilauksella',
    continue: 'Jatka',
    copy: 'Kopioi',
    continueAndSave: 'Jatka ja tallenna',
    triggerRollout: 'Käynnistä käyttöönotto',
    triggerRolloutAgain: 'Ota käyttöön uudelleen',
    clearAll: 'Tyhjennä kaikki',
    selectAll: 'Valitse kaikki'
  },
  modals: {
    preplan: {
      create: 'Suunnittele tilaus',
      change: 'Vaihda valittu kuljettaja',
      shipmentInfo: 'Suunnittele tilaus {{shipmentId}} ({{pickupName}} {{deliveryName}})',
      pickDriver: 'Valitse kuljettaja..',
      unpreplan: 'Peru Suunnittelu',
      preplan: 'Suunnittele',
      error: 'Suunnittelua ei pystytä toteuttamaan',
      notification: {
        preplanned: 'Suunniteltu',
        unpreplanned: 'Suunnittelematon',
        preplannedMessage: 'Tilaus suunniteltiin {{courierId}}',
        unpreplannedMessage: 'Tilauksen suunnittelu peruttu'
      }
    },
    maps: {
      save: 'Tallenna',
      cancel: 'Peruuta',
      delete: 'Poista',
      editMode: 'Muokkaa',
      mapArea: '{{routeName}} kartta-alue',
      saved: 'Tallennettu',
      deleted: 'Poistetut'
    }
  },
  consignment: {
    packageType: 'Paketin tyyppi',
    palletFootprints: 'Lavapaikka',
    loadingMeters: 'Latausmittarit',
    includePreAdvice: 'Ennakkoilmoitus',
    onlyFailedPreAdvice: 'Ennakkoilmoitus epäonnistui',
    onlyReturnPreAdvice: 'Palauta lähettäjälle',
    search: 'Etsi lähetyksiä',
    noShipmentsFound: 'Ei haku tuloksia',
    clickButtonToSearch: 'Paina haku painiketta suorittaaksesi haku',
    consignmentsForDate: 'Lähetykset {{date}}',
    showOnlyEditable: 'Vain muokattavissa',
    showOnlyNotAssigned: 'Ei annettu toimitettavaksi',
    withoutDate: 'Ilman päivämäärää',
    extendedSearch: 'Laajennettu haku',
    showDeleted: 'Näytä poistetut',
    showDeviated: 'Näytä poikkeama',
    deletedBy: 'Poistanut',
    deletionReason: 'Syy',
    numberOfConsignments: 'Löydetty {{number}} lähetystä',
    showAll: 'Kaikki',
    delivery: 'Toimitus',
    pickup: 'Nouto',
    pickups: '{{count}} nouto',
    pickups_other: '{{count}} noutoa',
    edit: 'Muokkaa',
    deleteOrders: 'Poista',
    duplicateOrder: 'Kopioida',
    duplicateConfirmation: 'Haluatko varmasti kopioida tämän tilauksen?',
    orderDuplicated: 'Tilaus on kopioitu',
    orderDuplicatedFailed: 'Tilauksen kopiointi epäonnistui',
    copyOrder: 'Kopioi',
    editOrder: 'Muokkaa',
    cantDeleteOfferedOrders: 'Voit poistaa vain tulevia tilauksia, joita ei ole vielä lisätty reitille',
    cantEditOfferedOrders: 'Voit muokata vain tulevia tilauksia, joita ei ole vielä lisätty reitille',
    onlyCopyOne: 'Voit kopioida vain yhden tilauksen kerrallaan',
    onlyEditOne: 'Voit muokata vain yhtä tilausta kerrallaan',
    deletedOrderNotCopyable: 'Poistettua tilausta ei voida kopioida koska tilauksen tiedot ovat puutteelliset',
    restoreOrder: 'Palauta',
    deletedOrderNotRestorable: 'Poistettua tilausta ei voida palauttaa puuttuvien tietojen takia',
    preplan: 'Suunnittele',
    deleteConfirmation: 'Haluatko varmasti poistaa tämän lähetyksen?',
    deleteMultipleConfirmation: 'Oletko varma että haluat poistaa valitut lähetykset?',
    copyConfirmation: 'Haluatko varmasti kopioida tämän lähetyksen?',
    editConsignment: 'Muokkaa lähetystietoja',
    changeDateAndTime: 'Muuta päivämäärää ja aikaa',
    searchShipments: 'Etsi tilaus:',
    searchCustomers: 'Etsi asiakas:',
    excelExportRemoved:
      'Exceliin vieminen ei ole enää mahdollista tältä sivulta. Käytä sen sijaan <0>Import / Export</0> -sivua tai <0>SAGAa</0>. Tämä on osa laajempaa päivitystä, jossa sivulta poistetaan vähitellen lisää toimintoja, ennen kuin se lopulta poistetaan käytöstä ja suljetaan. Kaikki työ tulee tehdä <1>tällä sivulla</1>.',
    filterBy: 'Suodata:',
    limitedShipmentsShownMessage: 'Näyttää enimmäis määrän {{count}} tilausta, tarkenna hakua',
    limitedUnresolvedAddressesShownMessage: 'Näytetään enimmäiset {{count}} epäselvää osoitetta',
    bulkActions: 'Massa toiminta',
    bulkActionsMultiple: 'Massa toiminta ({{count}})',
    addToRecurringGroup: 'Lisää tilaus vakio ryhmään',
    moveShipmentsToDifferentDepartment: 'Siirrä toiseen osastoon',
    addEvents: 'Lisää tapahtuma',
    disabledEditDeleteHelperText:
      'Tilauksen tietoja ei voi muuttaa, eikä sitä voi poistaa. Tehdäksesi muutoksia ole yhteydessä Bring asiakaspalveluun.',
    editPickupConsignment: 'Päivitä noutotietoja',
    editDeliveryConsignment: 'Päivitä toimitustietoja',
    editPickupAndDeliveryTime: 'Päivitä nouto ja toimitus aikoja',
    editConsignmentLocation: 'Sijainti',
    editConsignmentTime: 'Aika',
    editConsignmentName: 'Nimi',
    editConsignmentPhone: 'Puhelinnumero',
    editConsignmentInstructions: 'Ohjeet',
    earliestPickupTime: 'Aikaisin noutoaika *',
    latestPickupTime: 'Myöhäisin noutoaika *',
    earliestDeliveryTime: 'Aikaisin toimitusaika',
    latestDeliveryTime: 'Myöhäisin toimitusaika',
    enterPickupInstructions: 'Anna nouto-ohjeet',
    enterDeliveryInstructions: 'Anna toimitusohjeet',
    enterDeliveryName: 'Anna toimituksen nimi',
    enterPickupName: 'Annan noudon nimi',
    enterPickupPhone: 'Anna noudosta vastaavan puhelinnumero',
    enterDeliveryPhone: 'Anna toimituksesta vastaavan puhelinnumero',
    specificationSize: 'Koko',
    enterSpecificationSize: 'Anna specification size',
    editSpecificationSize: 'Muokkaa specification size',
    enterSpecificationDescription: 'Kirjoita kuvaus',
    editSpecificationDescription: 'Muokkaa kuvausta',
    editPickupInfoDescription: 'Voidaksesi muokata tietoja sinun pitää valita jompikumpi yllä olevista vaihtoehdoista',
    updateLocationFor: 'Päivitä {{count}} lähetyksen tiedot',
    updateLocationFor_other: 'Päivitä {{count}} lähetyksen noutotiedot',
    comment: 'Kommentti',
    show: 'Näytä',
    filter: 'Suodata lähetyksiä',
    state: 'Tila',
    estimatedDelivery: 'Arvioitu toimitus',
    requestedTimePickup: 'Toivottu noutoaika',
    requestedTimeDelivery: 'Toivottu toimitusaika',
    timeNotSet: 'Ei valittu',
    customerReference: 'Asiakkaan viite',
    shipmentId: 'Lähetystunnus',
    packageId: 'Paketin tunnus',
    noCourier: 'Ei lähettiä',
    noSlot: 'Ei sopivaa toimitusaikaa',
    showEvents: 'Näytä tapahtumat →',
    hideEvents: 'Piilota tapahtumat ←',
    events: 'Tapahtumat',
    send: 'Lähetä',
    sendMessage: 'Lähetä viesti',
    sendCommentFailed: 'Kommentin tallentaminen epäonnistui',
    recipient: 'Vastaanottaja',
    unresolved: 'Selvittämättömät lähetykset',
    description: 'Kuvaus',
    pickupAddress: 'Nouto-osoite',
    numberOfPackages: 'Pakettien lukumäärä',
    registeredPickupAddress: 'Rekisteröity nouto-osoite',
    pickupZipCode: 'Postinumero',
    pickupZipArea: 'Alue',
    deliveryAddress: 'Toimitusosoite',
    deliveryZipCode: 'Postinumero',
    deliveryZipArea: 'Alue',
    deliveryLocation: 'Sijainti',
    registeredDeliveryAddress: 'Rekisteröity toimitusosoite',
    updated: 'Lähetys on päivitetty',
    moved: 'Lähetys on siirretty',
    unresolvedMessage: 'Emme pystyneet paikantamaan {{count}} lähetyksen osoitetta, ole hyvä ja lisää osoitteet.',
    unresolvedMessage_other: 'Emme pystyneet paikantamaan {{count}} lähetyksen osoitetta, ole hyvä ja lisää osoitteet.',
    foundUnresolvedMessage:
      'Löysimme seuraavat voimassa olevan osoitteet tälle lähetykselle. Jos ne ovat oikein, paina päivitä. Muussa tapauksessa etsi oikea osoite alla olevalta kartalta.',
    remove: 'Poista',
    optimizingNewSlot: 'Optimoi lähetyksen uuteen ajankohtaan',
    slotSelect: 'Valitse toimitusajankohta',
    pickupInstructions: 'Nouto-ohjeet',
    deliveryInstructions: 'Toimitusohjeet',
    specificationDescription: 'Kuvaus',
    tracking: 'Seuranta',
    recipientPhone: 'Vastaanottajan puhelinnumero',
    customerRef: 'Asiakkaan viite',
    service: 'Palvelu',
    message: {
      CREATED: 'Luotu',
      ASSIGNED: 'Määritetty reitille',
      UNASSIGNED: 'Ei annettu toimitettavaksi',
      COLLECTED: 'Noudettu',
      DELIVERED: 'Toimitettu',
      DEVIATED: 'Poikkeama',
      COMMENT: 'Kommentti',
      RESOLVED: 'Ratkaistu',
      UNRESOLVED: 'Ei ratkaistu',
      OFFERED: 'Tarjottu',
      REJECTED: 'Hylätty',
      ACCEPTED: 'Hyväksytty',
      RETURNED: 'Palautettu',
      DELETED: 'Poistetut',
      UNCONFIRMED: 'Vahvistamaton',
      REFUSED: 'Hylätty'
    },
    adjustTabTitle: 'Muokata',
    bookingPanelTitle: 'Tilaus',
    mapPanelTitle: 'Kartta',
    recipientName: 'Vastaanottajan nimi',
    receivedBy: 'Vastaanottanut',
    manuallyChangeLocations: 'Sijainnit muutettu manuaalisesti',
    manualOverrideDeviationTimeConfirm: 'Hyväksy manuaalinen poikkeama valituille tilauksille',
    manualOverrideDeliveryTimeConfirm: 'Hyväksy manuaalinen toimitus valituille tilauksille',
    onManuallyChangeLocationsConfirm: 'Oletko varma että haluat tehdä tilauksista epäselvän?',
    unresolveDeliveryAddress: 'Siirrä vienti-osoite epäselväksi',
    unresolvePickupAddress: 'Siirrä nouto-osoite epäselväksi',
    unresolveAddress: 'Poista osoitteen koordinaatit',
    reference: 'Viite',
    shipmentIdNumber: 'Ei',
    shipmentDetails: 'Lähetyksen tiedot',
    customer: 'Asiakas',
    subcustomer: 'Asiakasnumero',
    dateAndTime: 'Päivä ja ajat',
    filterCustomer: 'Suodata asiakas',
    searchShipmentDateError: 'Anna aikaväliksi alle 120 päivää',
    searchPhraseLength: 'Haun täytyy olla vähintään {{minLength}} kirjainta pitkä.',
    moveOrder: 'Siirrä lähetys',
    moveOrderTitle: 'Siirrä lähetys toiselle osastolle',
    moveOrderDefault: 'Valitse osasto',
    label: 'Etiketti',
    createLabel: 'Luo etiketti',
    createDeliveryLabel: 'Luo toimitusosoitekortti',
    createLabelShipment: 'Luo etiketti (lähetys)',
    createMultipleLabel: 'Luo etiketti ({{count}})',
    viewLabel: 'Näytä etiketti',
    viewLabels: 'Näytä osoitekortit',
    generateLabelError: 'Virhe: {{error}}',
    generateLabelErrorTitle: 'Jokin meni vikaan',
    generateLabelErrorDescription: 'Osoitekortteja ei voitu luoda',
    generateLabelErrorButton: 'Näytä virhekoodi',
    generatingLabels: 'Odota hetki. Osoitekortteja luodaan',
    labelsGeneratedSuccessfully: 'Osoitekortit luotu onnistuneesti',
    vas: 'Lisäarvoa tuottavat palvelut (VAS)',
    price: 'Hinta',
    orderSources: {
      expressit: 'ExpressIT',
      glow: 'GLOW',
      glow_customerBooking: 'GLOW Asiakkaan tilaus',
      glow_excelImportV2: 'GLOW Excel',
      excel: 'GLOW Excel',
      HappyFlow: 'Happy Flow',
      '98466118503': 'Mybring',
      '98466118504': 'Mybring',
      glow_recurring: 'Vakio tilaukset',
      ShipmentAPI: 'Shipment API',
      others: 'EDI'
    },
    pickupDeviation: 'Noudon poikkeama',
    deliveryDeviation: 'Toimituksen poikkeama',
    shipmentSyncStatus: { yes: 'Kyllä', no: 'Ei', partial: 'Osittain' },
    selectOtherActions: 'Valitse muut toimet'
  },
  eventsList: { timeWindow: 'Aikaikkuna', from: 'Alkaen', to: 'Asti' },
  status: {
    started: 'Aloitettu',
    notStarted: 'Ei aloitettu'
  },
  consignmentEvent: {
    message: {
      'auto-dispatch-succeeded': 'Auto-dispatch aloitettu',
      'auto-dispatch-failed': 'Auto-dispatch epäonnistui',
      'optimizing-failed': 'Reittioptimointi epäonnistui',
      'order-excluded-from-invoicing': 'Jätetty laskutuksen ulkopuolelle',
      'reoptimized-with-fallback-window': 'Reitti optimoitu automaattisesti uudelleen',
      routeName: 'Reitin nimi',
      resolved: 'Osoitekoordinaatit asetettu',
      unresolved: 'Osoitekoordinaatit eivät ole asetettu',
      'pre-advice-status-changed': 'Ennakkoilmoituksen tila muutettu',
      'reported-damaged': 'Ilmoitettu vaurio',
      'reported-missing-article': 'Ilmoitettu puuttuvia tuotteita',
      comment: 'Kommentti',
      created: 'Luotu',
      completed: 'Valmis',
      assigned: 'Määritetty',
      plannedOnRoute: 'Suunniteltu reitille',
      plannedOnRouteMoreInfo: 'Suunniteltu reitille {{routeName}} ({{unitName}})',
      nameOfUnit: 'Yksikön nimi',
      optimizeProviderId: 'Optimointi-ID',
      noOptimizationEngine: 'Ei optimointimoottoria',
      failedOptimizeProviderId: 'Epäonnistunut optimointi-ID',
      retryOptimizeProviderId: 'Uuden yrityksen optimointi-ID',
      optimizationTimeWindow: 'Optimoinnin aikaikkuna',
      extendedBy: 'Pidennetty {{minutes}} min',
      optimizingFailedOtherNotPlanned: 'Toista reitin lähetystä ei voitu suunnitella',
      optimizingFailedError: 'Optimointi keskeytyi virheeseen',
      delivered: 'Toimitettu',
      collected: 'Noudettu',
      returned: 'Palautettu',
      deviated: 'Poikkeama',
      damaged: 'Vaurioitunut',
      notification: 'Ilmoitus',
      slotChanged: 'Toimitusajankohta muutettu manuaalisesti',
      unassigned: 'Ei annettu toimitettavaksi',
      rejected: 'Hylätty',
      image: 'Kuva',
      error: 'Virhe',
      started: 'Aloitettu',
      stopped: 'Lopetettu',
      accepted: 'Hyväksytty',
      offered: 'Tarjottu',
      unitName: 'Yksikkö',
      driverName: 'Kuljettaja',
      'delivery-id-check': 'ID:n tarkistus',
      'deviation-sms-sent': 'Poikkeama-SMS lähetetty',
      'delivered-manually-overridden': 'Toimitus manuaalisesti ohitettu',
      'order-released-for-invoicing': 'Laskutus vapautettu',
      'order-paused-from-invoicing': 'Laskutus pysäytetty',
      'manually-set-invoicing-ok-for-order-invoicing': 'Laskutettu OK',
      'manually-set-not-invoiced-for-order-invoicing': 'Ei laskutettu',
      'manually-set-excluded-from-invoicing': 'Poistettu laskutuksesta',
      'unit-manually-added-for-invoicing': 'Yksikkö lisätty manuaalisesti',
      'deviated-manually-overridden': 'Poikkeama manuaalisesti ohitettu',
      'collected-manually-overridden': 'Nouto manuaalisesti ohitettu',
      'pickup-location-changed': 'Noutoaika muutettu',
      'delivery-time-estimated': 'Päivitetty toimitusaika',
      'slot-manually-changed': 'Toimitusajankohta manuaalisesti ohitettu',
      'pickup-time-changed': 'Noutoaika muutettu',
      'manually-change-location': 'Sijainnit manuaalisesti ohitettu',
      'pickup-consignment-data-changed': 'Noutotietoja muutettu',
      'delivery-consignment-data-changed': 'Toimitustietoja muutettu',
      'specification-size-data-changed': 'Specification Size muutettu',
      'specification-description-data-changed': 'Kuvausta muutettu',
      'digital-identity-verified': 'Vastaanottajan henkilöllisyys varmistettu digitaalisesti',
      'digital-identity-verification-failed': 'Ei voitu vahvistaa vastaanottajan henkilöllisyyttä digitaalisesti',
      'flex-delivery-ordered': 'Yksinkertaistettu toimitus tilattu vastaanottajan toimesta',
      'flex-delivery-ordered-by-sender': 'Yksinkertaistettu toimitus tilattu lähettäjän toimesta',
      'flex-delivery-changed': 'Yksinkertaistettu toimitus muutettu',
      'flex-delivery-confirmation-sms-sent': 'Flex toimitus vahvistus viesti lähetetty',
      'flex-delivery-confirmation-app-notification': 'Push-ilmoitus joustavan toimituksen vahvistuksesta lähetetty',
      'return-to-pickup-point-delivery-deviated': 'Toimitetaan toimituspisteeseen',
      recipientName: 'Vastaanottajan nimi',
      receivedBy: 'Vastaanottanut',
      'reject-order-correction': 'Tilauksen korjaus hylätty',
      'accept-order-correction': 'Tilauksen korjaus hyväksytty',
      'handed-over-to-other-unit': 'Välitetty toiselle yksikölle',
      'handed-over': 'Välitetty toiselle yksikölle',
      deliveredWithoutSignature: 'Toimitettu ilman allekirjoitusta',
      deliveredWithoutSignatureReason: {
        left_package_outside: 'Toimitettu ohjeiden mukaisesti',
        did_not_get_signature: 'Toimitettu henkilölle',
        DELIVER_IN_PERSON: 'Henkilökohtaisesti'
      },
      'returned-manually-overridden': 'Toimitus manuaalisesti ohitettu',
      'eta-sms-sent': 'ETA-SMS lähetetty',
      calculatedEta: 'Arvioitu saapuminen: {{eta}}',
      etaSmsLabel: 'Arvioitu saapuminen',
      scanned: 'Saapunut terminaaliin',
      'arrived-at-terminal': 'Saapunut jakeluterminaaliin',
      'order-sorted': 'Lajiteltu',
      'not-arrived-at-distributing-terminal': 'Ei saapunut jakeluterminaaliin',
      'pickup-eta-sms-sent': 'Arvioitu noutoaika lähetetty',
      'handed-in-at-posten-terminal': 'Saapunut lajitteluterminaaliin',
      'pickup-sms-sent': 'Seuranta tekstiviesti lähetetty',
      'pre-pickup-sms-sent': 'Seuranta SMS lähetetty',
      'pickup-address-unresolved': 'Nouto-osoite on siirretty epäselviin',
      'delivery-address-unresolved': 'Vienti osoite on siirretty epäselviin',
      'in-transit': 'Kuljetuksessa',
      'upcoming-pickup-sms-sent': 'Tulevan toimituksen SMS lähetetty',
      'order-sorted-same-day': 'Päivämäärä asetettu tälle päivälle terminaali sovelluksella',
      'signature-sms-sent': 'Allekirjoitus sms lähetetty',
      'flex-delivery-cancelled': 'Yksinkertaistettu toimitus peruttu',
      'delivery-time-ordered': 'Vastaanottaja on muuttanut toimituspäivän',
      'delivery-time-ordered-internal': 'Muuttanut toimituspäivän',
      'delivery-time-updated-from-hf-sync': 'Toimitusaika synkronoitu HF:stä',
      'planned-delivery-date-ordered': 'Suunniteltu toimitus päivä tilattu',
      'delay-sms-sent': 'Tekstiviesti liittyen myöhästyneeseen toimitukseen lähetetty',
      'production-deviation': 'Tuotantopoikkeama',
      'manual-delay-sms-sent': 'Manuaalinen viivästys-SMS lähetetty',
      'route-planning-complete': 'Reitti valmis',
      'signature-delivered': 'Vastaanottajan allekirjoitus',
      showPicture: 'Näytä kuva',
      'external-address-wash': 'Toimitustietoja muutettu',
      'order-note-changed': 'Muistiinpanot muutettu',
      'customer-details-changed': 'Asiakastiedot muutettu',
      'order-data-changed': 'Järjestys muutettu',
      'order-moved-to-department': 'Siirretty osastojen välillä',
      'order-moved-to-department-with-data': 'Lähetys siirretty osastosta',
      'package-measurements-changed': 'Paketin koon muuttaminen',
      'package-data-changed': 'Paketin tiedot muutettu',
      'driver-deviated-from-route': 'Kuljettaja poikkesi reitiltä',
      'driver-deviated-from-route-at-pickup': 'Kuljettaja poikkesi reitiltä noudossa',
      'delivered-outside-service-time-window': 'Toimitus tai poikkeama on palvelu ajan ulkopuolella',
      'delivered-outside-estimated-time-window': 'Toimitus tai poikkeama on arvioidun aikaikkunan ulkopuolella',
      'delivered-in-estimated-time-window': 'Toimitus tai poikkeama on arvioidun aikaikkunan sisällä',
      'picked-up-outside-service-time-window': 'Nouto tai poikkeama on palveluajan ulkopuolella',
      'picked-up-outside-estimated-time-window': 'Nouto tai poikkeama on arvioidun aikaikkunan ulkopuolella',
      'picked-up-in-estimated-time-window': 'Nouto tai poikkeama on arvioidun aikaikkunan sisällä',
      'ordered-delivery-time-set-by-production-time-window': 'Tuotannon aikaikkuna asetettu',
      'seen-by-recipient': 'Vastaanottaja on nähnyt seuranta sivun',
      'first-estimated-times-seen': 'Vastaanottaja on nähnyt arvioidun ajan',
      'pre-advice-push-sms-sent': 'Ennakkoilmoituksen PUSH-SMS lähetetty',
      'pre-advice-push-return-sms-sent': 'Ennakkoilmoituksen PUSH-RETURN-SMS lähetetty',
      'pre-advice-pull-sms-sent': 'Ennakkoilmoituksen PULL-SMS lähetetty',
      'pre-advice-pull-email-sent': 'Ennakkoilmoituksen PULL-sähköposti lähetetty',
      'pre-advice-pull-reminder-sms-sent': 'Ennakkoilmoituksen PULL-muistutus-SMS lähetetty vastaanottajalle',
      'pre-advice-pull-reminder-email-sent': 'Ennakkoilmoituksen PULL-muistutussähköposti lähetetty vastaanottajalle',
      'pre-advice-pup-sms-sent': 'Ennakkoilmoituksen PUP-SMS lähetetty',
      'pre-advice-return-sms-sent': 'Ennakkoilmoituksen Return-SMS lähetetty',
      'pre-advice-return-email-sent': 'Ennakkoilmoituksen Return-sähköposti lähetetty',
      'pre-advice-pull-reminder-to-sender-email-sent':
        'Ennakkoilmoituksen PULL-muistutussähköposti lähetetty lähettäjälle',
      'pre-advice-pup-reminder-to-sender-email-sent':
        'Ennakkoilmoituksen PUP-muistutussähköposti lähetetty lähettäjälle',
      'pre-advice-return-return-to-sender-email-sent':
        'Ennakkoilmoituksen RETURN-sähköposti palautuksesta lähettäjälle lähetetty',
      'pre-advice-pull-return-to-sender-email-sent':
        'Ennakkoilmoituksen PULL-sähköposti palautuksesta lähettäjälle lähetetty',
      'pre-advice-push-return-email-sent': 'Ennakkoilmoituksen PUSH-sähköposti palautuksesta lähettäjälle lähetetty',
      'pre-advice-manual-attempt': 'Manuaalinen ennakkoilmoitusyritys',
      'pre-advice-manual-request': 'Manuaalinen ennakkoilmoitus aloitettu',
      'pre-advice-active-return-to-customer-email-sent':
        'Ennakkoilmoituksen aktiivinen palautus: sähköposti lähetetty asiakkaalle',
      'pre-advice-active-return-not-picked-up-email-sent':
        'Ennakkoilmoituksen aktiivista palautusta ei noudettu: sähköposti lähetetty asiakkaalle',
      'pre-advice-active-return-info-to-customer-email-sent':
        'Ennakkoilmoituksen aktiivisen palautuksen tiedot: sähköposti lähetetty asiakkaalle',
      'pre-advice-passive-return-to-customer-email-sent':
        'Ennakkoilmoituksen passiivinen palautus: sähköposti lähetetty asiakkaalle',
      'notification-to-sender-failed': 'Sähköposti-ilmoitus asiakkaalle epäonnistui',
      'delivery-location-deviation': 'Toimitus tai poikkeama ei odotetussa paikassa',
      'delivery-sms-sent': 'Toimitus SMS lähetetty',
      'parcelbox-allocated': 'Paikka varattu pakettilaatikossa',
      unconfirmed: 'Vahvistamaton',
      refused: 'Hylätty',
      'accepted-by-planner': 'Hyväksytty',
      'apartment-information-updated': 'Asunnon tiedot päivitetty',
      'lock-code-entered': 'Ovikoodi syötetty',
      'claim-registered-email-sent': 'Sähköposti viallisista tai puuttuvista tuotteista lähetetty',
      'invoicing-failed': 'Laskutus epäonnistui',
      'invoiced-ok': 'Laskutus OK',
      'service-upgrade-purchased': 'Lisämyynti: Vastaanottajan tilaama kuljetuspalvelu',
      serviceUpgradePurchasedDescription: 'Vastaanottaja tilasi kantopalvelun',
      'preliminary-loaded': 'Alustavasti lastattu',
      selfBillingUnitId: 'Self-billing unit ID',
      selfBillingUser: 'Käyttäjä',
      'manual-price-override': 'Hinta päällekirjoitettu',
      'incomplete-price-approved': 'Epätäydellinen hinta hyväksytty',
      'incomplete-price-unapproved': 'Puutteellinen hinnan hyväksyntä peruttu',
      'b2r-return-order-created': 'B2R-palautustilaus luotu',
      unloaded: 'Purettu',
      'manually-changed-measurements': 'Manuaalisesti muutettu paino ja tilavuus',
      'internal-trade-order-created': 'Sisäisen kaupan tilaus luotu',
      'delivery-time-purchased': 'Lisämyynti: Lyhyempi aikaikkuna vastaanottajan tilaamana',
      'invoice-awaiting-acknowledgement': 'Odottaa tilausvahvistusta',
      'parcel-locker-delivery-selected': 'Pakettiautomaatti valittu',
      'cancelled-parcel-locker-delivery': 'Pakettiautomaatti peruttu',
      'pre-advice-result': 'Ennakkoilmoitus',
      'order-credited': 'Tilaus hyvitetty',
      'parcel-locker-tracking-sms-sent': 'Pakettiautomaattitoimituksen seuranta-SMS lähetetty',
      'time-window-cancelled-by-recipient': 'Vastaanottaja peruutti aikaikkunan',
      'hd-multileg-return-created': 'Palautusosuus luotu',
      'hd-multileg-return-failed': 'Palautusosuuden luonti epäonnistui',
      'invoice-acknowledged-by-external-system': 'Tilaus vahvistettu ulkoisen järjestelmän toimesta',
      'invoice-created-in-external-system': 'Lasku luotu ulkoiseen järjestelmään',
      'invoice-sent-to-customer': 'Lasku lähetetty asiakkaalle',
      'invoice-paid-by-customer': 'Asiakas on maksanut laskun',
      'invoice-due-date-updated': 'Laskun eräpäivä päivitetty',
      'invoice-paid-to-vendor': 'Lasku maksettu toimittajalle',
      'customer-invoiced': 'Asiakas laskutettu',
      'load-carrier-ready-for-distribution': 'Kuormankuljettaja valmiina jakelua varten',
      'bom-articles-muted': 'BOM PU/DEL jätetään pois laskutuksesta',
      'bom-articles-unmuted': 'BOM PU/DEL ei ole jätetty laskutuksen ulkopuolelle',
      'pickup-app-notification': 'Push-ilmoitus seurannasta lähetetty',
      'duplicate-order-created': 'Tilauksen kopio luotu',
      'ready-for-pickup': 'Valmis noudettavaksi (PUP terminaalissa)',
      'return-address-updated': 'Palautusosoite päivitetty',
      restored: 'Palautettu',
      'manually-marked-as-handled': 'Palautus merkitty käsitellyksi',
      'recipient-phone-number-updated': 'Vastaanottajan puhelinnumero päivitetty',
      'recipient-email-address-updated': 'Vastaanottajan sähköpostiosoite päivitetty'
    },
    cause: {
      plannedStop: 'Noutotiedot on päivitetty, koska tilaus lastattiin suunnitellulla pysähdyksellä',
      planToScan: 'Toimitustaiedot on päivitetty, koska lähetys skannattiin reitille',
      adhocHenteordre: 'Toimitustiedot on päivitetty, koska reitillä on eri loppuosoite kuin terminaalilla',
      sorted: 'Toimitusten tiedot on päivitetty, koska lähetys lajiteltiin',
      shipmentDelayed: 'Toimitustietoja on päivitetty, koska lähetys on viivästynyt',
      movedToNextWorkingDay: 'Siirretty seuraavalle työpäivälle',
      optimizedInLoadCarrier: 'Toimitustiedot on päivitetty, koska lähetys reititettiin osana kuormankantajaa'
    },
    source: 'Lähde',
    unassignedReason: 'Syy',
    returnAddressSource: {
      OrderSource: 'Käytetään asiakkaan varaustiedostossa ilmoittamaa palautusosoitetta',
      CustomerAdmin: 'Käytetään Customer Adminissa määritettyä palautusosoitetta',
      SenderAddress: 'Asiakkaan varaustiedostossa ei ole palautusosoitetta, käytetään lähettäjän osoitetta'
    },
    rejectedReason: {
      reason: 'Syy',
      private: 'Yksityinen asia',
      notEnoughTime: 'En pysy aikataulussa',
      notEnoughSpaceOnVehicle: 'Liian suuri lähetys',
      other: 'Muu',
      CJ: '$t(consignmentEvent.rejectedReason.notEnoughSpaceOnVehicle)',
      CK: '$t(consignmentEvent.rejectedReason.other)',
      CL: '$t(consignmentEvent.rejectedReason.notEnoughTime)',
      OL1: 'Ei reitillä',
      OL2: 'Ei tarpeeksi tilaa autossa',
      OL3: 'Ei tarpeeksi aikaa',
      OL4: 'Lähetystä ei löytynyt',
      OL5: 'Suunniteltu myöhemmäksi, mutta terminaalipysäkkejä ei ole jäljellä',
      comment: 'Kommentti'
    },
    idCheck: {
      idCheckFailed: 'ID:n tarkistus epäonnistui, mutta toimitettiin {{idCheckFailedResult}}',
      idCheckSummaryOther: 'Muu ({{otherType}}), syntymäaika {{birthDate}}',
      idCheckSummary: '{{idCheckType}}, syntymäaika {{birthDate}}',
      idCheckSummaryOtherLabel: 'Muu ({{otherType}})',
      idCheckValue: 'Syntymäaika {{birthDate}}'
    },
    damaged: {
      damageType: 'Vaurion tyyppi',
      courierInput: 'Kuljettajan merkintä',
      showPictureLink: 'Näytä kuva {{idx}}',
      type: { A: 'Vahingoittunut paketti/pakkaus', D: 'Paine/puristus vahinko', E: 'Tuhoutunut lähetys' }
    },
    invoiceInitiationType: {
      automatic: 'Suunniteltu laskutus',
      'manual-department-level': 'Osastotason manuaalinen laskutus',
      'manual-order-level': 'Tilaustason manuaalinen laskutus',
      'multiple-order-level': 'Käyttäjän manuaalinen useiden tilausten laskutus'
    },
    autoDispatchFailedReason: {
      NO_MATCHING_ROUTE: 'Sopivaa reittiä ei löytynyt',
      DISPATCH_REJECTED: 'Optimoinnin aikataulutus epäonnistui',
      RETRIES_EXHAUSTED: 'Kaikki yritykset epäonnistuivat'
    },
    excludedFromInvoicingReason: {
      UNIT_NOT_SELF_BILLING_WITH_INTERNAL_TRADE:
        'Jätetty automaattisesti laskutuksen ulkopuolelle, koska yksiköllä ei ole sekä tasauslaskutusta että sisäistä kauppatapahtumaa aktiivisina'
    },
    autoDispatchSucceeded: {
      matchedRange: 'Vastaava postinumeroväli: {{from}}-{{to}}.',
      matchedPostalCode: 'Vastaava postinumero: {{code}}.',
      viewRuleDetails: 'Katso säännön tiedot <a>täältä</a>',
      sentForOptimization: 'Tilaus vastasi auto-dispatch-sääntöä ja on lähetetty reittioptimointiin.'
    },
    invoiceCallback: {
      timeOfTransaction: 'Tapahtuman aika',
      transactionNumber: 'Tapahtumanumero järjestelmässä {{systemId}}',
      invoiceLink: 'Näytä lasku napsauttamalla'
    },
    changedFrom: 'Muutettu -',
    blankText: '(Tyhjä)',
    name: 'Nimi',
    deliveryOrderedByReceiver: 'Vastaanottaja tilasi toimituksen pakettiautomaattiin',
    invoiceEventReason: {
      manuallySetByUser: 'Käyttäjän manuaalisesti asettama',
      manualInvoiceInfo: 'Pysäytetty automaattisesti, koska tilaukselle annettiin manuaaliset laskutustiedot'
    },
    unresolved: {
      missingPickupCoordinates: 'Puuttuvat noutokoordinaatit',
      missingDeliveryCoordinates: 'Puuttuvat toimituskoordinaatit'
    },
    resolved: {
      source: {
        DepartmentLocation: 'koordinaatit osastolle',
        GeocodingAPI: 'Google',
        DatabaseLookup: 'esitallennetut koordinaatit',
        PickupPointAPI: 'Pickup Point API',
        GlowFrontend: 'Glow',
        EDI: 'tuntematon',
        CustomerSite: 'asiakkaan sijainti',
        ParcelHub: 'ParcelHub',
        ParcelInMailbox: 'postilaatikon koordinaatit',
        Driver: 'kuljettaja',
        OriginalOrder: 'Alkuperäinen tilaus',
        Google: 'Google',
        GoodsReturnAddress: 'tavaroiden palautusosoite'
      },
      pickup: {
        coordinatesSetBy: 'Noutokoordinaatit asetettu {{source}} toimesta',
        coordinatesManuallySet: 'Noutokoordinaatit on asetettu manuaalisesti',
        coordinatesRestored: 'Noutokoordinaatit palautettu',
        coordinatesSwapped: 'Noutokoordinaatit asetettu aiempiin toimituskoordinaatteihin'
      },
      delivery: {
        coordinatesSetBy: 'Toimituskoordinaatit asetettu {{source}} toimesta',
        coordinatesManuallySet: 'Toimituskoordinaatit on asetettu manuaalisesti',
        coordinatesRestored: 'Toimituskoordinaatit palautettu',
        coordinatesSwapped: 'Toimituskoordinaatit asetettu aiempiin noutokoordinaatteihin'
      }
    },
    created: {
      recurringOrder: 'Luotu toistuvasta tilauksesta.',
      showOriginalOrder: 'Näytä alkuperäinen',
      recurringRoute: 'Luotu toistuvasta reitistä',
      recurringRouteLink: 'reitin asetuksiin',
      showDuplicate: 'Näytä tilauksen kopio',
      showOrder: 'Näytä tilaus',
      fromThisOrder: 'Luotu tästä tilauksesta',
      fromOrder: 'Luotu tilauksesta'
    },
    outsideTimeWindow: {
      'delivered-outside-estimated-time-window': 'Arvioitu aikaväli',
      'delivered-in-estimated-time-window': 'Arvioitu aikaväli',
      'delivered-outside-service-time-window': 'Palvelun aikaväli',
      'picked-up-outside-estimated-time-window': 'Arvioitu aikaväli',
      'picked-up-in-estimated-time-window': 'Arvioitu aikaväli',
      'picked-up-outside-service-time-window': 'Palvelun aikaväli',
      actual: 'Todellinen toimitus tai poikkeama',
      actualPickup: 'Todellinen nouto tai poikkeama'
    },
    deliveryInstructions: 'Toimitusohjeet'
  },
  jobs: {
    job: 'Työ',
    lastStarted: 'Käynnistetty viimeksi',
    lastFinished: 'Valmistunut viimeksi',
    maxDuration: 'Enimmäiskesto',
    timeBetweenRuns: 'Aika ajojen välillä',
    disable: 'Poista käytöstä',
    enable: 'Ota käyttöön',
    disabled: 'Pois käytöstä',
    disabledInConfig: 'Pois käytöstä asetuksissa',
    mustBeASuperAdmin:
      'Sinun täytyy olla pääjärjestelmänvalvoja voidaksesi poistaa töitä käytöstä ja ottaa niitä käyttöön',
    showOnlyStruggling: 'Näytä vain ongelmalliset työt',
    runningLongerThanExpected: 'Käynnissä odotettua pidempään',
    notStartedForLongerThanExpected: 'Ei ole käynnistynyt odotetusti'
  },
  numberSeries: {
    numberSeries: 'Numerosarjat',
    comparisonError: 'Enimmäisarvon on oltava vähimmäisarvoa suurempi',
    successfullyAdded: 'Numerosarja lisättiin luetteloon',
    successfullyDeleted: 'Numerosarja poistettiin',
    addNewNumberSeries: 'Lisää uusi numerosarja',
    addedNumberSeries: 'Lisätyt numerosarjat',
    addedNumberSeriesSubHeading: 'Lisää numerosarja (älä sisällytä tarkistusnumeroita)',
    selectType: 'Valitse tyyppi',
    shipmentNumber: 'GSIN (lähetysnumero)',
    packageNumber: 'SSCC (pakettinumero)',
    minimum: 'Vähimmäisarvo',
    maximum: 'Enimmäisarvo',
    addNumberSeriesButton: 'Lisää numerosarja luetteloon',
    type: 'Tyyppi',
    currentNumber: 'Nykyinen numero',
    maxNumber: 'Enimmäisnumero',
    numbersLeft: 'Jäljellä olevat numerot',
    validMinimumValue: 'Syötä kelvollinen vähimmäisarvo',
    validMaximumValue: 'Syötä kelvollinen enimmäisarvo',
    deleteModalTitle: 'Poista numerosarja',
    deleteModalDescription: 'Tätä toimintoa ei voida peruuttaa'
  },
  preadvice: {
    preadvice: 'Ennakkoilmoitus',
    searchPlaceholder: 'Kirjoita vähintään 3 merkkiä suodatusta varten',
    selectedCustomers: 'Valitut asiakkaat ({{count}})',
    noSelectedCustomers: 'Ei valittuja asiakkaita',
    customerSearch: 'Hakukenttä - Kirjoita vähintään 3 merkkiä etsiäksesi asiakkaita',
    settingTargetDepartment:
      'Tämä ennakkoilmoitusasetus kohdistuu tiettyihin osastoihin. Poista kaikki valitut osastot voidaksesi vaihtaa asetuksen osastoryhmiin',
    settingTargetDepartmentGroups:
      'Tämä ennakkoilmoitusasetus kohdistuu tiettyihin osastoryhmiin. Poista kaikki valitut osastoryhmät voidaksesi vaihtaa asetuksen osastoihin',
    settingTargetCustomers:
      'Tämä preavisoimissääntö kohdistuu tiettyyn asiakkaaseen. Poista kaikki valitut asiakkaat voidaksesi vaihtaa asetuksen asiakasryhmiin',
    settingTargetCustomerGroups:
      'Tämä ennakkoilmoitusasetus kohdistuu tiettyihin asiakasryhmiin. Poista kaikki valitut asiakasryhmät voidaksesi vaihtaa asetuksen asiakkaisiin',
    conflictHeading: 'Ennakkoilmoitussäännöissäsi on ristiriitoja',
    conflictingRules: 'Ristiriitaiset säännöt',
    deletePreadviceDescription:
      'Poistaminen poistaa kaikki ilmoitusasetukset, eikä vastaanottaja tai lähettäjä saa enää mitään viestejä. Tätä toimintoa ei voi kumota.',
    rule: 'Sääntö',
    ruleTrigger: 'Ennakkoilmoituksen laukaisija',
    type: 'Tyyppi',
    trigger: 'Laukaisija',
    action: 'Vaihtoehto',
    result: {
      NO_RULE: 'Ei vastaavaa sääntöä',
      NO_DELIVERY_TIME_WINDOW: 'Toimituksen aikaikkunaa ei löytynyt',
      SMS_SENT: 'Ennakkoilmoitussääntö tarkistettu. SMS lisätty jonoon',
      EMAIL_SENT: 'Ennakkoilmoitussääntö tarkistettu. Sähköposti lisätty jonoon',
      SMS_AND_EMAIL_SENT: 'Ennakkoilmoitussääntö tarkistettu. SMS ja sähköposti lisätty jonoon',
      NO_VALID_PHONE_OR_EMAIL: 'Ei kelvollista puhelinnumeroa tai sähköpostiosoitetta',
      FEATURE_OFF: 'Ennakkoilmoitus on pois päältä',
      ALREADY_PRE_ADVICED: 'Toimituksen aikaikkuna on jo asetettu. Toimenpiteitä ei tehty',
      CANCELLED: 'Ennakkoilmoitus peruttu',
      WAITING_FOR_PACKAGES: 'Kaikki paketit eivät ole saapuneet terminaaliin',
      ALREADY_IN_PROGRESS: 'Odotetaan, että vastaanottaja valitsee toimitusajan',
      ERROR: 'Tapahtui virhe',
      WRONG_TRIGGER: 'Laukaisija ei vastaa sääntöä. Ohitetaan.',
      MANUAL_ATTEMPT: 'Ennakkoilmoitusyrityksiä lisätty manuaalisesti',
      PRE_ADVICE_LIMIT_REACHED: 'Ennakkoilmoitusten enimmäismäärä saavutettu',
      PRE_ADVICE_LOCKED: 'Ennakkoilmoitus on lukittu',
      ORDER_DELIVERED: 'Tilaus on jo toimitettu',
      RETURN_LAST_LEG_CREATION_SKIPPED: 'Palautusosuutta ei luotu'
    },
    error: {
      PRE_ADVICE_RULE_COLLISIONS: {
        label: 'Sääntöristiriita!',
        detail:
          'Palvelun {{service}} sääntö ohittaa säännön kohteessa {{policySetNames}} suhteen {{relations}} kautta.',
        department: 'osasto',
        department_group: 'osastoryhmä',
        customer: 'asiakas',
        customer_group: 'asiakasryhmä'
      }
    },
    customers: 'Asiakkaat',
    customerGroups: 'Asiakasryhmät',
    customersCount: 'Asiakkaat',
    customerGroupsCount: 'Asiakasryhmät',
    showGroupMembers: 'Näytä ryhmän jäsenet',
    departmentsCount: 'Osastot',
    departmentGroupsCount: 'Osastoryhmät',
    lockNotification: 'Lukitse ilmoitus',
    preadviceRule: 'Ennakkoilmoitussääntö',
    locked: 'Ennakkoilmoitus lukittu',
    nameOfRule: 'Säännön nimi',
    updated: 'Ennakkoilmoitus päivitetty',
    nameDescription: 'Nimi ja kuvaus',
    createNewPreadvice: 'Luo uusi preavisoimissääntö',
    bizArea: 'Valitse liiketoiminta-alue',
    courierAndExpress: 'Lähetti ja pikatoimitus (C&E)',
    homeDelivery: 'Kotiinkuljetus (HD)',
    filterDepartmentAndGroups: 'Suodata osastoilla tai osastoryhmillä',
    filterCustomersAndGroups: 'Suodata asiakkaille tai asiakasryhmille',
    tabsWithErrors: 'Korjaa seuraavien välilehtien ongelmat: {{tabs}}',
    hdDepartments: 'HD Departments',
    ceDepartments: 'C&E-osastot',
    departmentGroups: 'Osastoryhmät',
    noPoliciesFound: 'Ei ennakkoilmoitusasetuksia',
    policies: 'Ennakkoilmoitusasetukset',
    copyText: 'Kopioi teksti',
    customerInGroupTitle: 'Asiakkaat ryhmässä {{groupName}}',
    policy: {
      servicePoliciesDescription: 'Valitsemastasi ilmoitustyypistä riippuen näytetään eri syöttökentät',
      servicePolicy: {
        edit: 'Muokkaa asetuksia',
        new: 'Lisää palvelun ennakkoilmoitusasetukset',
        cutOff: 'Cutoff',
        remove: 'Poista valitut',
        serviceCode: 'Palvelu',
        serviceCodeLegend: 'Lisää palvelukoodi, esim. 3123',
        vasCode: 'VAS',
        vasCodeLegend: 'Lisää valinnainen lisäpalvelu, esim. SWAP',
        sameDay: 'SameDay',
        returnToCustomer: 'Palautus asiakkaalle',
        reminderToCustomer: 'Muistutus asiakkaalle',
        redirectToPuP: 'Ohjaa noutopisteeseen',
        sameDayTitle: 'Salli saman päivän varaukset ennen cutoff-aikaa',
        yesRecipientShouldChange: 'Kyllä, vastaanottajan pitää voida muuttaa',
        noRecipientShouldNotChange: 'Ei, vastaanottaja ei saa voida muuttaa',
        recipientCanCancelBookedTimeSlot: 'Vastaanottaja voi peruuttaa varatun aikaikkunan.',
        sameDayLegend: 'Valitse tämä ruutu, jos haluat lähetyksen toimitettavan Same Day -palveluna.',
        triggerEvent: 'Ennakkoilmoituksen laukaisija',
        triggerEventTitle: 'Ennakkoilmoituksen laukaisu',
        triggerEventLegend:
          'Mikä laukaisee ennakkoilmoituksen lähettämisen: kun saamme EDI:n Glowiin, kun paketit vastaanotetaan HUBissa tai DIPissä. Jos ennakkoilmoitusta ei pidä laukaista, valitse MANUAL.',
        cutoff: 'Cutoff',
        cutoffLegend:
          'Cutoff-aika, jonka jälkeen vastaanottajille ei enää tarjota kalenterin ensimmäistä vapaata aikaikkunaa, vaan seuraavaa päivää.',
        relativeCutoffMinutes: 'Cutoff-minuutit',
        relativeCutoffMinutesLegend:
          'Vähimmäismäärä minuutteja ennakkoilmoituksen ajankohdasta seuraavaan vapaaseen aikaikkunaan. Ohittaa cutoff-ajan.',
        calendarDays: 'Kalenteripäivät',
        goodsRedirectToPickupPoint: 'Lähetys ohjataan noutopisteeseen yhden toimitusyrityksen jälkeen',
        dateAndTimeChangeBookingPageTitle: 'Päivämäärän ja ajan muutokset varaussivulla.',
        calenderDaysTitle: 'Määritä, montako päivää vastaanottajalle näytetään varaussivulla',
        calendarDaysLegend: 'Montako päivää vastaanottajalle näytetään kalenterissa.',
        noServicePoliciesFound: 'Asetuksia ei ole vielä lisätty',
        returnToSenderAfterDays: 'Palautus lähettäjälle',
        returnToSenderAfterDaysLegend:
          'Montako päivän kuluttua lähetys palautetaan lähettäjälle, jos vastaanottajaa ei ole tavoitettu.',
        scheme: 'Tyyppi',
        schemeLegend: 'Lähetettävän ennakkoilmoituksen tyyppi: Push, Pull, Return tai Pick up parcel.',
        searchCustomer: 'Etsi asiakas',
        remindAfterHours: 'Muistutus vastaanottajalle',
        remindAfterHoursLegend:
          'Käytetään Pull- ja PUP-ennakkoilmoituksissa. Montako tunnin kuluttua vastaanottajalle lähetetään muistutus toimitusajan varaamisesta.',
        preAdviceAttempts: 'Ennakkoilmoitusyritykset',
        preAdviceAttemptsLegend: 'Montako muistutusta lähetetään ennen kuin lähetys palautetaan lähettäjälle.',
        reminderToSenderAfterHours: 'Muistutus lähettäjälle',
        reminderToSenderAfterHoursLegend:
          'Tämä on muistutus lähettäjälle siitä, ettemme ole tavoittaneet vastaanottajaa. Lähetys palautetaan.',
        deliveryAttempts: 'Toimitusyritykset',
        deliveryAttemptsTitle: 'Kun toimitusyritysten enimmäismäärä on saavutettu, paketti palautetaan asiakkaalle',
        deliveryAttemptsChoiceTitle: 'Mitä tapahtuu, kun toimitusyritysten enimmäismäärä on saavutettu',
        deliveryAttemptsLegend: 'Montako toimitusyritystä tehdään ennen kuin lähetys palautetaan lähettäjälle.',
        pickupAttempts: 'Noutoyritykset',
        pickupAttemptsTitle: 'Noutoyritysten enimmäismäärä',
        pickupAttemptsDescription:
          'Kun noutoyritysten enimmäismäärä on saavutettu, ilmoitamme asiakkaalle, ettei palautettavaa ole noutopoikkeaman vuoksi',
        label: {
          days: 'Päivät',
          hours: 'h',
          smss: 'kpl'
        },
        legend: {
          days: 'Päivät',
          hours: 'Tunnit',
          smss: 'SMS-viestien enimmäismäärä'
        },
        returnToPup: 'Palautus noutopisteeseen',
        addNewRule: 'Lisää uusi sääntö',
        enableCancelBookingTimes: 'Salli peruutus varaussivulla',
        typeOfOrders: 'Tilausten tyyppi',
        ordersWithDate: 'Tilaukset, joilla on päivämäärä',
        ordersWithoutDate: 'Tilaukset ilman päivämäärää',
        ordersWithAndWithoutDate: 'Tilaukset päivämäärällä ja ilman',
        emailToCustomer: 'Sähköposti asiakkaalle',
        triggerEventType: {
          EDI: 'EDI',
          HUB: 'HUB',
          DIP: 'DIP',
          MANUAL: 'MANUAL'
        }
      },
      exception: 'Poikkeus',
      deleteConfirm: 'Haluatko varmasti poistaa nämä ennakkoilmoitussäännöt?',
      name: 'Nimi',
      new: 'New preadvice policy',
      edit: 'Edit preadvice policy',
      description: 'Kuvaus',
      save: 'Tallenna',
      saveAnyway: 'Tallenna silti',
      servicePolicies: 'Ennakkoilmoitussäännöt',
      targets: 'Customer-/department connections'
    },
    tooltip: 'Tilauksen lukitseminen = vastaanottajalle ei lähetetä ilmoitusta',
    customerCode: 'Asiakaskoodi'
  },
  holidays: {
    holidays: 'Pyhäpäivät',
    holiday: 'Pyhäpäivä',
    dayBeforeHoliday: 'Pyhäpäivän aatto',
    addHoliday: 'Lisää uusi pyhäpäivä',
    country: 'Maa',
    type: 'Tyyppi',
    date: 'Päivämäärä',
    successfullyAdded: 'Pyhäpäivä lisättiin luetteloon',
    successfullyDeleted: 'Pyhäpäivä poistettiin',
    filterOnCountry: 'Suodata maan mukaan',
    selectHolidayType: 'Valitse pyhäpäivän tyyppi',
    addHolidayToList: 'Lisää pyhäpäivä luetteloon',
    selectCountry: 'Valitse maa',
    addedHolidays: 'Lisätyt pyhäpäivät',
    deleteModalTitle: 'Poista pyhäpäivä',
    deleteModalDescription: 'Tätä toimintoa ei voi perua'
  },
  distributionMapping: {
    title: 'Jakelukytkentä',
    addDips: 'Lisää DIP',
    addedDips: 'Lisätty DIP-sijainti ({{count}})',
    addedDips_other: 'Lisätyt DIP-sijainnit ({{count}})',
    connectedToPickupPoints: 'Kytketty {{count}} noutopisteeseen',
    connectedToPickupPoints_other: 'Kytketty {{count}} noutopisteeseen',
    emptyTitle: 'Ei kytkettyjä jakelupisteitä (DIP)',
    emptyDescription:
      'Sinun on ensin valittava DIP, jotta voit lisätä noutopisteitä.\nAloita napsauttamalla oikeassa yläkulmassa olevaa painiketta.',
    addDipModalTitle: 'Lisää jakelukytkentä',
    addDipModalDescription: 'Valitse DIP, johon haluat lisätä noutopisteitä',
    selectDipLabel: 'Hae jakelupistettä (DIP)',
    searchPlaceholder: 'PUP ID, nimi tai osoite',
    selectButton: 'Valitse',
    editDip: 'Muokkaa {{name}}',
    selectPickupPointHeading: 'Valitse noutopiste, jonka haluat lisätä DIP:iin',
    selectPickupPointLabel: 'Hae noutopistettä (PUP)',
    addedPickupPoints: 'DIP:iin lisätyt noutopisteet',
    removePickupPoint: 'Poista {{name}}',
    editPickupPoint: 'Muokkaa {{name}}',
    editPickupPointDescription: 'Valitse päivät, joina noutopiste voi vastaanottaa toimituksia',
    deliveryDays: 'Toimituspäivät',
    deliveryDaysHint: 'Valitse päivät, joina noutopisteet voivat vastaanottaa toimituksia',
    addPickupPoint: 'Lisää noutopiste',
    saveToast: 'Kohteen {{name}} jakelukytkentä tallennettiin',
    addLocations: 'Lisää sijainteja',
    removeDip: 'Poista {{name}}',
    removeDipQuestion: 'Poistetaanko {{name}} jakelukytkennöistä?',
    removeDipDescription: 'Siihen kytketyt noutopisteet menettävät DIP:insä.',
    removeConnectionQuestion: 'Poistetaanko kytkentä kohteeseen {{name}}?',
    removeConnectionDescription: 'Noutopisteellä ei ole DIP:iä, ennen kuin se kytketään uudelleen.',
    alreadyAdded: 'Tämä noutopiste on jo tässä DIP:issä. Uudelleen lisääminen korvaa sen toimituspäivät.',
    alreadyMappedToOtherDip:
      'Tämä noutopiste on jo kytketty kohteeseen {{dip}}. Poista se kyseisestä DIP:istä, ennen kuin lisäät sen tähän.',
    loadFailed: 'Jakelukytkentöjen haku ei onnistunut. Yritä uudelleen tai lataa sivu uudelleen.',
    errorSelectPickupPoint: 'Sinun on valittava noutopiste',
    errorSelectDeliveryDay: 'Sinun on valittava vähintään yksi toimituspäivä',
    errorSelectDip: 'Sinun on valittava DIP',
    deleteToast: '{{name}} poistettiin'
  },
  department: {
    region: 'Alue',
    general: 'Yleiset',
    plannedStopLocations: 'Suunnitellut pysähdyspaikat',
    plannedStopLocationsDescription:
      'Tässä voit lisätä kaikki suunnitellut pysähdyspaikat reittisuunnittelun optimointia varten.',
    plannedStopLocationName: 'Suunnitellun pysähdyspaikan nimi',
    plannedStopLocationIsTerminal: 'Lasketaan tämän osaston terminaaliosoitteeksi',
    plannedStopLocationIsTerminalTooltip:
      'Koskee vain osastoja, joilla on useampi kuin yksi terminaaliosoite. Tätä osoitetta käytetään osaston oletusosoitteen lisäksi.',
    addPlannedStopLocation: 'Lisää suunniteltu pysähdyspaikka',
    searchDepartmentByNameOrId: 'Suodata osaston nimen tai osaston ID:n perusteella',
    searchDepartmentGroups: 'Etsi ryhmän nimi tai kuvauksia',
    createNewDepartment: 'Luo uusi osasto',
    addressAndContact: 'Osoite ja yhteystiedot',
    searchAddressError: 'Puuttuvat arvot osoitteelle. Sinun täytyy käyttää hakukenttää saadaksesi oikean osoitteen.',
    addressContactIngress:
      'Saadaksesi oikean osoitteen, käytä hakukenttää. Osoite, postinumero ja kaupunki täytetään automaattisesti.',
    settingsInGlow: 'Asetukset vastaanottajan seurantatilalla',
    settingsBodyText: 'Valintasi mukaan erilaiset sisällöt ja viestintä näytetään/lähetetään vastaanottajille.',
    tooltipNPSID:
      'NPS ID = Glow voi lähettää NPS-kyselyjä vastaanottajatyytyväisyyden mittaamiseksi. Tähän täytetään kunkin osaston yksilöllinen tunniste',
    tooltipTerminal: 'Täytä nämä tiedot, jos nouto- ja osastonimi eroavat toisistaan',
    removeRow: 'Poista rivi',
    cutoff: 'Cutoff',
    regular: 'Tavallinen',
    sameDay: 'Sama päivä',
    weekdays: 'Arkipäivät',
    saturdays: 'Lauantait',
    sundays: 'Sunnuntait',
    setTimeWindow: 'Aseta aikaikkuna',
    setTimeWindowToDepartment: 'Aseta aikaikkuna osastolle',
    updateTimeWindow: 'Päivitä aikaikkuna',
    timeWindowTitle: 'Päivätoimitusten logiikka',
    timeWindowIngress:
      'Minä päivinä tämä osasto tekee toimituksia? Täytä jokaiselle päivälle joko kaikki arvot tai ei yhtään arvoa.',
    emailAddress: 'Sähköpostiosoite',
    npsId: 'NPS ID',
    defaultAlystraUnitId: 'Selfbilling unit ID',
    timeWindow: 'Aikaikkuna',
    pickupEarliest: 'Aikaisin nouto',
    pickupLatest: 'Myöhäisin nouto',
    deliveryEarliest: 'Aikaisin toimitus',
    deliveryLatest: 'Myöhäisin toimitus',
    routePlanning: 'Reittisuunnittelu',
    autoRouteCreationTime: 'Automaattinen reitin luominen',
    autoRouteOptimizationTime: 'Automaattinen reitin optimointi',
    clearTime: 'Poista aika',
    delegatedDepartment: 'Delegoitu osasto',
    disableSms: 'Poista seuranta- ja ETA-SMS käytöstä reitillä',
    smsShouldNotBeSent: 'Seuranta- ja ETA-SMS-viestejä ei lähetetä vastaanottajille tämän osaston reiteillä.',
    manageDepartment: 'Hallitse osasto',
    listAllDepartments: 'Näytä kaikki osastot',
    listAllGroups: 'Listaa kaikki osastoryhmät',
    successUpdate: '{{name}} päivitettiin onnistuneesti',
    editDepartment: 'Muokkaa: {{name}}',
    departmentTitle: 'Osasto',
    departmentsLabel: 'osastot',
    labels: 'Tunnisteet',
    labelsDescription:
      'Luo tunnisteita rakentaaksesi suodatussääntöjä tälle osastolle. Saman kategorian sisällä olevat tunnisteet yhdistetään <bold>OR</bold>-logiikalla, kun taas eri kategoriat yhdistetään <bold>AND</bold>-logiikalla. Muista määrittää tunnisteet reiteillesi, jotta suodatus tulee voimaan.\n' +
      '\n' +
      'Jos osastolle on luotu tunnisteita, käyttäjiltä kysytään, mitkä tunnisteet he haluavat näyttää, kun he avaavat <bold>Reittikatsaus</bold>-sivun ensimmäistä kertaa. He voivat muuttaa valintaansa milloin tahansa käyttämällä tavallista suodatinpaneelia <bold>Reittikatsaus</bold>-sivulla. Valinta tallennetaan selaimeen. Lue lisää täältä (tai “Mikä tämä on” -ikkunasta): <supportLink>Labels (Only for Parcel Norway departments) – GLOW Support</supportLink>',
    labelsCategory: 'Kategoria',
    labelsCategoryHint: 'Käytä olemassa olevaa kategorianimeä lisätäksesi lisää tunnisteita samaan ryhmään.',
    labelName: 'Tunnisteen nimi',
    existingLabels: 'Olemassa olevat tunnisteet',
    labelsEmpty: 'Tunnisteita ei ole vielä luotu.',
    labelsPreview: 'Esikatselu',
    labelsPreviewEmpty: 'Valitse tunnisteita nähdäksesi, miten suodatuslogiikka muodostuu.',
    labelsDuplicate: 'Tämä tunniste on jo valitussa kategoriassa.',
    labelsNotAdded: 'Lisää tunniste painamalla Lisää ennen tallentamista.',
    nameRequired: 'Nimi on pakollinen',
    addressRequired: 'Osoite on pakollinen',
    zipCodeRequired: 'Postinumero on pakollinen',
    zipAreaRequired: 'Alue on pakollinen',
    labelsCategoryRequired: 'Kategoria on pakollinen',
    labelNameRequired: 'Tunnisteen nimi on pakollinen',
    departmentTypeRequired: 'Osastotyyppi on pakollinen',
    departmentIdRequired: 'Osasto Id on pakollinen',
    descriptionRequired: 'Kuvaus on pakollinen',
    regionRequired: 'Alue on pakollinen',
    minutesAfterOrderArrivalRequired: 'Minuutit tilauksen vastaanoton jälkeen on pakollinen',
    createLabels: 'Luo tunnisteita',
    departmentWithCount: '{{count}} osasto',
    departmentWithCount_other: '{{count}} osastoa',
    departmentGroups: 'Osasto ryhmät',
    numberOfDepartmentGroups: 'Osasto ryhmä',
    numberOfDepartments: 'Määrä osastoa',
    search: 'Etsi osastoja',
    searchGroups: 'Etsi osastoryhmiä',
    noDepartmentsFound: 'Osastoja ei löytynyt',
    noDepartmentGroupsFound: 'Osastoryhmiä ei löytynyt',
    noDepartmentName: 'Nimi puuttuu',
    noDepartmentId: 'ID puuttuu',
    noCouriers: 'Ei lähettejä',
    courierCount_other: '{{count}} lähettiä',
    courierCount: '{{count}} lähetti',
    noCourier: 'Ei lähettejä',
    couriers: 'Lähettien lukumäärä',
    plannerCount_other: '{{count}} reitin suunnittelutyökalua',
    plannerCount: '{{count}} reitin suunnittelutyökalu',
    noPlanner: 'Ei reitin suunnittelutyökaluja',
    planners: 'Reitin suunnittelutyökalujen määrä',
    choose: 'Valitse osasto',
    new: 'Uusi osasto',
    description: 'Kuvaus',
    name: 'Nimi',
    created: 'Osasto luotu',
    updated: 'Osasto päivitetty',
    departmentType: 'Osastotyyppi',
    notSet: 'Ei valittu',
    courier: 'Lähetti',
    express: 'Pikatoimitus',
    hd: 'Kotitoimitus',
    h2: 'H2',
    parcel: 'Paketti',
    posten: 'Posten',
    other: 'Muu',
    all: 'Kaikki',
    deliveryDisplayType: 'Toimitusajan näyttö',
    terminalName: 'Terminaalin nimi',
    terminalNameTooltip: 'Jos nouto ja osaston nimi eroavat toisistaan, täytä nämä tiedot',
    selectArea: 'Valitse alue...',
    address: 'Osoite',
    zipCode: 'Posti nro',
    zipArea: 'Alue',
    autoRecurrentTime: 'Automaattinen toistuva aika',
    orderBillingType: {
      title: 'Tilauksen laskutustyyppi',
      selectBillingType: 'Valitse Laskutustyyppi',
      apollo: 'Apollo',
      h2: 'H2',
      pickup: 'Nouto',
      customerBillingNumber: 'Asiakkaan laskutusnumero',
      addMoreOrderBillingInfo: 'Lisää uusi tilauksen laskutustyyppi',
      internalTrade: 'Sisäinen kauppa'
    },
    departmentId: 'Osasto Id',
    autoInvoiceTitle: 'Automaattinen laskutus',
    autoInvoiceEnable: 'Aseta automaattinen laskutus',
    autoInvoiceTime: 'Aika',
    autoInvoiceOffset: {
      legend: 'Mitkä tilaukset tulee laskuttaa',
      oneDayEarlier: 'Toimitettu 1 päivää sitten',
      twoDaysEarlier: 'Toimitettu 2 päivää sitten',
      threeDaysEarlier: 'Toimitettu 3 päivää sitten',
      fourDaysEarlier: 'Toimitettu 4 päivää sitten',
      fiveDaysEarlier: 'Toimitettu 5 päivää sitten'
    },
    autoDispatchSettings: {
      title: 'Noutotilausten automaattinen osoitus',
      enable: 'Aseta noutotilausten automaattinen osoitus',
      minutesAfterOrderArrival: 'Minuuttia tilauksen vastaanoton jälkeen',
      startTime: 'Aloitusaika'
    },
    unitNumber: 'Yksikkönumero'
  },
  departmentGroup: {
    departmentGroupDeleted: '{{name}} poistettiin',
    selectedCountries: '{{count}} valittu maa',
    selectedCountries_other: '{{count}} valittua maata',
    countries: 'Maat',
    allDepartmentTypes: 'Kaikki osastotyypit',
    selectedDepartmentTypes: '{{count}} valittu osastotyyppi',
    selectedDepartmentTypes_other: '{{count}} valittua osastotyyppiä',
    departmentTypes: 'Osastotyypit',
    youMustSelectDepartment: 'Valitse osasto',
    manageDepartments: 'Hallitse osastoja ryhmässä',
    createDepartmentGroup: 'Luo uusi osastoryhmä',
    noSelectedDepartments: 'Ei valittuja osastoja',
    selectedDepartments: 'Valitut osastot ({{count}})',
    selectAllFor: 'Valitse kaikki {{name}}',
    departmentGroup: 'Osasto ryhmä',
    name: 'Nimi',
    deleteConfirm: 'Oletko varma että haluat poistaa osaston tämän ryhmän?',
    edit: 'Muokkaa osasto ryhmä',
    type: 'Tyyppi',
    types: {
      DEFAULT: 'Standardi',
      FOLLOW_UP: 'Seuranta',
      INVOICING: 'Laskutus',
      PLANNING: 'Suunnittelu',
      PREADVICE: 'Ennakkoilmoitus',
      REGION: 'Alue',
      SEARCH: 'Haku'
    }
  },
  deliveryDisplayType: { instant: 'Kuriiri', customized: 'Räätälöity' },
  templateRouteRules: {
    title: 'Reittisääntöjen hallinta',
    ruleName: 'Säännön nimi',
    type: 'Tyyppi',
    POSTAL_CODE: 'Postinumero',
    searchPlaceholder: 'Hae nimen tai tyypin mukaan',
    createNew: 'Luo uusi sääntö',
    createNewRule: 'Luo uusi reittisääntö',
    edit: 'Muokkaa',
    settings: 'Asetukset',
    assignToTemplateRoutes: 'Mallireitit',
    connectedToRule: 'liitetty sääntöön "{{name}}"',
    noTemplateRoutesInDepartment: 'Tällä osastolla ei ole käytettävissä mallireittejä',
    templateHasNoRoutes: 'Valitulla mallilla ei ole reittejä',
    noRecurringRoutesInDepartment: 'Tällä osastolla ei ole käytettävissä toistuvia reittejä',
    template: 'Mallipohja',
    selectTemplate: 'Valitse mallipohja',
    templateRoute: 'Mallireitti',
    selectTemplateRoutes: 'Valitse mallireitit',
    assignedTemplateRoutes: 'Määritetyt mallireitit ({{count}})',
    noAssignedTemplateRoutes: 'Mallireittejä ei ole vielä määritetty',
    assignToRecurringRoutes: 'Toistuvat reitit',
    recurringRoute: 'Toistuva reitti',
    selectRecurringRoutes: 'Valitse toistuvat reitit',
    assignedRecurringRoutes: 'Määritetyt toistuvat reitit ({{count}})',
    noAssignedRecurringRoutes: 'Toistuvia reittejä ei ole vielä määritetty',
    atLeastOneRule: 'Lisää vähintään yksi postinumerosääntö',
    successfullyAdded: '{{name}} lisättiin onnistuneesti',
    successfullyUpdated: '{{name}} päivitettiin onnistuneesti',
    successfullyDeleted: 'Reittisääntö poistettiin onnistuneesti',
    deleteRule: 'Poista reittisääntö',
    deleteRuleDescription: 'Haluatko varmasti poistaa tämän reittisäännön?',
    serviceExclusion: 'Palvelujen poissulkeminen',
    serviceExclusionDescription:
      'Tilauksia, joilla on jokin näistä palvelukoodeista, ei koskaan liitetä reitteihin tällä säännöllä.',
    serviceCode: 'Palvelukoodi',
    addServiceCode: 'Lisää palvelukoodi',
    excludedServices: 'Poissuljetut palvelut',
    noExcludedServices: 'Ei poissuljettuja palveluja',
    serviceCodeRequired: 'Syötä palvelukoodi',
    serviceCodeAlreadyExcluded: '{{code}} on jo poissuljettu',
    removeServiceCode: 'Poista {{code}}'
  },
  menu: {
    distributionMapping: 'DIP-kytkentä',
    manageRouteRules: 'Reittisääntöjen hallinta',
    defaultDisabled: 'Valitse yksi asiakastunnus nähdäksesi valikon',
    home: 'Alkuun',
    admin: 'Hallinto',
    planner: 'Reitin suunnittelutyökalu',
    volumeReport: 'Volyymiraportit',
    openSearch: 'Avaa haku',
    report: 'Raportit',
    customer: 'Asiakas',
    apiOrder: 'Etsi API-tilaus',
    support: 'Tuki',
    priceMotor: 'Hinnoittelutyökalu',
    departments: 'Osastot',
    users: 'Käyttäjät',
    customers: 'Asiakas',
    customerGroups: 'Asiakasryhmiä',
    numberSeries: 'Numerosarjat',
    jobsMonitoring: 'Työpaikkojen seuranta',
    holidays: 'Lomat',
    shd: 'SHD',
    settings: 'Asetukset',
    preadvice: 'Ennakkoilmoitus',
    cms: 'CMS',
    userRoles: 'Käyttäjäroolit',
    integrations: 'Integraatiot',
    live: 'Live',
    routePlanning: 'Reitin suunnittelu',
    dispatching: 'Ajojärjestely',
    booking: 'Tilaus',
    h2Booking: 'H2 Tilaus',
    setCoordinates: 'Aseta koordinaatit',
    pickupOrders: 'Noutotilaukset',
    billingOrder: 'Laskutustilaus',
    shipments: 'Haku',
    corrections: 'Muutokset',
    units: 'Yksiköt',
    couriers: 'Lähetit',
    vehicles: 'Ajoneuvot',
    recurring: 'Vakiot',
    importExport: 'Tuonti / vienti',
    addresses: 'Osoitteet',
    invoicing: 'Laskutus',
    manageReturns: 'Hallinnoi palautuksia',
    preAdviceFollowup: 'Hallitse ennakkoilmoitusta',
    optimizing: 'Optimointi',
    services: 'Palvelut',
    matrix: 'Matriisi',
    vendors: 'Toimittajat',
    productionTimeWindow: 'Tuotannon aikaikkuna',
    backToOldShipmentsPage: 'Takaisin vanhalle sivustolle.',
    mainNavigation: 'Päävalikko',
    closePanel: 'Sulje paneeli',
    expandPanel: 'Laajenna paneeli',
    goToHomepage: 'Siirry etusivulle',
    routesOverview: 'Reittikatsaus'
  },
  planner: {
    colorPicker: 'Värinvalitsin',
    canLogIn: 'Voi kirjautua sisään',
    chooseYourDepartment: 'Valitse osastosi',
    unassignedShipments: 'Varaamattomat lähetykset',
    filterCustomers: 'Suodata asiakkaita',
    filterServices: 'Suodata palvelut',
    autoRoute: 'Automaattireitti',
    saved: 'Tallennettu',
    allUserRoles: 'Kaikki käyttäjäroolit',
    userRolesCount_other: '{{count}} käyttäjäroolia',
    createNewUser: 'Luo uusi käyttäjä',
    userRolesCount: '{{count}} käyttäjärooli',
    role: 'Rooli',
    searchForNameOrNumber: 'Hae nimeä tai puhelinnumeroa',
    noPlannersFound: 'Suunnittelijoita ei löytynyt',
    typeOfRole: 'Käyttäjäroolin tyyppi',
    selectUserRole: 'Valitse käyttäjärooli',
    secondTab: 'Toinen välilehti',
    users: 'Käyttäjät',
    connectDepartment: 'Yhdistä osasto käyttäjään',
    autoRouteModal: {
      selectRoutes: 'Valitse reitit',
      selectRoutesText:
        'Valitse reitit, jotka sisällytetään automaattiseen reititykseen. Vain reitit, joiden tila on Luotu tai Annettu toimitettavaksi, ovat käytettävissä. Käynnissä oleville reiteille käytä toimintoa Lisää reittiin lähetysten dispatchaamiseen.',
      routesStartedRemoved: '{{routes}} on käynnistynyt ja poistettiin valinnasta',
      routesStartedRemoved_other: '{{routes}} ovat käynnistyneet ja poistettiin valinnasta',
      lockAllToSlot: 'Lukitse kaikki osoitetut lähetykset reitille',
      useMapAreaRestrictions: 'Käytä kartta-aluerajoituksia',
      usePostalCodeRestrictions: 'Käytä postinumerorajoituksia',
      useGraphHopper: 'Käytä GraphHopperia',
      usePtv: 'Käytä PTV:tä',
      usePtvPilot: 'Premium-optimointi',
      useKardinal: 'Käytä Kardinalia',
      useHere: 'Käytä HERE:ä',
      useHexaly: 'Käytä Hexalya',
      useHexalyCloud: 'Käytä Hexaly Cloudia',
      timeLimitInSeconds: 'Aikaraja sekunteina',
      timeLimitByStops: 'Tyhjä: suunnitelman koon mukaan',
      timeLimitAsMinutes: '= {{minutes}} min {{seconds}} s',
      timeLimitOutOfRange: 'Anna kokonaiset sekunnit väliltä 10-2700 (45 minuuttia)',
      timeLimitExample: 'esim. 60',
      useNoEngine: 'Älä käytä optimointimoottoria tällä reitillä',
      optimizeOn: 'Optimoi seuraavan perusteella',
      noRelevantRoutes: 'Sopivia reittejä ei löytynyt',
      startAutomaticRouting: 'Aloita automaattinen reititys',
      selectOptimizingEngine: 'Valitse optimointimoottori',
      useFlexAndForceFromPrevious: 'Käytä aiempien optimointien joustoja ja pakotettua järjestystä'
    },
    wait: 'Odotus',
    trips: 'Matkat',
    searchSlotCourierName: 'Hae toimitusajankohdan/lähetin nimeä',
    banner: {
      tryNewRoutePlanner:
        '1. toukokuuta, <0>reitinsuunnittelija 2.0</0> on ainoa saatavilla oleva reitinsuunnittelija. Jos et ole käyttänyt reitinsuunnittelijaa aiemmin, kannustamme sinua aloittamaan sen käytön nyt. <1>Lue lisää Zendeskistä</1> ja muista asiaan liittyvistä artikkeleista saadaksesi yleiskuvan siitä, miten se toimii.'
    },
    createdBy: 'Luonut',
    totalTitle: 'Paketit',
    pickList: 'Valintalista',
    export: 'Siirto laskutukseen',
    deleteSlot: 'Poista',
    editSlot: 'Muokkaa',
    deleteSlotConfirmDialogText: 'Oletko varma, että haluat poistaa tämän toimitusajankohdan?',
    deleteFilteredSlots: 'Poista kaikki paikat',
    deleteAllSlotsConfirmDialogText: 'Haluatko varmasti poistaa kaikki paikat?',
    created: 'Reitin suunnittelutyökalu luotu',
    updated: 'Reitin suunnittelutyökalu päivitetty',
    deleted: 'Suunnittelija on poistettu',
    confirmDelete: 'Haluatko varmasti poistaa tämän käyttäjän?',
    live: 'Live',
    removeDepartment: 'Poista osasto {{name}}',
    youMustProvideName: 'Sinun on annettava käyttäjän nimi',
    youMustProvidePhonenumber: 'Sinun on annettava puhelinnumero',
    showInGoogleMaps: 'Näytä reitti Google Mapsissa',
    detailedAccessRights: 'Yksityiskohtaiset käyttöoikeudet: {{name}}',
    routePlanning: 'Reitin suunnittelu',
    vehicles: 'Ajoneuvot',
    routePlanningConsignmentsAssigned: 'annettu toimitettavaksi',
    routePlanningRangeDescription: 'Suodata lähetyksiä toimitusajan perusteella',
    unresolvedConsignments: 'Epäselvät',
    consignments: 'Haku',
    couriers: 'Lähetit',
    units: 'Yksiköt',
    invoicing: 'Laskutus',
    planner: 'Reitin suunnittelutyökalu',
    planners: 'Reitin suunnittelutyökalut',
    noPlanners: 'Ei reitin suunnittelutyökaluja',
    missingId: 'ID puuttuu',
    missingName: 'Nimi puuttuu',
    search: 'Etsi',
    searchForPlanner: 'Etsi reitin suunnittelutyökaluja',
    name: 'Nimi',
    phoneNumber: 'Puhelinnumero',
    selectDepartments: 'Valitse osastot',
    createSlot: 'Luo',
    editSlotForm: 'Muokkaa toimitusajankohtaa',
    routeUpdated: 'Toimitusajankohdan tiedot päivitetty',
    createSlotFormName: 'Toimitusajankohdan nimi',
    createSlotFormUnit: 'Yksikkö',
    createSlotFormCourier: 'Lähetti',
    createSlotFormSlotMode: 'Toimitusajankohdan tila',
    createSlotFormSlotModePickup: 'Piirrä noutoalue kartalle',
    createSlotFormSlotModeDelivery: 'Piirrä toimitusalue kartalle',
    createSlotFormSlotModeManual: 'Valitse lähetykset manuaalisesti',
    createSlotFormSlotModeSelected: 'Valitut lähetykset',
    createSlotFormTimeRange: 'Aikaväli',
    createSlotFormStartLocation: 'Aloituspaikka',
    createSlotFormEndTime: 'Päättymisaika',
    createSlotFormEndLocation: 'Lopetuspaikka',
    createSlotFormSlotColor: 'Toimitusajankohdan väri',
    createSlotFormTimeRangeTooBig: 'Aikaväli on liian suuri. Enimmäisaika on {{hours}} tuntia.',
    createSlotFormFilterCustomers: 'Suodata asiakkaita',
    createSlotFormFilterServices: 'Suodata palveluita (jos yhtään ei rastita, kaikki on valittu)',
    slotFilterInfo:
      'Tämä toimitusajankohta on suodatettu, mikä tarkoittaa, että vain valitulle/-tuille asiakkaalle/-kaille kuuluvat lähetykset ja valittu/-tut palvelu/-t voidaan yhdistää toimitusaikaan.',
    slotFilteredCustomer: 'Toimitusajankohtaan sisältyy VAIN seuraavien asiakkaiden tilaukset',
    slotFilteredService: 'Toimitusajankohtaan sisältyy VAIN seuraavia palveluita sisältävät tilaukset',
    onlyShowApplicable:
      'Näytä vain sellaiset tilaukset, jotka sopivat tähän toimitusajankohtaan asiakkaan/palveluiden suodatuksen perusteella',
    optimizeButtonLabel: 'Optimoi ja määrittele reitit',
    optimizeSlotButtonLabel: 'Optimoi toimitusajankohta uudelleen',
    reversedOptimizeSlotButtonLabel: 'Käänteinen toimitusjärjestys',
    optimizingSince: 'Optimointi käynnissä, alkanut klo {{startTime}}',
    addToRoute: 'Lisää reittiin...',
    pickup: 'Nouto',
    delivery: 'Toimitus',
    depot_call: 'Suunniteltu pysähdys',
    slot: 'Toimitusajankohta',
    notAssigned: 'Ei annettu toimitettavaksi',
    readOnly: 'Vain luku -oikeus',
    normal: 'Normaali',
    plus: 'Lisäoikeudet',
    partner: 'Kumppani',
    readOnlyAccessPlannersWithCount: '{{count}} suunnittelijat (lukuoikeudet)',
    plusPlannersWithCount: '{{count}} plus suunnittelijat (admin)',
    normalPlannersWithCount: '{{count}} suunnittelijat (perusoikeudet)',
    saveTemplate: 'Tallenna sivupohjana',
    loadTemplate: 'Lataa sivupohjasta',
    routeListForFilteredSlots: 'Kuittauslista (tulosta kaikki)',
    loadListForFilteredSlots: 'Lastauslista (tulosta kaikki)',
    sendPrePickupSmsesToAll: 'Ennen lähetyksen seurantatekstiviesti',
    alertBeforeSendingPrePickupSms:
      'Haluatko varmasti lähettää seurantatekstiviestin kaikille tämän päivän lähtö- ja saapumisaikoille?',
    newTemplate: 'Luo uusi sivupohja',
    selectTemplate: 'Valitse sivupohja',
    deleteTemplate: 'Poista',
    templateDeleteConfirm: 'Oletko varma, että haluat poistaa tämän sivupohjan?',
    missingDeliveryMarker: 'Toimitusosoite tai sijainti ei kelpaa',
    missingPickupMarker: 'Nouto-osoite tai sijainti ei kelpaa',
    assignConsignmentFromSlot: 'Määritä lähetys reitille {{routeName}}?',
    unassignConsignmentFromSlot: 'Poista {{count}} lähetys reitiltä?',
    unassignConsignmentFromSlot_other: 'Poista {{count}} lähetystä reitiltä?',
    unassignBulkConsignmentsFromSlotsAlert: 'Poista lähetykset niille merkatulta reitistä?',
    unassignedFromSlot: 'Lähetys on nyt poistettu reitiltä',
    unassignBulkConsignmentsFromSlots: 'Lähetykset on nyt poistettu niille merkatulta reitiltä',
    unassignButton: 'Poista toimitusajankohdasta',
    forceUnassignButton: 'Pakota poisto reitiltä',
    driverName: 'Lähetit',
    deliveries: 'Toimitukset',
    returns: 'Palautukset',
    installations: 'Asennukset',
    curbside: 'Curbside',
    label: 'Etiketti',
    filters: {
      assigned: 'Annettu toimitettavaksi',
      unassigned: 'Ei  annettu toimitettavaksi',
      pickups: 'Noudot',
      deliveries: 'Toimitukset'
    },
    saveSelected: 'Tallenna valitut ({{count}})',
    showSaved: 'Näytä tallennetut ({{count}})',
    showAll: 'Näytä kaikki',
    clearSaved: 'Tyhjennä tallennetut',
    sendPrePickupSms: 'Ennakko lähetä seuranta SMS vastaanottajalle',
    sendSms: 'Lähetä tekstiviesti',
    sendingSmsText: 'Lähetetään {{count}} seuranta SMS',
    prePickupSmsSent: '{{sentCount}} / {{totalCount}} ennakkoviestiä lähetetty',
    manualDelaySms: {
      smsSent: '{{count}} manuaalista viivästys-SMS:ää lähetetty',
      heading: 'Manuaalinen viivästys-SMS',
      sendingSmsText: 'Lähetetään {{count}} manuaalista viivästys-SMS:ää',
      selectSmsDescription:
        'SMS alkaa tekstillä "Hei! Toimituksesi lähettäjältä on valitettavasti viivästynyt.". Valitse SMS:n loppuosa alta.',
      disabledTooltip: 'Tilaukset eivät voi olla tilassa Toimitettu',
      selectSmsEnding: 'Valitse, miten tekstiviestin tulee päättyä',
      selectSmsBeginning: 'Valitse, miten tekstiviestin tulee alkaa',
      previewLabel: 'Tekstiviestin esikatselu',
      buttonTitle: 'Lähetä',
      beginningType: {
        hi: 'Hei!',
        none: 'Ei mitään',
        fromSender: 'Toimituksesi lähettäjältä on valitettavasti myöhässä.',
        highDemand: 'Suuren kysynnän vuoksi toimituksesi on valitettavasti myöhässä.'
      },
      endingType: {
        none: 'Ei mitään',
        soon: 'Uusi toimituspäivä ja kellonaika ilmoitetaan pian.',
        tomorrow: 'Uusi toimituspäivä ja kellonaika ilmoitetaan huomenna.',
        whenShipmentHasArrived: 'Uusi toimituspäivä ja kellonaika ilmoitetaan, kun lähetys saapuu terminaaliin.',
        newDeliveryTime: 'Toimitamme tämän sinulle seuraavana mahdollisena toimituspäivänä.',
        newDeliveryTimeFullEnding:
          'Uusi toimitus on aikataulutettu päivälle [DATE] [TIMESLOT]. Voit muuttaa toimitusaikaa osoitteessa [TRACKINGLINK]. Terveisin, Bring'
      }
    },
    delayedShipmentNotification: {
      description:
        'Vastaanottaja saa tekstiviestin, että lähetys on viivästynyt ja että uusi toimituspäivä ja kellonaika lähetetään, kun lähetys saapuu terminaaliin.',
      resetDescription:
        'Kun vahvistat, valitut lähetykset nollataan ja poistetaan reitiltä, jos ne on osoitettu reitille.',
      gScanDescription:
        'Kun terminaaliin saapuminen on rekisteröity, vastaanottajalle ilmoitetaan uudelleen preadvice-sääntöjen mukaisesti.',
      successMessage: 'Viivästyneen lähetyksen työnkulku käynnistettiin'
    },
    rescheduledShipmentNotification: {
      description: 'Toimitus siirretään uudelle päivämäärälle ja kellonajalle.',
      autoUpdateDescription:
        'Vastaanottaja saa tekstiviestin, jossa kerrotaan, että toimitus ei saavu tänään suunnitellun mukaisesti. Viesti sisältää myös uuden päivämäärän ja kellonajan sekä linkin, josta he voivat muuttaa toimitusta tarvittaessa.'
    },
    h2: { booking: 'H2 Tilaus', vasHelperText: 'Käytä VAS 1158 kun MBH' },
    loadList: {
      address: 'Osoite',
      customerRef: 'Asiakkaan viite',
      date: 'Päivämäärä',
      deliveries: 'Toimitukset',
      distance: 'Välimatka',
      estimatedLoadTime: 'ALA',
      estimatedTotalTime: 'Arv. aika',
      header: 'Reitti yhteenveto',
      instructions: 'Toimitusohjeet,\npuhelin,\nvastaanottajan viite',
      instructionsPhone: 'Puh:',
      instructionsRef: 'Vastaanottajan viite:',
      listName: 'Lastauslista',
      name: 'Nimi',
      qty: 'Kpl',
      routeName: 'Reitti',
      service: 'Palvelu\n(VAS)',
      stopOrder: 'Pys. nro',
      summary: 'Yhteenveto',
      time: 'Aika',
      timeWindow: 'Aikaikkuna (ETA-ETD)',
      tripNumber: 'Matka',
      totalDistance: 'Kokonaismatka',
      totalTime: 'Kokonaisaika',
      unit: 'Yksikkö',
      volume: 'Til.\nm³',
      weight: 'Paino\nkg',
      zipArea: 'Alue',
      zipCode: 'Postinumero',
      unknownRouteName: 'Tuntematon reitin nimi',
      unknownUnitName: 'Tuntematon kuljettajan nimi',
      noDataText: 'Täällä ei ole mitään nähtävää',
      utilization: 'Käyttöaste'
    },
    locationList: { listName: 'Sijaintiluettelo' },
    assignedUnits: 'Määrätyt yksiköt',
    unassignedUnits: 'Määrittämättömät yksiköt',
    noUnitSelected: 'Yksikköä ei ole valittu',
    unitAssignmentCount: 'Yksikkö määrätty {{count}} reitille',
    breakDeletedFromRoute: 'Tauko poistettiin reitiltä',
    favouriteDepartments: 'Suosikit',
    addFavouriteDepartment: 'Lisää suosikki: {{department}}',
    removeFavouriteDepartment: 'Poista suosikki: {{department}}',
    largeDepartmentGuard: {
      validationMessage:
        'Valitussa osastoryhmässä {{departmentGroup}} on liian monta reittiä, eikä sitä voi käyttää sivulla {{page}}. Valitse toinen osastoryhmä tai osasto.'
    }
  },

  updateServiceLevel: {
    menuItem: 'Vaihda palvelutaso',
    selectOption: 'Valitse palvelutaso',
    heading: 'Vaihda palvelutaso',
    confirmation: 'Palvelutaso päivitetty',
    subtext: 'Vaihda palvelutaso {{count}} lähetykselle',
    subtext_other: 'Vaihda palvelutaso {{count}} lähetykselle',
    failed: {
      title: 'Palvelutason vaihto epäonnistui',
      message: 'Palvelutason vaihto epäonnistui {{count}} lähetykselle',
      message_other: 'Palvelutason vaihto epäonnistui {{count}} lähetykselle'
    }
  },
  manualPreAdvice: {
    menuItem: 'Manuaalinen ennakkoilmoitus',
    selectOption: 'Valitse ennakkoilmoituksen tyyppi',
    heading: 'Manuaalinen ennakkoilmoitus',
    confirmation: 'Ennakkoilmoituspyyntö/-pyynnöt tallennettu',
    subtext: 'Change service level for {{count}} shipment',
    subtext_other: 'Change service level for {{count}} shipments',
    failed: {
      title: 'Ennakkoilmoituspyyntöjen tallennus epäonnistui',
      message: 'Ennakkoilmoituksen pyytäminen epäonnistui {{count}} lähetykselle',
      message_other: 'Ennakkoilmoituksen pyytäminen epäonnistui {{count}} lähetykselle'
    }
  },
  setPickupDeliveryDuration: {
    menuItem: 'Aseta noudon/toimituksen ajat',
    heading: 'Aseta noudon ja toimituksen ajat',
    subtext: 'Aseta noudon ja toimituksen ajat {{count}} lähetykselle',
    subtext_other: 'Aseta noudon ja toimituksen ajat {{count}} lähetykselle',
    pickupPreparation: 'Noudon valmistelu',
    pickupDuration: 'Nouto aika',
    deliveryPreparation: 'Toimituksen valmistelu',
    deliveryDuration: 'Vienti aika',
    confirmation: 'Noudon ja toimituksen ajat päivitetty',
    validationError: 'Virheellinen aika. Suurin sallittu määrä minuutteja ja sekunteja on 59',
    description:
      'Anna valittujen tilausten noudon ja toimituksen valmistelu ja kesto. Suurin sallittu minuuttien ja sekuntien määrä on 59.'
  },
  importExportOrders: {
    importOrdersHeading: 'Tuo tilaus',
    importStatus: 'Tällä hetkellä jonossa on {{imports}} tuontia, yhteensä {{orders}} tilausta',
    exportForInvoice: 'Export for Invoicing',
    fileTemplateLink: 'Lataa Excel-malli',
    uploadFile: 'Tuo tilaus',
    uploadingMessage: 'Ladataan tiedostoa ja tuodaan tilauksia...',
    testDataWarning: 'Älä käytä henkilökohtaisia ​​tietoja testiympäristössä',
    testDataInfo:
      'Tämä on qa / testiympäristö, etkä saa käyttää tuotantotietoja testeissä ilman asianomaisten käyttäjien nimenomaista suostumusta',
    fromDate: 'Päivämäärästä',
    toDate: 'Päivämäärään',
    fromDateNotAfterToDate: 'Ei voi olla myöhäisempi kuin päivämäärää',
    toDateNotBeforeFromDate: 'Ei voi olla aikaisempi kuin päivämäärästä alkaen',
    removeControlColumns: 'Poista ohjaussarakkeet',
    importResults: 'Tuo tulokset',
    fileName: 'tuotu tiedosto',
    processedAt: 'Processed',
    createdShipmentId: 'Luotu toimitustunnus',
    date: 'Päivämäärä',
    exportShipments: 'vientialukset',
    createLabels: 'Luo tunnisteita',
    selectSlot: 'Valitse reitti',
    selectExportLabel: 'Valitse, mitä haluat viedä',
    allOrders: 'Kaikki tilaukset',
    deviatedOrders: 'Poikkeamatilaus',
    all: 'Kaikki',
    selectFile: 'Valitse tiedosto',
    exportFailed: 'Tietojen vienti epäonnistui',
    jobList: {
      title: 'Edellinen vienti',
      content: 'sisältö',
      created: 'Luotu',
      user: 'Käyttäjä',
      dates: 'Päivämäärä',
      download: 'Ladattu',
      exporting: 'Vietään...',
      downloading: 'Ladataan...',
      inQueue: 'Vientijonossa',
      exportFailed: 'Vienti epäonnistui',
      updated: 'Updated',
      previousImports: 'Aiemmat tuonnit',
      fileName: 'Tiedoston nimi',
      numberOfOrders: 'Tilausten määrä',
      imported: 'Tuotu',
      viewOrders: 'Näytä tilaukset',
      lastImports: 'Luetellaan viimeiset {{count}} tuontia'
    },
    exportStartedNotification: 'Vienti aloitettu',
    exportStartedNotificationMessage: 'Raporttisi on saatavilla heti, kun se on käsitelty.',
    exportFailedNotification: 'Vienti epäonnistui, yritä myöhemmin uudelleen',
    refreshData: 'Päivitä tiedot olemassa olevaan raporttiin',
    refreshDataDescription:
      'Valitse tämä vaihtoehto, jos olet jo luonut olemassa olevan raportin tietyille päivämäärille',
    types: {
      SHIPMENT_EXPORT: 'Toimitukset',
      COURIER_WORK_REPORT: 'Kuljettajan työraportti',
      COURIER_WORK_REPORT_EXTENDED: 'Laajennettu kuljettajan työraportti',
      END_OF_DAY_REPORT: 'Päivän loppuraportti',
      SOCIAL_CONTROL: 'Sosiaalinen valvonta',
      LOCATION_LIST: 'Sijaintiluettelo',
      ORDER_EXPORT: 'Tilauksen vienti',
      ORDER_DEVIATION_EXPORT: 'Tilaus (poikkeama)',
      ORDER_EXPORT_ANONYMOUS: 'Tilaus (anonyymit tiedot)',
      ORDER_PARTNER_EXPORT: 'Tilaus (kumppaneille)',
      DEVIATION_EVENTS: 'Poikkeamatapahtumat',
      OPTIMIZATION_RESULTS: 'Optimointitulokset',
      FINANCIAL_REPORT: 'Talousraportti'
    },
    exportTitles: {
      SHIPMENT_EXPORT: 'Vie lähetykset',
      COURIER_WORK_REPORT: 'Kuljettajan työraportti',
      COURIER_WORK_REPORT_EXTENDED: 'Laajennettu kuljettajan työraportti',
      END_OF_DAY_REPORT: 'Päivän loppuraportti',
      SOCIAL_CONTROL: 'Vie sosiaalinen hallinta',
      LOCATION_LIST: 'Vie sijaintiluettelo',
      ORDER_EXPORT: 'Vie tilaus',
      ORDER_DEVIATION_EXPORT: 'Vie tilaus poikkeamalla',
      ORDER_EXPORT_ANONYMOUS: 'Vie tilaus nimettömänä',
      ORDER_PARTNER_EXPORT: 'Vie kumppanitilaus',
      DEVIATION_EVENTS: 'Vie poikkeamatapahtumat',
      OPTIMIZATION_RESULTS: 'Vie optimointitulokset',
      FINANCIAL_REPORT: 'Vie talousraportti'
    },
    exportDescriptions: {
      SHIPMENT_EXPORT: '',
      COURIER_WORK_REPORT: '',
      COURIER_WORK_REPORT_EXTENDED: '',
      END_OF_DAY_REPORT:
        'Tämän raportin avulla näet päivittäiset reittitilastot, mukaan lukien toimintakulut ja tuotot.',
      SOCIAL_CONTROL: '',
      LOCATION_LIST: '',
      ORDER_EXPORT:
        'Jos haluat käyttää dataa testiympäristöissä, suosittelemme "Tilaa (anonymisoitu data)"-vaihtoehtoa',
      ORDER_DEVIATION_EXPORT:
        'Jos haluat käyttää dataa testiympäristöissä, suosittelemme "Tilaa (anonymisoitu data)" -vaihtoehtoa',
      ORDER_EXPORT_ANONYMOUS: 'Voidaan käyttää, jos tietoja tuodaan testiympäristöön',
      ORDER_PARTNER_EXPORT: 'Muokattu Excel-tiedosto, jota voidaan käyttää Opterin tuontiin',
      DEVIATION_EVENTS: '',
      OPTIMIZATION_RESULTS: '',
      FINANCIAL_REPORT: 'Sisältää lisäarkin, jossa tilaukset on eritelty veloitusrivein soveltuvin osin'
    }
  },
  unit: {
    new: 'Uusi unit',
    edit: 'Muokkaa unit',
    addCourier: 'Lisää lähetti',
    hideAddCourier: 'Piilota lisää lähetti',
    requiresCourierUsers: 'Pitäisi olla vähintään yksi kuriiri',
    created: 'Unit on luotu',
    updated: 'Unit on päivitetty',
    search: 'Etsi yksiköitä muilta osastoilta...',
    unitsInCurrentDepartment: 'Yksiköt nykyisessä osastossa',
    unitsInOtherDepartments: 'Muiden osastojen yksiköt',
    saveUnit: 'Tallenna yksikkö',
    addCourierToUnit: 'Lisää lähetti yksikköön',
    clearSearch: 'Tyhjennä haku',
    unitWithCount: '{{count}} yksikkö',
    unitWithCount_other: '{{count}} yksikköä',
    noCouriersFound: 'Lähettejä ei löytynyt',
    addCourierToUnitSearch: 'Voit etsiä lähettejä vain niistä osastoista, joihin sinulla on pääsy',
    addedCouriers: 'Lisätyt lähetit ({{count}})',
    newCourier: 'Luo uusi lähetti',
    name: 'Nimi',
    unitId: 'Yksikkö-ID',
    couriers: 'Lähetit',
    active: 'Aktiivinen',
    vehicle: 'Ajoneuvo',
    deleteQuestion: 'Poista yksikkö nykyisestä osastosta',
    deleteDescription: 'Yksikkö voidaan yhdistää uudelleen myöhemmin, jos se on edelleen yhteydessä muihin osastoihin',
    unassigned: 'Yksikkö poistettiin onnistuneesti osastosta',
    setDefaultVehicle: {
      add: 'Lisää ajoneuvo',
      change: 'Vaihda ajoneuvo',
      title: 'Lisää ajoneuvo yksikköön {{unit}}',
      selectVehicle: 'Valitse ajoneuvo',
      addSuccess: 'Ajoneuvo lisättiin onnistuneesti yksikköön {{unit}}',
      changeSuccess: 'Ajoneuvo vaihdettiin onnistuneesti yksikössä {{unit}}'
    }
  },
  courier: {
    isActive: 'On aktiivinen',
    canLogIn: 'Voi kirjautua sisään',
    secureLoginEnabled: 'Kirjautuminen pankkitunnuksilla',
    recipientName: 'Vastaanottajan nimi',
    created: 'Lähetti on luotu',
    updated: 'Lähetti on päivitetty',
    courier: 'Lähetti',
    couriers: 'Lähetit',
    noCouriers: 'Ei lähettejä',
    courierWithCount: '{{count}} lähetti',
    courierWithCount_other: '{{count}} lähettiä',
    numberOfCouriers: 'Löydetty {{number}} lähetit',
    multipleDrivers: 'Useampi kuljettaja',
    missingId: 'ID puuttuu',
    missingName: 'Nimi puuttuu',
    search: 'Etsi lähettejä',
    new: 'Uusi lähetti',
    edit: 'Muokkaa lähettiä {{name}}',
    name: 'Nimi',
    phoneNumber: 'Puhelinnumero',
    driverId: 'Kuljettajan ID',
    capacity: 'Kapasiteetti',
    capacityLabel: 'Kapasiteetti (määrä)',
    weightCapacity: 'Painokapasiteetti (kg)',
    volumeCapacity: 'Tilavuuskapasiteetti (m³)',
    maxRangeKm: 'Toimintasäde (km)',
    color: 'Väri',
    resetColor: 'nollaa väri',
    speedFactor: 'Nopeustekijä',
    speedFactorExplanation: 'alhainen = hitaampi',
    serviceTimeFactor: 'Palveluaikatekijä',
    serviceTimeFactorExplanation: 'alhainen = nopeampi',
    defaultStopLocation: 'Oletukseksi asetettu pysähdyspaikka',
    defaultStartLocation: 'Oletukseksi asetettu aloituspaikka',
    slotNumDeliveries: '{{count}} toimitus',
    slotNumDeliveries_other: '{{count}} toimitusta',
    slotNumPickups: '{{count}} nouto',
    slotNumPickups_other: '{{count}} noutoa',
    deliverPerformButtonLabel: 'Toimittaa',
    handoverPerformButtonLabel: 'Luovuttaa',
    deviationPerformButtonLabel: 'Poikkeama',
    deliverWithoutSignatureButtonLabel: 'Ilman allekirjoitusta',
    deliverWithSignatureButtonLabel: 'Allekirjoitus',
    deviateNotAtHomeButtonLabel: 'Ei kotona',
    deviateLocNotFoundButtonLabel: 'Sijaintia ei löytynyt',
    deviateRecipientDeclinedButtonLabel: 'Vastaanottaja ei halunnut sitä',
    deviateTimeWindow: 'Aika ei riittänyt toimittamaan pyydetyssä aikaikkunassa',
    addressNotFound: 'Osoitetta ei löytynyt',
    deliverySpotUnavailable: 'Sovittu toimitus paikka ei ole mahdollinen',
    deliveryAttemptNotPickedUp: 'Toimitusyritys - Ei noudettu',
    deviation: {
      'H-12': 'Lähetys yritettiin toimittaa, mutta vastaanottaja ei ollut paikalla',
      'H-11': 'Paketissa toimitusyritys, mutta osoitetta ei löytynyt',
      'H-10': 'Paketissa toimitusyritys, mutta vastaanottajaa ei tavoitettu osoitteesta',
      'H-13': 'Lähetys yritettiin toimittaa, mutta sen vastaanottamisesta kieltäydyttiin',
      '7-10': 'Tavaroita ei voitu noutaa puutteellisen osoitteen takia',
      '7-12': 'Lähettäjä ei ollut tavoitettavissä. Tavaroita ei ole noudettu',
      '7-82': 'Tavarat eivät olleet valmiit noudettavaksi',
      'OFU-10': 'Puutteellinen osoite',
      'OFU-12': 'Vastaanottaja ei tavoitettavissa',
      'OFU-82': 'Tavarat eivät ole valmiina noudettavaksi',
      'OFU-DI': 'Ei noudettavia tavaroita',
      'OFU-87': 'Ylivoimainen este',
      'OFU-OCB': 'Ajoneuvon rikkoutuminen',
      'OFU-OL2': 'Ei tarpeeksi tilaa ajoneuvossa',
      'OFU-OS1': 'Tavarat vaurioituneet ennen noutoa',
      'V-41-K': 'Lähetys on viivästynyt, mutta se toimitetaan eteenpäin mahdollisimman pian',
      'V-OL2': 'Ei tarpeeksi tilaa autossa',
      'V-OL4': 'Lähetystä ei löytynyt',
      'V-OL5': 'Suunniteltu myöhemmin samalle reitille',
      '9-91': 'Peruttu asiakkaan toimesta',
      'H-07-R': 'Epäilyttävä, tai päihtynyt vastaanottaja',
      'H-07-Z': 'Epäilyttävä, tai päihtynyt vastaanottaja',
      'H-08-Z': 'Alaikäinen henkilö',
      'H-09-Z': 'Henkilöllisyystodistus puuttuu',
      'VI-16-X': 'Aika ei riittänyt toimittamaan pyydetyssä aikaikkunassa',
      'H-11-Z': 'Osoitetta ei löytynyt',
      'H-BL-A': 'Sovittu toimitus paikka ei ole mahdollinen',
      'A-10': '$t(courier.deviation.7-10)',
      'A-12': '$t(courier.deviation.7-12)',
      'A-82': '$t(courier.deviation.7-82)',
      'V-100-CA': 'Ei saatavilla olevaa pakettiautomaattia. Paketti toimitetaan kotiinkuljetuksena',
      'V-100-CI': 'Ei vapaata lokeroa',
      'V-80-CI': 'Paketti ylittää sallitut mitat/painon',
      'V-99-CI': 'Muu tuntematon',
      'V-AO-CI': 'Automaatti on epäkunnossa',
      'H-49-Q': '$t(courier.deliveryAttemptNotPickedUp)',
      'V-X-Y': 'Tilaus noudettu toisella kuljettajalla'
    },
    completionProgressCounter: '{{numCompleted}}/{{numTotal}} valmiina',
    lockCode: 'Ovikoodi',
    flexDelivery: 'Yksinkertaistettu toimitus',
    fuelType: 'Polttoainetyyppi',
    fuelTypes: {
      diesel: 'Diesel',
      gasoline: 'Bensiini',
      natural_gas: 'Maakaasu',
      ethanol: 'Etanoli',
      bio_gas: 'Biokaasu',
      electric: 'Sähkö',
      bicycle: 'Polkupyörä',
      hydrogen: 'Vety',
      rme: 'RME',
      hvo: 'HVO'
    },
    fuelCategory: 'Polttoaineluokka',
    fuelCategories: {
      fossil: 'Fossiilinen polttoaine',
      fossil_free: 'Fossiilivapaa polttoaine',
      zero_emissions: 'Päästöt nolla'
    },
    latestLogin: 'Viimeisin kirjautuminen',
    latestVersion: 'Uusin versio',
    failedSocialControl: 'Epäilyttävä, tai päihtynyt vastaanottaja',
    failedIdControl: 'Henkilöllisyystodistus puuttuu',
    failedAgeControl: 'Alaikäinen henkilö',
    incompletePickupAddress: 'Puutteellinen nouto-osoite',
    custNotAvailableAtPickupAddress: 'Asiakas ei ollut saatavilla nouto-osoitteessa',
    goodsNotReadyAtPickupForCust: 'Tavarat eivät olleet valmiina asiakkaan noudettavaksi',
    shipmentNotAvailableAtTerminal: 'Lähetystä ei ollut saatavilla terminaalissa',
    registrationNumber: 'Rekisterinumero',
    commercialTrafficEligibility: 'Kaupallinen liikenne kelpoisuus',
    vehicleBrand: 'Autonmerkki',
    vehicleModel: 'Autonmalli',
    vehicleControl: 'Ajoneuvon tarkastus',
    vehicleControlComment: 'Ajoneuvon tarkastuksen kommentti',
    euroClass: 'Euro-luokka',
    alcoholDeliveryEducation: 'Alkoholin kuljetus koulutus',
    alcoholDeliveryEducationDate: 'Suoritettu koulutus',
    alcoholDeliveryEducationDateMissing: 'Päivämäärä puuttuu',
    alcoholDeliveryEducationDateRequired: 'Anna päivämäärä, jolloin alkoholin kuljetuskoulutus suoritettiin',
    alcoholDeliveryEducationValidToDate: 'Voimassa {{date}} asti',
    alcoholDeliveryEducationExpiresDate: 'Päättyy {{date}}',
    alcoholDeliveryEducationExpiredDate: 'Vanhentui {{date}}',
    alcoholDeliveryEducationValidTo: 'Voimassa asti',
    alcoholDeliveryEducationValidToRequired: 'Anna päivämäärä, johon asti koulutus on voimassa',
    alcoholDeliveryEducationValidToAfterEducationDate:
      'Voimassaolon on oltava suoritetun koulutuksen päivämäärän jälkeen',
    approved: 'Hyväksytty',
    notApproved: 'Ei Hyväksytty',
    couriersInCurrentDepartment: 'Kyseisen osaston kuriirit',
    editCourier: 'Muokkaa kuriiria:',
    courierUserUpdated: 'Kuriirin tiedot päivitetty onnistuneesti.',
    courierScanEnabled: 'Skannaa',
    noCouriersExplain: 'Emme löytäneet tuloksia. Kokeile etsiä toisella hakusanalla',
    unitId: 'Yksikkö-ID',
    minShipmentWeightKg: 'Tämän ajoneuvon vähimmäislähetyspaino (kg)',
    maxShipmentWeightKg: 'Tämän ajoneuvon enimmäislähetyspaino (kg)',
    canCarryPallets: 'Voi kuljettaa lavoja',
    noAvailableHatchInParcelBoxMachine: 'Ei vapaata lokeroa',
    packageDoesNotFitInParcelBox: 'Paketti ylittää sallitut mitat/painon',
    unknownErrorForParcelBoxDelivery: 'Muu tuntematon',
    errorInParcelBoxMachine: 'Automaatti on epäkunnossa',
    euroClassTypes: { euroEL: 'Euro EL', euro5: 'Euro 5', euro6: 'Euro 6' },
    co2: 'CO2',
    inCurrentDepartment: 'Nykyinen osasto',
    couriersInOtherDepartments: 'Lähetit muissa osastoissa',
    inOtherDepartments: 'Eri osastot',
    confirmConnect: 'Yhdistä lähetti nykyiseen osastoon',
    confirmModalDescription: '',
    searchForCouriers: 'Etsi lähettejä',
    dateOfBirth: 'Syntymäaika',
    dateNotValid: 'Virheellinen päivämäärä',
    dateOfBirthWithFormat: 'Syntymäaika (vvvv-kk-pp)',
    occupationalInjuryInsurance: 'Tapaturmavakuutus',
    breakTime: 'Taukoaika',
    breakDuration: 'Tauon kesto (min)',
    timeWindow: 'Tauon aloitusaika (aikaisin ja myöhäisin)',
    breakTimeDescription:
      'Kentissä <i>Tauon aloitusaika (aikaisin ja myöhäisin)</i> asetat aikaisimman ja myöhäisimmän ajan, jolloin tauko voi alkaa. Esimerkiksi asetus 11:00 - 17:00 tarkoittaa, että kuljettajan on aloitettava tauko viimeistään klo 17:00.',
    breakOptimizingSupportDescription:
      'Huomaa, että tauot ovat tuettuja vain, kun reittejä optimoidaan GraphHopperilla. Tämä toiminnallisuus ei ole käytettävissä PTV:n käytön yhteydessä.',
    between: 'Välillä',
    editBreakTime: 'Muokkaa taukoaikaa',
    updateBreakTime: 'Päivitä taukoaika',
    latestBreakStart: 'Myöhäisin tauon aloitus',
    radioButtons: { noBreakTime: 'Ei taukoa', timeWindow: 'Aikaväli', workingTime: 'Työaika' },
    workingTimeDescription:
      'Asetat maksimityöajan ennen kuin kuljettajan on pidettävä tauko. Esimerkiksi 8 tunnin jälkeen kuljettajan on pidettävä 30 minuutin tauko.',
    maxWorkingTime: 'Maksimi työaika',
    selectMaxWorkingTime: 'Valitse maksimityöaika',
    hours: '{{hours}} tuntia',
    breakTooltip: 'Voit asettaa vain yhden taukotyypin per yksikkö'
  },
  slot: {
    minutesDelay: 'minuuttia viivästynyt',
    minutesAhead: 'minuuttia aikaisessa',
    minutes: 'minuuttia',
    time: 'Aika',
    created: 'Luotu',
    assigned: 'Annettu toimitettavaksi',
    lock: 'Lukko',
    lockDescription:
      'Kun toimitusajankohta on lukittu, sitä ei voi käyttää enää tulevissa reitin optimoinneissa, eikä sitä voi muokata.',
    toggleVisibleSlotDescription: 'Piilota toimitusajankohta.',
    inProgress: 'Käynnissä',
    onHold: 'Odottaa',
    complete: 'Valmis',
    unknownState: 'Tuntematon tila',
    courierSelect: 'Valitse lähetti',
    unitSelect: 'Valitse yksikkö',
    printableSlotList: 'Tulostettava toimitusaikalista',
    followsRoute: 'Seuraa',
    doesNotFollowRoute: 'Poiketa',
    hasLocation: 'Näkyvissä',
    hasNoLocation: 'Ei näkyvissä',
    showActiveSlots: 'Käynnissä olevat',
    showSlotNotStarted: 'Ei aloitetut',
    showLoggedInRoutes: 'Kirjautunut - ei aloitettu',
    showCompletedSlot: 'Valmiit',
    showPerfectSlot: 'Täydelliset',
    filterSlots: 'Suodata toimitusajankohtia',
    planningCompleted: 'Valmis',
    completeWithLastSent: '{{label}} (viimeksi lähetetty: {{time}})',
    addMapArea: 'Valitse alue',
    editMapArea: 'Muokkaa alue'
  },
  login: {
    heading: 'Kirjaudu sisään',
    phone:
      "Lisää Glow'hun rekisteröity puhelinnumerosi mukaan lukien maanumero (esim. +358...), niin lähetämme sinulle SMS-tokenin.",
    code: 'Token lähetetty, jos tälle numerolle on rekisteröity käyttäjä. Se on voimassa 5 minuutia. Anna token.',
    requestNewCode: 'Pyydä toista koodia',
    verifyFailed:
      'Koodi tai puhelinnumero on väärin, tai liian monta kertaa mennyt väärin. Yritä uudestaan tai pyydä uusi koodi.',
    requestFailed: 'Tokenia ei voitu lähettää, yritä uudelleen.',
    verifyTokenButton: 'Vahvista koodi',
    requestTokenButton: 'Pyydä koodi',
    privacyLink: 'Tietosuojakäytäntö',
    passwordWrong: 'Virheellinen salasana',
    customer: 'Olen asiakas',
    forgotPassword: 'Unohditko salasanasi?',
    tryApp: 'Kokeile uutta sovellusta!',
    appDownload: 'Lataa kuljettajan sovellus täältä, niin saat käyttöösi enemmän toimintoja!',
    appInfo:
      'Oletko kuljettaja, jolla on Android-puhelin? Lataa kuljettajan sovellus <1>täältä</1>, niin saat käyttöösi enemmän toimintoja!',
    webApp: 'Web-sovellus',
    note: 'Huomautus! Käytä vain kuriirisovelluksen web-versiota, jos et jostain syystä käytä iOS- ja Android-sovelluksia',
    resendToken: 'Lähetä uudelleen',
    submitPassword: 'Lähetä salasana',
    loginAsCustomer: 'Kirjaudu sisään asiakkaana',
    loginAsPlanner: 'Kirjaudu sisään suunnittelijana',
    loginAsPartnerOrPhoneNumber: 'Kirjaudu sisään kumppanina',
    loginWithPhoneNumber: 'Kirjaudu sisään puhelinnumerolla',
    loginUsingSSO: 'Kirjaudu sisään Posten-tilillä',
    partnerLoginTitle: 'Kirjautuminen puhelinnumerolla on tarkoitettu kumppaneille',
    partnerLoginBody:
      'Vain kumppanikäyttäjät voivat kirjautua sisään puhelinnumerolla. Glow- ja Bring-työntekijänä käytä <pageLink>tätä sivua</pageLink>.',
    ssoLoginFailed:
      'Sisäänkirjautuminen ei onnistunut. Ota yhteyttä Postenin ja Bringin servicedeskiin, jos ongelma jatkuu.',
    token: 'Koodi',
    password: 'Salasana',
    tokenRequired: 'Koodi vaaditaan',
    forgotPasswordDescription:
      'Jatkaaksesi sinun on asetettava salasana. Lähetämme sinulle sähköpostin, jossa on linkki tämän asettamiseksi. Jos sähköpostisi on muuttunut, sinun on otettava yhteyttä ylläpitäjään sen muuttamiseksi.',
    sendEmailDescription:
      'Jatkaaksesi tarvitsemme sähköpostisi. Lähetämme sinulle vahvistuslinkin annettuun osoitteeseen. Tällä linkillä voit asettaa 2-vaiheisen salasanasi.',
    emailFormatValidation: 'Sähköpostin on oltava kelvollisessa muodossa',
    sendEmailSuccess: 'Sähköpostin pitäisi saapua pian',
    sendEmailFailed: 'Sähköpostin lähetys epäonnistui, yritä uudelleen',
    setYourPassword: 'Aseta salasanasi',
    sendEmail: 'Lähetä sähköposti',
    passwordsDontMatch: 'Salasanat eivät täsmää',
    passwordNotMeetRequirements: 'Salasana ei täytä vaatimuksia',
    passwordRequired: 'Salasana vaaditaan',
    newPassword: 'Uusi salasana',
    repeatPassword: 'Toista salasanasi',
    lowercaseLetter: 'Pieni kirjain',
    uppercaseLetter: 'Iso kirjain',
    numberCharacter: 'Numero',
    minimumCharacters: 'Vähintään 15 merkkiä',
    passwordDescription: 'Voit nyt asettaa salasanasi, sen on sisällettävä seuraavat'
  },
  error: {
    '404Title': 'Sivua ei löydy',
    '404Message': 'Emme löydä etsimääsi sivua',
    '500Message': '{{error}} - Pahoittelut, emme löydä tietojasi... yritämme uudelleen minuutin kuluttua...',
    title: 'Jotain meni vikaan!',
    dateRequiredWhenSecureLogin: '*Vaadittu jos kirjautuminen pankkitunnuksella on aktivoitu',
    dateNotValid: 'Virheellinen päivämäärä',
    dateCannotBeInFuture: 'Päivämäärä ei voi olla tulevaisuudessa',
    dateCannotBeInThePast: 'Päivämäärä ei voi olla menneisyydessä',
    dateCannotBeOlderThanMonths: 'Päivämäärä ei voi olla yli {{months}} kuukautta vanha',
    dateOutsideRange: 'Päivämäärä on voimassa olevan alueen ulkopuolella',
    errorMessage:
      'Olemme pahoillamme! Tämä ei sujunut kuten piti – olemme ilmoittaneet virheestä järjestelmänkehittäjille...',
    errorClickToReload: 'Klikkaa tästä ladataksesi sivun uudelleen',
    phoneNumber: 'Anna kelvollinen puhelinnumero, esim. +47 12345678',
    phoneNumberPrefix: 'Sinun täytyy antaa maanumero, esim. +358...',
    somethingWentWrong: 'Jokin meni vikaan.',
    andMoreErrors_one: 'ja {{count}} virhe lisää',
    andMoreErrors_other: 'ja {{count}} virhettä lisää',
    notAValidNumber: 'Virheellinen numero',
    notAValidAlphaNumeric: 'Täytyy olla numeroita ja/tai kirjaimia',
    notAValidDate: 'Virheellinen päivämäärä (vvvv-kk-pp)',
    notAValidTime: 'Virheellinen kellonaika (hh:mm)',
    notAValidDuration: 'Täytyy olla kelpaava aika (mm:ss)',
    notAValidZipCode: 'Ei kelvollinen postinumero',
    notAValidPostalCodeRange: "'Postinumero alkaen' on oltava pienempi tai yhtä suuri kuin 'Postinumero asti'",
    notAValidTimezone: 'Aikavyöhyke ei ole kelvollinen. Yrittää "Europe/Helsinki" tai samankaltainen',
    somethingWentWrongOnTheServer: 'Jokin meni palvelimella vikaan...',
    somethingWentWrongWithTheRequest: 'Pyynnössä oli jokin vika...',
    somethingWentWrongWithTheResponse: 'Vastauksessa oli jotain vikaa..',
    selectAtLeastOne: 'Sinun täytyy valita vähintään yksi vaihtoehto',
    timeInWrongFormat: 'Aika ei ole mahdollinen',
    invalidEmail: 'Sinun on annettava kelvollinen sähköpostiosoite, esim. name@gmail.com',
    requiredBreakDuration: 'Sinun on syötettävä tauon kesto',
    notAValidTimeWindow: 'Aikaisimman tauon on alettava ennen myöhäisintä',
    requiredEarliestStartBreak: 'Sinun on syötettävä aikaisin tauon aloitus',
    requiredLatestStartBreak: 'Sinun on syötettävä myöhäisin tauon aloitus',
    requiredIfWorkingTimeDuration: 'Sinun on syötettävä enimmäistyöaika',
    invalidUrlParameterCombination: 'Tämä URL-parametriyhdistelmä on virheellinen, eikä sivua voida näyttää',
    numberCannotContainDecimals: 'Luku ei saa sisältää desimaaleja',
    selectAtLeastOneItem: 'Vähintään yksi kohde on valittava',
    mustSelectDepartment: 'Osasto on valittava',
    mustSelectRoute: 'Sinun on valittava reitti',
    mustProvideLabel: 'Sinun on annettava {{label}}',
    sizeMustBeAnIntegerGreaterThanZero:
      'Koon on oltava kokonaisluku ilman desimaaleja, joka on suurempi tai yhtä suuri kuin 1'
  },
  loading: 'Haemme tietojasi...',
  newAppVersion: 'Glow parani hieman, haemme nyt uutta versiota.',
  loadingReceiptList: 'Kuittilistoja luodaan...',
  invoicing: { departmentInvoicingInProgress: 'Laskutus käynnissä...' },
  months: {
    january: 'Tammikuu',
    february: 'Helmikuu',
    march: 'Maaliskuu',
    april: 'Huhtikuu',
    may: 'Toukokuu',
    june: 'Kesäkuu',
    july: 'Heinäkuu',
    august: 'Elokuu',
    september: 'Syyskuu',
    october: 'Lokakuu',
    november: 'Marraskuu',
    december: 'Joulukuu'
  },
  weekdays: {
    monday: 'Maanantai',
    tuesday: 'Tiistai',
    wednesday: 'Keskiviikko',
    thursday: 'Torstai',
    friday: 'Perjantai',
    saturday: 'Lauantai',
    sunday: 'Sunnuntai'
  },
  weekdaysShort: {
    sunday: 'Su',
    monday: 'Ma',
    tuesday: 'Ti',
    wednesday: 'Ke',
    thursday: 'To',
    friday: 'Pe',
    saturday: 'La'
  },
  notifications: {
    dismiss: 'Hylkää',
    dismissAll: 'Hylkää kaikki',
    dismissAllNotifications: 'Hylätäänkö kaikki ilmoitukset?',
    error: 'Virhe',
    reload: 'Päivitä',
    reloadCourier: 'Paina tästä päivittääksesi näytön',
    navigate: 'Navigoi sivulle',
    networkError:
      'Vaikuttaa siltä, että tällä hetkellä on verkko-ongelmia, ne voivat olla tilapäisiä. Sivu tulee joka tapauksessa päivittää.',
    networkErrorCourier: 'Olet ollut offline-tilassa, ole hyvä ja päivitä sivu.',
    liveUpdatesPaused: 'Live-päivitykset keskeytetty',
    liveUpdatesDescription:
      'Live-päivitykset keskeytettiin, kun välilehti oli passiivinen. Päivitä ja ota uusimmat päivitykset käyttöön napsauttamalla.'
  },
  grid: {
    columns: {
      addressWashRecipientId: 'Vastaanottajan tunnus',
      addressWashAddressId: 'Osoitetunnus',
      department: 'Osasto',
      deadline: 'Aikaraja',
      failedReason: 'Virheviesti',
      exceptions: 'Poikkeukset',
      dispatchAsGroup: 'Dispatch ryhmänä',
      name: 'Nimi',
      senderName: 'Lähettäjän nimi',
      puearly: 'N',
      pulate: 'N',
      delearly: 'T',
      dellate: 'T',
      vas: 'VAS',
      zip: 'Posti nro',
      type: 'Tyyppi',
      estimated: 'Arvioitu aika',
      estimatedDepartureTime: 'ETD',
      adjusted: 'Muokattu',
      timeWindow: 'aikaikkuna',
      onCar: 'autossa',
      frequency: 'Toistuvuus',
      startDate: 'Aloituspäivä',
      endDate: 'Päättymispäivä',
      from: 'Alkaen',
      to: 'Asti',
      days: 'Päivät',
      holidays: 'Pyhät',
      startdate: 'Aloitus päivämäärä',
      enddate: 'Lopetus päivämäärä',
      orders: 'Tilaukset',
      id: 'Tilausnumero',
      shipmentId: 'Tilausnumero',
      packageId: 'Paketin ID',
      errorMessage: 'Virheilmoitus',
      customer: 'Asiakas',
      pickup: 'Nouto',
      delivery: 'Toimitus',
      service: 'Palvelu',
      address: 'Osoite',
      zipcode: 'Posti nro',
      area: 'Alue',
      weight: 'Paino',
      volume: 'Tilavuus{{unit}}',
      bookedWeight: 'Varattu paino{{unit}}',
      bookedVolume: 'Varattu tilavuus{{unit}}',
      qty: 'Kpl',
      preplanned: 'Kuljettaja',
      preplannedRouteTemplate: 'Reitti',
      group: 'Ryhmä',
      totalOrders: 'Tilauksia yhteensä',
      ordersFailed: 'Tilauksia epäonnistunut',
      date: 'Päivämäärä',
      finished: 'Valmis',
      failed: 'Epäonnistunut',
      ordersInvoiced: 'Tilauksia laskutettu',
      start: 'Aloitus',
      stop: 'Lopetus',
      pickupContactPerson: 'Nouto yhteyshenkilö',
      pickupPhone: 'Nouto puhelin',
      deliveryContactPerson: 'Toimitus yhteyshenkilö',
      deliveryPhone: 'Toimitus puhelin',
      deliveryAddress: 'Toimitusosoite',
      deliveryTime: 'Toimitusaika',
      contactPerson: 'Yhteyshenkilö',
      phone: 'Puhelin',
      email: 'Sähköposti',
      deliveryReferencePlaceholder: 'Vastaanottajan viite',
      specificationDescriptionPlaceholder: 'Tiedot tavarasta',
      multileg: 'Multileg',
      groupName: 'Ryhmän nimi',
      customerNumber: 'Asiakasnumero',
      orderNote: 'Sisäinen huomautus',
      returned: 'Palautettu',
      price: 'Hinta',
      slotName: 'Toimitusajankohta',
      estimatedArrivalTime: 'ETA',
      waitingTime: 'Odotusaika',
      timeOfDelivery: 'ToD',
      timeOfPickup: 'ToP',
      deliveryEtaSmsSentAt: 'Toimitusaika SMS lähetetty',
      trip: 'Matka',
      addresses: {
        title: 'Osoitteet',
        search: 'Etsi osoite',
        searchAddresses: 'Etsi osoitteita',
        filterAddresses: 'Suodata osoitteita',
        deleteConfirmation: 'Oletko varma että haluat poistaa tämän osoitteen?',
        deleteMultipleConfirmation: 'Oletko varma että haluat poistaa kaikki valitut osoitteet?',
        deleteSuccess: 'Osoite poistettu',
        deleteMultipleSuccess: 'Osoitteet poistettu',
        delete: 'Poista',
        name: 'Nimi',
        phone: 'Puhelinnumero',
        address: 'Osoite',
        zipArea: 'Kaupunki',
        zipCode: 'Postinumero',
        country: 'Maa',
        contactPerson: 'Yhteyshenkilö',
        instructions: 'Ohjeet',
        deleteAddress: 'Poista osoite',
        deleteMultipleAddresses: 'Poista osoitteet ({{count}})',
        loc: 'S',
        locTitle: 'Sijainti'
      },
      orderGrid: {
        vehicleType: 'Ajoneuvo',
        extraInfo: 'Lisätieto'
      },
      dispatch: {
        adjusted: 'Muokattu',
        customerName: 'Asiakkaan nimi',
        estimatedDepartureTime: 'ETD',
        service: 'Palvelu'
      },
      goodsType: 'Tavaratyyppi',
      orderSource: 'Tilaustapa',
      postalCodes: '# postinumero',
      displayEndCustomerPriceShd: 'Näytä asiakashinta',
      courier: 'Lähetti',
      createdAt: 'Luontipäivämäärä',
      createdBy: 'Luonut',
      plannedDeliveryDate: 'Suunniteltu aika',
      orderedDeliveryDate: 'Tilaus päivä',
      lastUpdatedAt: 'Viimeksi päivitetty',
      route: 'Reitti',
      instructions: 'Ohjeet',
      pickupDuration: 'Nouto aika',
      deliveryDuration: 'Vienti aika',
      pickupPreparation: 'Nouto valmistelu',
      deliveryPreparation: 'Vienti valmistelu',
      originalPickupAddress: 'Alkuperäinen lähettäjän osoite',
      originalPickupZipCode: 'Alkuperäinen lähettäjän postinumero',
      originalPickupZipArea: 'Alkuperäinen lähettäjän kaupunki',
      originalPickupCountry: 'Alkuperäinen lähtömaa',
      originalDeliveryAddress: 'Alkuperäinen toimitusosoite',
      originalDeliveryZipCode: 'Alkuperäinen toimituksen postinumero',
      originalDeliveryZipArea: 'Alkuperäinen toimituskaupunki',
      originalDeliveryCountry: 'Alkuperäinen toimitusmaa',
      packagesArrivedAtDip: 'Saapunut',
      packagesCollected: 'Noudettu',
      packagesDelivered: 'Toimitettu',
      originalDeliveryEarliest: 'Alkuperäinen T',
      originalDeliveryEarliest1: 'Alkuperäinen DEL 1',
      originalDeliveryLatest: 'Alkuperäinen T',
      originalDeliveryLatest2: 'Alkuperäinen DEL 2',
      preAdvices: 'Ennakkoilmoitusyritykset',
      preAdviceScheduledDate: 'Ensimmäisen ennakkoilmoituksen päivämäärä',
      hasPreAdviceSettings: 'Ennakkoilmoitusasetus',
      arrivedAtHub: 'Arrived at hub',
      returnToSender: 'Palautus lähettäjälle',
      preAdviceFailed: 'Ennakkoilmoitus epäonnistui',
      deliveryAttempts: 'Toimitusyritykset',
      shipmentCreationDate: 'Lähetyksen luontipäivämäärä',
      preAdviceResult: 'Ennakkoilmoituksen tulos',
      failedPreAdviceDate: 'Epäonnistuneen ennakkoilmoituksen päivämäärä',
      loadCarrierId: 'Kuormankantajan ID',
      deliveryPupUnitId: 'PUP ID',
      loadCarrier: 'Kuormankantaja',
      pickupZipCode: 'Noutopostinumero',
      pickupArea: 'Noutoalue',
      deliveryZipCode: 'Toimituspostinumero',
      deliveryArea: 'Toimitusalue',
      plannedStops: 'Suunnitellut pysähdykset'
    },
    columnSettings: {
      header: 'Lisää sarakkeita datataulukkoon',
      description: 'Kun valitset nimikkeen, nämä tiedot näytetään datataulukossa'
    }
  },
  openBooking: {
    error: {
      pickupTimeNotWithinServiceTimeWindow: 'Noutoaika ei ole palvelun aikaikkunan sisällä',
      pickupTimeBeforeEarliestServicePickupTime: 'Noutoaika ei voi olla ennen palvelun aikaisinta noutoaikaa',
      pickupNotAvailableForWeekend: 'Noutopalvelu ei ole saatavilla viikonloppuisin',
      invalidOrganisationNumber: 'Virheellinen Y-tunnus'
    }
  },
  instant: {
    title: 'Ajojärjestely',
    openMap: 'Avoin kartta',
    group: 'Ryhmä valittu',
    editGroup: 'Muokkaa ryhmää',
    groupName: 'Ryhmän nimi',
    groupOrders: 'Ryhmän tilaukset',
    viewGroup: 'Näytä ryhmä',
    ordersToGroup: 'Lisää tilaukset ryhmään',
    fixedOrder: 'Korjattu toimitusjärjestys',
    saveFixedOrder: 'Tallenna järjestysmuutokset',
    paidTogether: 'Maksetaan yhdessä',
    saveGroup: 'Tallenna Ryhmä',
    ungroup: 'Pura ryhmä',
    removeSelected: 'Poista valitut',
    split: 'Jaa valitut',
    noCourierSelected: 'Lähettiä ei valittu',
    noOrderSelected: 'Tilausta ei valittu',
    workingHours: 'Työtunnit',
    chatButton: 'Chatti kuljettajan kanssa',
    offeredShipments: 'Tarjotut lähetykset',
    rejectedShipments: 'Hylätyt lähetykset',
    rejectedShipmentsSnackbar: '"{{count}}" {{name}} hylkäämä lähetys',
    rejectedShipmentsSnackbar_other: '"{{count}}" {{name}} hylkäämää lähetystä',
    toBeDone: 'Tulevat noudot ja toimitukset',
    finishedRoutePoints: 'Hoidetut noudot ja toimitukset',
    suggestedRouteApplied: 'Ehdotettu reitti on otettu käyttöön',
    suggestedRouteCancelled: 'Ehdotettu reitti on peruttu',
    reorderValidationError: 'Ehdotettu reitti on virheellinen',
    planSlot: 'Reittisuunnitelma',
    createRoute: {
      vehiclePlaceholder: 'Ajoneuvoa ei ole valittu',
      title: 'Valitse ajoneuvo uuden reitin luomiseksi',
      description:
        'Tätä yksikköä ei ole vielä liitetty reittiin. Kun valitut lähetykset lisätään tälle yksikölle, luodaan uusi reitti. Valitse reitille ajoneuvo.'
    },
    columnSettings: {
      reset: 'Nollaa',
      settings: 'Asetukset',
      hideColumns: 'Piilota sarakkeet',
      saveAndClose: 'Tallenna ja sulje'
    },
    routePoint: {
      pickup: 'N',
      delivery: 'T',
      depot_call: 'PS',
      start: 'A',
      end: 'L'
    },
    confirmation: {
      heading: 'Tilausvahvistus',
      from: 'Nouto',
      to: 'Toimitus',
      service: 'Palvelu',
      pickup: 'Alkaen',
      delivery: 'Asti',
      shipmentNumber: 'Lähetyksen numero',
      printLabel: 'Tulosta etiketti',
      copyOrder: 'Kopioi tilaus',
      editOrder: 'Muokkaa tilausta'
    },
    goods: {
      custom: 'Mukautettu',
      letter: 'Kirje',
      bag: 'Pussi',
      smallbox: 'Pieni laatikko',
      mediumbox: 'Keskikokoinen laatikko',
      largebox: 'Iso laatikko',
      tube: 'Putkilo',
      quarterpallet: '1/4 lava',
      halfpallet: 'Teholava',
      fullpallet: 'Lava',
      suitcase: 'Matkalaukku',
      movingbox: 'Muuttolaatikko',
      trolley: 'Rullakko',
      parcel: 'Paketti',
      expressbox: 'Express-laatikko',
      '9A': 'Rullakko, paketit, tavarat',
      '9C': 'Rullakko, tyhjä',
      '9F': 'Puolilava, kirjeet',
      '9J': 'Lava, kirjeet',
      PX: 'Lava',
      PA: 'Paketti',
      AF: 'Puolilava',
      SA: 'Säkki',
      CS: 'Kasetti',
      '9N': 'Monsterrullakko, paketit',
      '9O': 'Monsterrullakko, tyhjä',
      '9B': 'Rullakko, kirjeet',
      '9D': 'Rullakko, muut',
      '9E': 'Puolilava, paketit, tavarat',
      '9G': 'Puolilava, tyhjä',
      '9H': 'Puolilava, muut',
      '9I': 'Lava, paketit, tavarat',
      '9K': 'Lava, tyhjä',
      '9L': 'Lava, muut',
      '9M': 'Kirje, kpl',
      '9P': 'IKEA TU pitkä',
      '9Q': 'IKEA TU lyhyt',
      '9Z': 'Tuntematon tilavuus',
      BE: 'Nippu',
      BG: 'Pussi',
      BX: 'Laatikko',
      CD: 'Kanisteri',
      CL: 'Kela',
      CN: 'Kontti',
      CR: 'Häkki',
      CT: 'Pahvilaatikko',
      CW: 'Rullakko',
      DR: 'Tynnyri',
      ED: 'Lavakaulus',
      LT: 'Erä',
      OA: 'Neljänneslava',
      OC: 'Merilava',
      OT: 'Oktabiini',
      PB: 'Lavalaatikko',
      PC: 'Paketti',
      PE: 'Modulaarinen lava',
      PI: 'Putki',
      PK: 'Kolli',
      PP: 'Kappale',
      PV: 'Putkinippu',
      RK: 'Hylly',
      RO: 'Rulla',
      RV: 'Rek. arvo',
      SE: 'Puoliperävaunu',
      TY: 'Säiliö, sylinterimäinen',
      VB: 'Vaihtokori',
      Z1: 'Bison-lava',
      Z2: 'Kukkarullakko',
      Z3: 'Banaanilava',
      Z4: 'Hedelmärullakko',
      Z5: 'Matala lava',
      Z6: 'Rema-lava',
      Z8: 'Maitorullakko',
      ZZ: 'Tuntematon'
    },
    instantGrid: {
      editColumnTooltip: 'Muokkaa tilausta',
      deleteColumnTooltip: 'Poista',
      unassignColumnTooltip: 'Poista kuljettajalta',
      dragColumnTooltip: 'Klikkaa ja vedä antaaksesi tehtävän lähetille',
      filtersActive: 'Suodatin päällä',
      clearFilters: 'Tyhjennä suodattimet',
      filterPlaceholder: 'suodata <enter>',
      assignColumnTooltip: 'Napsauta määrittääksesi lähetyksen'
    },
    booking: {
      numberOfCopies: 'Kopioiden määrä',
      numberOfCopiesPlaceholder: 'Syötä numero väliltä {{min}}-{{max}}',
      numberOfCopiesError: 'Sinun on annettava numero väliltä {{min}}-{{max}}',
      afterCutoffWarning:
        'Toimitus ei ole saatavilla - tänään klo {{cutoffTime}} ollut aikaraja on jo ylitetty. Valitse toinen palvelu tai toimituspäivä.',
      standaloneInvoiceCheckbox: 'Merkitse erilliseksi laskuksi',
      standaloneInvoiceDescription:
        'Valitsemalla tämän vaihtoehdon tämä tilaus käsitellään erikseen eikä yhdistetä muihin tilauksiin laskutusta varten.',
      addPackage: 'Lisää uusi paketti',
      removePackageRow: 'Poista paketti',
      cannotRemoveLastPackageRow: 'Viimeistä pakettia ei voi poistaa',
      copyPackageRow: 'Kopioi paketti',
      title: 'Tilaus',
      header: 'Tilaus',
      headerCreate: 'Uusi tilaus',
      headerEdit: 'Muokkaa tilausta',
      headerCopy: 'Kopioi tilaus',
      headerRestore: 'Palauta tilaus',
      customer: 'Asiakas',
      customerPlaceholder: 'Asiakastunnus',
      subcustomerPlaceholder: 'Ala-asiakas',
      invalidSubcustomer: 'Subcustomer nimi on virheellinen',
      invoiceSplitPlaceholder: 'Lasku jaettu',
      invoiceSplitPlaceholderLegend: 'Valitse laskun osuus',
      shipmentOrPackageId: 'Lähetys tai paketti ID',
      creditBlockedCustomer: 'Ei luottotietoja',
      priceDetails: 'Hintatiedot',
      sender: 'Lähettäjä',
      setAsDefaultAddress: 'Aseta oletusosoitteeksi',
      setAsDefaultDisabledText: 'Koordinaatit puuttuvat. Aseta osoite osoitehakukentän avulla',
      defaultAddressUpdated: 'Oletusosoite päivitetty',
      recipient: 'Vastaanottaja',
      pickupNamePlaceholder: 'Nimi',
      pickupAddressPlaceholder: 'Osoite',
      pickupZipCodePlaceholder: 'Postinumero',
      pickupZipAreaPlaceholder: 'Kaupunki',
      pickupCountryPlaceholder: '-- Valitse maa --',
      pickupPhoneNumberPlaceholder: 'Puhelin',
      pickupContactPerson: 'Yhteyshenkilö',
      customerReference: 'Asiakkaan viite',
      pickupReferencePlaceholder: 'Asiakkaan viite – Tämä kenttä näkyy asiakkaan laskussa',
      pickupInformationPlaceholder: 'Noutotiedot',
      pickupEmailPlaceHolder: 'Sähköposti',
      customerContact: 'Asiakaskontakti',
      customerContactPlaceholder: '$t(instant.booking.customerContact) – Tämä kenttä näkyy asiakkaan laskussa',
      customerInfoPlaceholder: 'Yleiset asiakaskohtaiset tiedot',
      customerInfoHelper:
        'Tämä tieto on liitetty asiakkaaseen. Tehdyt muutokset näkyvät kaikissa asiakkaan tilauksissa.<br><br>Jos haluat lisätä tietoa vain tähän tilaukseen, käytä ”Lisätietoja” kohtaa.',
      deliveryNamePlaceholder: 'Nimi',
      letterBoxPrefix: 'Postilaatikko',
      letterBoxAlt: '{{operator}} postilaatikko',
      deliveryAddressPlaceholder: 'Osoite',
      deliveryZipCodePlaceholder: 'Postinumero',
      deliveryZipAreaPlaceholder: 'Kaupunki',
      deliveryCountryPlaceholder: '-- Valitse maa --',
      deliveryPhoneNumberPlaceholder: 'Puhelin',
      deliverySecondPhoneNumberPlaceholder: 'Toinen puhelinnumero',
      deliveryEmailPlaceHolderPlaceholder: 'Sähköposti',
      deliveryReferencePlaceholder: 'Vastaanottajan viite',
      deliveryInformationPlaceholder: 'Toimitustiedot',
      orderNote: 'Sisäinen huomautus',
      invalidInvoiceSplit: 'Virheellinen laskun jakoteksti',
      clearData: 'Tyhjennä',
      dimensions: 'Tavara',
      weightPlaceholder: 'Paino (kg)',
      lengthPlaceholder: 'Pituus (cm)',
      widthPlaceholder: 'Leveys (cm)',
      heightPlaceholder: 'Korkeus (cm)',
      service: 'Palvelu',
      serviceCode: 'Palvelukoodi',
      servicePlaceholder: 'Palvelukoodi',
      serviceSelect: 'Valitse palvelu',
      serviceSelectDisabled: 'Palvelujen vaihtaminen HD-tilauksissa on tehtävä HappyFlow-muodossa',
      deliveryOrderService: {
        description: 'Toimitustilaus'
      },
      goodsEditDisabled: 'HD-tilausten tuotteisiin tehtävät muutokset on tehtävä HappyFlow´ssa',
      standardServices: '-- PERUSPALVELUT --',
      customizedServices: '-- ASIAKASKOHTAISET PALVELUT --',
      specificationDescription: 'Tavara',
      specificationDescriptionPlaceholder: 'Tiedot tavarasta',
      invoiceInfo: 'Laskutustiedot',
      invoiceInfoPlaceholder: 'Laskutustiedot – Tämä kenttä näkyy asiakkaan laskussa',
      manualInvoiceInfo: 'Manuaalinen laskunkäsittely',
      manualInvoiceInfoPlaceholder:
        'Manuaalinen laskunkäsittely (jos tähän kenttään on täytetty laskutustiedot, tilausta ei laskuteta automaattisesti)',
      pickup: 'Nouto',
      delivery: 'Toimitus',
      pickupDatePlaceholder: 'Noutopäivä',
      pickupTimePlaceholder: 'Noutoaika',
      deliveryDatePlaceholder: 'Toimituspäivä',
      deliveryTimePlaceholder: 'Toimitusaika',
      deliveryContactPerson: 'Yhteyshenkilö',
      restoreButton: 'Palauta',
      orderButton: 'Tilaus',
      editButton: 'Päivitä',
      copyButton: 'Tilaus',
      created: 'Tilaus on rekisteröity',
      edited: 'Tilaus on päivitetty',
      quickSelect: 'Nopea valinta',
      volume: 'Volyymi',
      points: 'Pisteet',
      totalVolume: 'Kokonaisvolyymi {{volume}}',
      totalWeight: 'Kokonaispaino {{weight}}',
      removeItem: 'Poista',
      copyItem: 'Kopioi',
      addItem: 'Lisää',
      calculatePrice: 'Laske hinta',
      priceExplanations: {
        header: 'Hinnan selitys',
        article: 'Artikla: {{article}}',
        priceListName: 'Hinta lista:: {{pricelist}}',
        explanations: 'Selitykset',
        noInfo: 'Hintatietoja ei ole saatavilla',
        details: 'Yksityiskohdat',
        notFound: 'Hintaselityksiä ei ole saatavilla.'
      },
      approveIncompletePrice: 'Hyväksyn kaikki rivit, joiden hinta on nolla',
      muteBomArticles: 'Jätä {{bomArticle}} pois laskutuksesta',
      prePlan: 'Suunnittele',
      prePlannedToCourier: 'Valitse lähetti',
      prePlannedToRouteTemplate: 'Valitse reitti',
      prePlannedToRouteText:
        'Saatavilla olevat reitit riippuvat osastolle tallennetuista malleista. Jotta automaattinen reititys toimisi oikein, sinun on määritettävä reittiasetukset <0>osastotasolla</0> hallintasivuilla.',
      automaticDepartment: 'Automaattinen',
      departmentLabel: 'Osasto',
      notifications: 'Ilmoitukset',
      emailNotifications: 'Sähköposti ilmoitukset',
      eventRegistered: 'Rekisteröity',
      eventPickup: 'Nouto',
      eventDelivery: 'Toimitus',
      emailAddress: 'Sähköpostiosoite',
      emailRecipientText: 'Seuraavat sähköpostiosoitteet vastaanottavat ilmoituksia:',
      invalidEmail: 'Väärä sähköpostiosoite',
      editIndicator: 'Muokkaa',
      updateIndicator: 'Päivitä',
      copyIndicator: 'Kopioi',
      quantity: 'Määrä',
      additionalServices: 'Lisäpalvelut',
      paymentInformation: 'Maksutiedot',
      paidTogetherLabel: 'Maksetaan samasta?',
      groupingLabel: 'Lähetysten ryhmittäminen',
      groupIdPlaceholder: 'Ryhmän id',
      groupOrderPlaceholder: 'Ryhmän tilausnumero',
      addRecipient: 'Lisää ylimääräinen vastaanottaja',
      addPickup: 'Lisää ylimääräinen lähettäjä',
      vehicleType: 'Ajoneuvotyyppi',
      vehicleTypeUpdated: 'Ajoneuvotyyppi päivitetty',
      selectVehicleType: 'Valitse ajoneuvotyyppi',
      customerPrice: 'Asiakas hinta',
      resourcePrice: 'Kuljettajan hinta',
      priceList: 'Hinta lista',
      manualPrice: 'Manuaalinen',
      total: 'Kaikki yhteensä',
      vehicleTypes: {
        car: 'Henkilöauto',
        bicycle: 'Polkypyörä',
        truck: 'Kuorma-auto',
        van: 'Pakettiauto',
        motorcycle: 'Moottoripyörä',
        cargobike: 'Rahtipyörä'
      },
      date: 'Päivämäärä',
      unNumber: 'YK-numero',
      hazardous: 'Luokka',
      class: 'Luokka',
      group: 'Ryhmä',
      netWeight: 'Nettopaino',
      name: 'Nimi',
      restrictions: 'Rajoitukset',
      totalPoints: 'Kokonaispisteet',
      unacceptableMeasurementsError:
        'Mitat eivät ole oikein. Syötä joko kaikki mitat oikein tai anna kaikille paketeille tilavuus.',
      serviceMessage: 'Muista lisätä asiakas, jotta näet saatavilla olevat palvelut',
      pickupTimeEarliest: 'Aikaisin noutoaika',
      pickupTimeLatest: 'Myöhäisin noutoaika',
      deliveryTimeEarliest: 'Aikaisin toimitusaika',
      deliveryTimeLatest: 'Myöhäisin toimitusaika',
      henteordre: {
        availableTimeSlots: 'Saatavilla olevat aikaikkunat',
        setCustomTimes: 'Aseta mukautetut ajat',
        selectAvailableTimes: 'Valitse saatavilla olevat ajat',
        enterPickupZipCode: 'Syötä noutopostinumero nähdäksesi saatavilla olevat aikaikkunat'
      },
      hazardousGoods: 'Vaaralliset aineet'
    },
    courierSorting: { title: 'Suodatusperuste', alystraId: 'Kuljettajanumero', empty: 'Tyhjä', full: 'Täynnä' },
    courierFilter: {
      title: 'Lähettien suodatusperuste',
      all: 'Näytä kaikki',
      inactive: 'Piilota passiivinen',
      offline: 'Piilota offline',
      both: 'Piilota passiivinen ja offline-tilassa'
    },
    invoicingFilter: {
      ALL: 'Näytä kaikki',
      INVOICED_OK: 'Jo laskutettu',
      TO_BE_INVOICED: 'Laskutettavat',
      ORDER_CORRECTION: 'Tilauskorjauksella',
      INVOICED_FAILED: 'Laskutus epäonnistui'
    },
    shipmentFilter: {
      title: 'Suodata lähetyksiä',
      showAll: 'Näytä kaikki',
      notCollected: 'Noutamatta',
      hideAll: 'Piilota kaikki'
    },
    offer: {
      carEmpty: 'Auto on parhaillaan tyhjä',
      suggestedDelivery: 'Ehdotetty toimitus järjestys',
      newShipments: 'Uudet tilaukset',
      manualRoute: 'Manuaalinen reitti',
      confirmRoute: 'Hyväksy reitti',
      assigning: 'Määrää',
      replanning: 'Suunnitellaan reittiä uudelleen kohteelle',
      shipmentsTo: 'lähetystä kuljettajalle',
      shipmentTo: 'lähetys kuljettajalle'
    },
    useFlexible: 'Käytä joustavia toimitus aikoja',
    forceOptimizing: 'Pakota annettu toimitus järjestys',
    replanRoute: 'Suunnittele reitti uudelleen',
    recurring: {
      exceptionsUpdated: 'Poikkeukset päivitetty',
      dispatchAsGroup: 'Dispatch ryhmänä',
      recurringOrderSaved: 'Toistuva tilaus tallennettu',
      executeDate: 'Suorituspäivä',
      confirmExecuteOrders: 'Oletko varma, että haluat suorittaa kaikki toistuvat tilaukset päivälle {{date}}?',
      editRecurringOrder: 'Muokkaa toistuvaa tilausta',
      createRecurringOrder: 'Luo toistuva tilaus',
      title: 'Vakiot',
      successMessage: '{{number}} lähetystä lisättiin valittuihin toistuviin ryhmiin',
      recurringOrders: 'Vakio tilaukset',
      includedOrders: 'Tilaukset sisältyvät aikatauluun',
      details: 'Henkilötiedot',
      editOriginal: 'Muokkaa alkuperäistä',
      copyOriginal: 'Kopioi alkuperäinen',
      notStarted: 'Ei alkanut',
      executing: 'Esittäen...',
      ended: 'Päättynyt',
      status: 'Tila',
      pending: 'Vireillä',
      ok: 'OK',
      total: 'Yhteensä',
      failedOrders: 'Epäonnistuneet tilaukset',
      exceptionsHeading: 'Tilausten poikkeukset',
      addExceptionHeading: 'Uusi poikkeusjakso',
      exceptionStart: 'Alku',
      exceptionEnd: 'Loppu',
      editExceptions: 'Muokkaa poikkeuksia',
      addRecurring: 'Vakio',
      addToGroup: 'Valitse vakioryhmä',
      exceptions: 'Poikkeukset',
      recurringOrderAddedConfirmation: 'Tilaus lisätty vakioryhmään',
      name: 'Nimi',
      frequency: 'Toistuvuus',
      frequencies: {
        weekly: 'Joka viikko',
        second_week: 'Joka toinen viikko',
        third_week: 'Joka kolmas viikko',
        monthly: 'Joka kuukausi'
      },
      daysOfWeek: 'Viikonpäivät',
      includeHolidays: 'sisällytä lomat',
      endsNextDay: 'Päättyy seuraavana päivänä',
      endsNextDayExplanation:
        'Vain reiteille, jotka jatkuvat puolenyön yli. Aloitusaika on ensimmäisenä päivänä ja päättymisaika seuraavana päivänä.',
      endsNextDayRequiredByShipments:
        'Poista nouto tai toimitus seuraavana päivänä lähetyksistä ennen tämän poistamista',
      pickupNextDay: 'Nouto seuraavana päivänä',
      deliveryNextDay: 'Toimitus seuraavana päivänä',
      nextDayExplanation: 'Ikkuna alkaa reitin ensimmäisenä päivänä. Vain viimeisin aika siirtyy seuraavalle päivälle.',
      createBillingOrder: 'Luo laskutusjärjestys',
      customerForBillingOrder: 'Asiakas laskutusjärjestykselle',
      errorBeforeToday: 'Ei voi olla ennen tätä päivää',
      errorEndBeforeStart: 'Ei voi olla ennen aloituspäivää',
      excludedDateRanges: {
        title: 'Poissuljetut päivämäärät',
        add: 'Lisää listaan',
        savedWithRoute: 'Poissuljetut päivämäärät tallennetaan, kun tallennat reitin',
        ongoing: 'käynnissä'
      },
      startDate: 'Aloituspäivä',
      endDate: 'Päättymispäivä',
      save: 'Tallenna',
      fromDate: 'Alkamispäivä',
      confirmDelete: 'Haluatko varmasti poistaa valitun(-t) toistuvan(-t) kuljetuksen(-t)?',
      numSelectedRoutes: '{{count}} valittu',
      deleteTemplateRoute: {
        title: 'Poista mallireitti',
        description: 'Tätä toimintoa ei voi kumota.'
      },
      deleteTemplateRoutes: {
        title: 'Haluatko varmasti poistaa {{count}} reittiä?',
        description: 'Tätä toimintoa ei voi kumota.'
      },
      rolloutTemplateRoutes: {
        title: 'Haluatko varmasti ottaa käyttöön {{count}} reittiä?',
        description: 'Reitit otetaan käyttöön päivämäärälle {{date}}.',
        alreadyRolledOut: '{{count}} reiteistä on jo otettu käyttöön päivämäärälle {{date}}:',
        replaceWarning:
          'Niiden reitit ja tilaukset poistetaan ja otetaan käyttöön uudelleen. Tilaukset saavat uudet lähetysnumerot.'
      },
      from: 'Alkaen',
      createOrders: 'Luo tilaukset',
      showResult: 'Näytä tulos',
      showRolloutResult: 'Näytä käyttöönoton tulos',
      rolloutProblems: 'Käyttöönoton ongelmat',
      rolloutProblemsFrom: 'Edellisestä käyttöönotosta, {{date}}',
      rolloutProblemsHandled: 'Käsitellyt käyttöönoton ongelmat',
      noRolloutProblems: 'Ei käyttöönoton ongelmia tällä ajanjaksolla',
      noOutstandingRolloutProblems: 'Kaikki käyttöönoton ongelmat on käsitelty',
      dealtWith: 'Käsitelty',
      problems: 'Ongelmat',
      problemType: 'Ongelma',
      severityCritical: 'Kriittinen',
      severityWarning: 'Varoitus',
      rangeReversed: 'Alkupäivä ei voi olla loppupäivän jälkeen',
      rangeTooLong: 'Ajanjakso ei voi olla pidempi kuin {{days}} päivää',
      rangeNeedsEnd: 'Jos haluat katsoa yli {{days}} päivää taaksepäin, aseta myös loppupäivä',
      problemRolloutFailed: 'Käyttöönotto epäonnistui',
      problemOrderNotCreated: 'Tilausta ei luotu',
      problemOrderNotOnRoute: 'Tilaus ei ole reitillä',
      problemStopNotOnRoute: 'Suunniteltu pysähdys ei ole reitillä',
      startdate: 'Aloitus päivämäärä',
      enddate: 'Lopetus päivämäärä',
      orders: 'Tilaukset',
      executionSummary: 'Suoritusten yhteenveto',
      executions: 'Suoritukset',
      executionStatus: 'Suorituksen tila',
      executionId: 'Suoritus',
      templateShipment: 'Mallilähetys',
      createdOrderId: 'Luotu tilausnumero',
      packageIds: 'Paketti-id:t',
      sentAt: 'Lähetetty',
      lastAttemptAt: 'Viimeisin yritys',
      routeConnected: 'Liitetty reittiin',
      optimizationRequestId: 'Optimointipyynnön id',
      failedOptimizationRequestIds: 'Epäonnistuneiden optimointipyyntöjen id:t',
      routeConnectedSummary: 'Liitetty reittiin',
      onlyWithErrors: 'Vain virheelliset',
      rolloutResult: {
        newView: 'Uusi näkymä',
        oldViewNotice:
          'Tämä näkymä poistuu pian. Uusi näkymä näyttää ongelmat tästä päivästä eteenpäin syyn mukaan ryhmiteltyinä.',
        switchToNewView: 'Vaihda uuteen näkymään',
        earlierProblems_one: 'Käyttöönotosta {{date}} on {{count}} käsittelemätön ongelma.',
        earlierProblems_other: 'Käyttöönotoista {{date}} alkaen on {{count}} käsittelemätöntä ongelmaa.',
        showEarlierProblems: 'Näytä ne',
        crumb: 'Käyttöönoton tulos',
        title: 'Käyttöönoton tulos - {{date}}',
        nothingRolledOut: 'Tästä päivästä alkaen ei ole otettu mitään käyttöön',
        progress: 'Käyttöönoton tila',
        showProgress: 'Näytä käyttöönoton tila',
        processing: 'Käyttöönotto käynnissä',
        processingCount: 'Edistyminen · {{processed}}/{{total}} reittiä',
        done: 'Käyttöönotto valmis',
        doneCount: '{{processed}}/{{total}} reittiä',
        routes: 'Luodut reitit',
        createdOrders: 'Luodut tilaukset',
        stops: 'Pysähdykset',
        failedStops: 'Epäonnistuneet pysähdykset',
        orderStatus: {
          PENDING: 'Odottaa',
          SENT: 'Lähetetty',
          CREATED: 'Luotu',
          FAILED: 'Epäonnistui',
          MISSING: 'Puuttuu'
        },
        plannedStopStatus: {
          PENDING: 'Odottaa',
          CONNECTED: 'Yhdistetty',
          FAILED: 'Epäonnistui'
        },
        unhandled: 'Käsittelemättömät',
        handled: 'Käsitellyt',
        handledToggle: 'Näytä käsittelemättömät tai käsitellyt ongelmat',
        unhandledCount: 'Käsittelemättömät ongelmat ({{count}})',
        handledCount: 'Käsitellyt ongelmat ({{count}})',
        unhandledDescription: 'Korjaa virheet, jotta seuraava käyttöönotto ei toista niitä.',
        handledDescription: 'Käsitellyiksi merkityt ongelmat. Merkitse ongelma käsittelemättömäksi palauttaaksesi sen.',
        unhandledEmpty: 'Ei käsiteltäviä ongelmia',
        handledEmpty: 'Yhtään ongelmaa ei ole merkitty käsitellyksi',
        groupDescription: 'Kun olet korjannut tiedot, merkitse ongelma käsitellyksi, niin se poistuu listalta.',
        cause: {
          MISSING_CUSTOMER: {
            title: 'Asiakasnumero puuttuu',
            description: 'Asiakasta ei löytynyt. Se on voitu poistaa tai muuttaa.'
          },
          ORDER_NOT_CREATED: {
            description: 'Tilausta ei voitu luoda. Katso virheen syy.'
          },
          TIME_WINDOW: {
            title: 'Aikaikkuna',
            description: 'Tilausta ei lisätty reitille aikaikkunan vuoksi.'
          },
          MISSING_COORDINATES: {
            title: 'Koordinaatit puuttuvat',
            description: 'Osoitteelta puuttuvat koordinaatit.'
          },
          CAPACITY: {
            title: 'Ajoneuvossa ei ole tarpeeksi kapasiteettia',
            description: 'Tilaus ei mahtunut kapasiteetin vuoksi.'
          },
          OPTIMIZATION_FAILED: {
            title: 'Optimointi epäonnistui',
            description: 'Reittioptimointi epäonnistui useiden yritysten jälkeen.'
          },
          ORDER_NOT_ON_ROUTE: {
            description: 'Tilaus luotiin, mutta sitä ei lisätty reitille. Syy ei ole vielä tiedossa.'
          },
          STOP_NOT_ON_ROUTE: {
            description:
              'Pysähdystä ei voitu lisätä reitille, yleensä aikaikkunan tai sijainnin vuoksi. Korjaa se mallireitillä.'
          }
        },
        filterRoutes: 'Suodata reittejä',
        allRoutes: 'Kaikki reitit',
        routeName: 'Reitin nimi',
        templateRoute: 'Mallireitti',
        rolledOutAt: 'Otettu käyttöön',
        handledBy: 'Käsitellyksi merkinnyt',
        selectRow: 'Valitse {{route}} {{id}}',
        markAsHandled: 'Merkitse käsitellyksi',
        markAsHandledHint: 'Se poistuu listalta',
        markAsUnhandled: 'Merkitse käsittelemättömäksi'
      },
      rolloutView: {
        label: 'Käyttöönotot',
        current: 'Nykyiset',
        all: 'Kaikki, myös korvatut',
        replaced: 'Vain korvatut'
      },
      replaced: 'korvattu',
      replacedAt: 'Korvattu',
      replacedBy: 'Korvaaja',
      replacesExecution: 'Korvaa käyttöönoton',
      templateRouteId: 'Mallireitti-id',
      templateRouteName: 'Mallireitin nimi',
      createdAt: 'Luotu',
      updatedAt: 'Päivitetty',
      date: 'Päivämäärä',
      createdSlotId: 'Luotu reitti-id',
      createdBy: 'Luonut',
      failed: 'Epäonnistunut',
      by: 'Tekijä',
      on: '–',
      reset: 'nollata',
      confirmReset: 'Haluatko varmasti nollata {{date}} toistuvat tilaukset?',
      startDateExplanation: 'Tilaukset luodaan samana päivänä kuin aloituspäivä',
      noOrderSelected: 'Tilausta ei valittu',
      noOrdersFound: 'Tilausta ei löytynyt',
      groups: 'Ryhmät',
      routes: 'Reitit',
      newRoute: 'Luo uusi toistuva reitti',
      recurringRoute: 'Toistuva reitti',
      tabFrequency: 'Taajuus',
      tabRoute: 'Reitti',
      tabTemplateShipments: 'Mallilähetykset',
      timeQuestion: 'Mihin aikaan reitti alkaa ja päättyy?',
      frequencyQuestion: 'Kuinka usein haluat ottaa reitit käyttöön?',
      holidayRollout: 'Käyttöönotto pyhäpäivinä',
      holidayRolloutDescription:
        'Reittejä ei oletuksena oteta käyttöön pyhäpäivinä. Valitse tämä, jos haluat ottaa pyhäpäivät mukaan käyttöönottoon.',
      weekdaysQuestion: 'Minä viikonpäivinä haluat reitin toimittavan?',
      periodQuestion: 'Milloin haluat reitin alkavan ja päättyvän?',
      routeDetails: 'Reitin tiedot',
      searchShipments: 'Etsi lähetyksiä',
      editShipment: 'Muokkaa mallilähetystä',
      newTemplateShipment: 'Uusi mallilähetys',
      addShipments: 'Lisää lähetykset',
      saveShipment: 'Tallenna lähetys',
      findYourShipmentsDescription: 'Kirjoita hakemasi termi yllä olevaan hakukenttään',
      onRoute: 'Tiellä',
      saveFrequency: 'Tallenna taajuusasetukset',
      saveRoute: 'Tallenna reittiasetukset',
      saveShipments: 'Tallenna lähetykset reitille',
      shipmentsAddedToRoute: 'Lähetykset lisätty reitille',
      shipmentCopied: 'Mallilähetys kopioitu',
      routeCreated: 'Toistuva reitti luotu',
      routeUpdated: 'Toistuva reitti päivitetty',
      editRoute: 'Muokkaa {{route}}',
      recurringRoutes: 'Toistuvat reitit',
      selectRouteWithId: 'Valitse reitti tunnuksella {{id}}',
      rolloutInfoConfigured:
        'Automaattinen käyttöönotto käyttää osaston automaattista toistuvaa aikaa {{time}} ja ottaa reitit käyttöön seuraavalle päivälle.',
      rolloutInfoMissing:
        'Automaattista käyttöönottoa ei ole määritetty tälle osastolle, koska automaattinen toistuva aika on tyhjä. Pyydä järjestelmänvalvojaa määrittämään tämä.',
      addStop: 'Lisää pysähdys',
      days: 'Päivät',
      dates: 'Päivämäärät',
      addException: 'Lisää poikkeus',
      addedExceptions: 'Lisätyt poikkeukset',
      selectedOrders: 'Valitut tilaukset',
      moveShipment: 'Siirrä lähetys',
      moveShipmentModal: {
        errorMessage: 'Lähetykset: {{shipmentIds}}, virheilmoitus: {{error}}',
        shipmentsMovedText: 'Lähetykset {{shipmentIds}}, {{stopIds}} on siirretty reitille {{route}}',
        partialSuccessMessage: '{{count}} / {{fullCount}} lähetyksestä siirrettiin',
        title: 'Siirrä valitut lähetykset toiselle reitille'
      },
      changeRoute: 'Vaihda reitti',
      viewRoute: 'Reitille',
      plannedStops: 'Suunnitellut pysähdykset',
      templatePlannedStopId: 'Mallin suunniteltu pysähdys',
      createdPlannedStopId: 'Luotu suunniteltu pysähdys',
      notRouteConnected: 'Ei reitillä'
    },
    corrections: {
      title: 'Muutokset',
      headline: 'Tilauksen muutokset ajalta {{date}}',
      accepted: 'Tilauksen muutos hyväksytty',
      rejected: 'Tilauksen muutos hylätty',
      approve: 'HYVÄKSY',
      decline: 'HYLKÄÄ',
      shipmentId: 'Tilausnumero',
      courier: 'Kuljettaja',
      from: 'Mistä',
      to: 'Mihin',
      details: 'Tietoja',
      pickupWaitingTime: 'Noudon odotusaika (min)',
      deliveryWaitingTime: 'Toimituksen odotusaika (min)',
      pickupLoadingTime: 'Noudettu (min)',
      deliveryLoadingTime: 'Toimitettu (min)',
      comment: 'Kommentti',
      weight: 'Paino',
      volume: 'Tilavuus',
      packages: 'Pakettimäärä',
      serviceCode: 'Palvelun koodi',
      noOrderCorrections: 'Ei tilauskorjauksia',
      minutesOutOfRangeError: 'Sinun on täytettävä numero välillä {{min}} ja {{max}}',
      timeInMinutesWarning: 'Virheellinen aika-arvo, tarkista onko se oikea'
    },
    dispatch: {
      assigningMultilegDelivery: 'Määritetään {{count}} multileg-toimitus',
      assigningMultilegDelivery_other: 'Määritetään {{count}} multileg-toimitusta',
      turningThisOnExplanation: '(Tämän kytkeminen päälle antaa sinun ohittaa reittisuunnitelman)'
    },
    suggestedUnits: {
      unitName: 'Laitteen nimi',
      driverName: 'Kuljettajan nimi',
      slotName: 'Reitti',
      timeAtLocation: 'Aika kohteessa',
      distanceFromLocation: 'Etäisyys kohteesta',
      shipmentInformation: 'Lähetystiedot',
      suggestedVehicles: 'Suositellut ajoneuvot',
      suggestedVehiclesOnPickup: 'Ehdotetut ajoneuvot noutoon',
      suggestedVehiclesOnDelivery: 'Ehdotetut ajoneuvot toimitukseen',
      suggestedUnits: 'Ehdotetut yksiköt',
      noSuggestionsAvailable: 'Ei ehdotuksia saatavilla',
      pickupTime: 'Nouto Aika',
      deliveryTime: 'Toimitus Aika',
      filterBy: 'Rajoita'
    },
    shipmentSummary: {
      unPrePlan: 'Peru suunnittelu',
      prePlanTo: 'Suunnittele kohteeseen'
    }
  },
  errors: {
    DIP_DESTINATION_ALREADY_MAPPED:
      'Tämä noutopiste on jo kytketty toiseen DIP:iin. Lataa sivu uudelleen nähdäksesi nykyiset kytkennät.',
    ALREADY_ENQUEUED_FOR_INVOICING: 'Jo lisätty laskutusjonoon',
    DEPARTMENT_INVALID_ALYSTRA_ID: 'Virheellinen osaston ID',
    EXPORT_DEPARTMENT_GROUP_TOO_LARGE: 'Valitse pienempi osastoryhmä tai lyhyempi vientiaikaväli',
    ENTITY_DOES_NOT_EXIST: 'Kohdetta ei ole olemassa',
    RECURRING_ROUTE_REROLL_OUT_DATE_NOT_IN_FUTURE:
      'Toistuvat reitit voidaan ottaa käyttöön uudelleen vain tämän päivän jälkeiselle päivämäärälle',
    RECURRING_ROUTE_NOT_ROLLED_OUT:
      'Valittua reittiä ei ole otettu käyttöön tälle päivämäärälle. Lataa sivu uudelleen ja yritä uudelleen',
    RECURRING_ROUTE_ROLLOUT_IN_PROGRESS:
      'Valittua reittiä otetaan vielä käyttöön. Odota muutama minuutti ja yritä uudelleen',
    ROUTE_ALREADY_CONNECTED_TO_ANOTHER_RULE:
      'Reitti on jo liitetty toiseen reittisääntöön, päivitä sivu ja yritä uudelleen',
    INVALID_DATE_RANGE: 'Virheellinen ajanjakso',
    INVALID_DELIVERY_LATITUDE: 'Virheellinen toimituksen leveysaste',
    INVALID_DELIVERY_LONGITUDE: 'Virheellinen toimituksen pituusaste',
    INVALID_LATITUDE: 'Virheellinen leveysaste',
    INVALID_LONGITUDE: 'Virheellinen pituusaste',
    INVALID_OR_MISSING_TIME: 'Virheellinen tai puuttuva aika',
    INVALID_PHONE_NUMBER: 'Virheellinen puhelinnumero',
    DUPLICATE_PHONE_NUMBER: 'Sama puhelinnumero!',
    DUPLICATE_PHONE_NUMBER_COURIER: 'Tällä puhelinnumerolla on jo rekisteröity kuljettaja',
    INVALID_PICKUP_LATITUDE: 'Virheellinen noudon leveysaste',
    INVALID_PICKUP_LONGITUDE: 'Virheellinen noudon pituusaste',
    INVALID_SLOT_TYPE: 'Virheellinen toimitusaikatyyppi',
    MISSING_ADDRESS: 'Osoite puuttuu',
    MISSING_ALYSTRA_ID: 'ID puuttuu',
    MISSING_AREA: 'Alue puuttuu',
    MISSING_CAPACITY: 'Kapasiteetti puuttuu',
    MISSING_COLOR: 'Väri puuttuu',
    MISSING_CONSIGNMENT_INPUTS: 'Tavaraerää ei syötetty',
    MISSING_CONSIGNMENT: 'Tavaraerä puuttuu',
    MISSING_CONSIGNMENTS: 'Tavaraerät puuttuvat',
    MISSING_COURIER_ID: 'Lähetin id puuttuu',
    MISSING_COURIER: 'Sinun täytyy valita lähetti',
    MISSING_CREATED_AT: 'Luontitiedot puuttuvat',
    MISSING_CUSTOMER_ID: 'Asiakastunnus puuttuu',
    MISSING_CUSTOMER_REF: 'Asiakkaan viite puuttuu',
    MISSING_DATE: 'Päivä puuttuu',
    MISSING_DAYS: 'Päivät puuttuvat',
    MISSING_DEPARTMENT: 'Osasto puuttuu',
    MISSING_DESCRIPTION: 'Kuvaus puuttuu',
    MISSING_DEVIATION_TEXT: 'Poikkeaman teksti puuttuu',
    MISSING_END_LOCATION_LATITUDE: 'Päätepisteen leveysaste puuttuu',
    MISSING_END_LOCATION_LONGITUDE: 'Päätepisteen pituusaste puuttuu',
    MISSING_EVENT_DATA: 'Tapahtumadata puuttuu',
    MISSING_EVENT_TYPE: 'Tapahtumatyyppi puuttuu',
    MISSING_FILE_NAME: 'Tiedostonimi puuttuu',
    MISSING_FROM_DATE: 'Alkamispäivä puuttuu',
    MISSING_ID: 'ID puuttuu',
    MISSING_LOCATION_LATITUDE: 'Sijainnin leveysaste puuttuu',
    MISSING_LOCATION_LONGITUDE: 'Sijainnin pituusaste puuttuu',
    MISSING_LOCATION_POSITION: 'Sijainnin paikka puuttuu',
    MISSING_LOCATION_TIME: 'Sijainnin aika puuttuu',
    MISSING_NAME: 'Nimi puuttuu',
    MISSING_GROUP: 'Ryhmittely puuttuu',
    MISSING_PACKAGE_ID: 'Paketin tunnus puuttuu',
    MISSING_PHONE: 'Puhelinnumero puuttuu',
    MISSING_PLANNER_ID: 'Suunnittelutyökalun id puuttuu',
    MISSING_SERVICE_CODE: 'Palvelukoodi puuttuu',
    MISSING_SHIPMENT_ID: 'Lähetytunnus puuttuu',
    MISSING_SLOT_ID: 'Toimitusajankohdan ID puuttuu',
    MISSING_SLOT_TYPE: 'Toimitusajankohdan tyyppi puuttuu',
    MISSING_SMS_TOKEN: 'SMS-token puuttuu',
    MISSING_START_LOCATION_LATITUDE: 'Aloituspisteen leveysaste puuttuu',
    MISSING_START_LOCATION_LONGITUDE: 'Aloituspisteen pituusaste puuttuu',
    MISSING_TO_DATE: 'Päättymispäivä puuttuu',
    MISSING_ZIP_AREA: 'Postinumeroalue puuttuu',
    MISSING_ZIP_CODE: 'Postinumero puuttuu',
    MISSING_COUNTRY_CODE: 'Maatunnus puuttuu',
    NO_SUCH_USER: 'Ei käyttäjää',
    BILLING_ORDER_AMOUNT_OUT_OF_VALID_RANGE: 'Suurimmat sallitut hintasummat ({{limit, number}}) ylittyvät',
    PARAM_NOT_OF_EXPECTED_TYPE: 'Parametri ei odotettua tyyppiä',
    PARAM_NULL_NOT_ALLOWED: 'Parametri nolla ei ole sallittu',
    PTW_ALREADY_EXISTS: 'Vastaanottajan tunnuksella {{recipientId}} on jo määritetty tuotantoaikaikkuna.',
    QUERY_NAME_MISSING: 'Kyselyn nimi puuttuu',
    QUERY_PARAMS_MISSING: 'Kyselyn parametrit puuttuvat',
    USER_NOT_EXIST_OR_INCORRECT_ROLE: 'Käyttäjää ei ole tai rooli on väärä',
    USER_EXIST_BUT_INCOMPATIBLE_ROLE: 'Käyttäjä on jo olemassa ja hän on toisessa roolissa',
    SLOT_CANNOT_BE_STARTED: 'Toimitusajankohtaa ei voi luoda',
    SLOT_CANNOT_BE_DELETED: 'Toimitusajankohtaa ei voi poistaa',
    COURIER_NOT_PART_OF_DEPARTMENT: 'Lähetti ei kuulu osastoon',
    CONSIGNMENT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Tavaraerää ei voi päivittää virheellisessä tilassa',
    ORDER_DOES_NOT_EXISTS: 'Tilausta ei ole olemassa',
    OPTIMIZE_ALREADY_RUNNING: 'Optimointi on jo käynnissä',
    CANNOT_CHANGE_ORDER: 'Tilausta ei voi muuttaa',
    NO_ACCESS: 'Ei pääsyä',
    NO_RELEVANT_CONSIGNMENTS_OR_SLOTS: 'Ei relevanttia tavaraerää annettuihin toimitusajankohtiin',
    NO_RELEVANT_CONSIGNMENTS: 'Ei relevanttia tavaraerää annettuihin toimitusajankohtiin',
    NO_RELEVANT_SLOTS:
      'Vain reittejä, joita ei ole aloitettu tai jotka on keskeytetty, voidaan optimoida tällä toiminnolla',
    NOT_EQUAL_PICKUP_ADDRESSES:
      'Kaikkien noutoosoitteiden on oltava samat, jotta kaikki lähetykset voidaan rajata yhdelle kuljettajalle',
    NO_SUCH_QUERY: 'Kyselyä ei ole olemassa',
    EXCEL_MISSING_SHIPMENT_ID: 'Lähetystunnus puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_CUSTOMER_REF: 'Asiakkaan viite puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_CUSTOMER_ID: 'Asiakastunnus puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_DEPARTMENT: 'Osasto puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_PACKAGE_ID: 'Paketin tunnus puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_NAME: 'Nimi puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_INVALID_PHONE: 'Virheellinen puhelinnumero solussa {{col}} rivillä {{row}}',
    EXCEL_MISSING_ADDRESS: 'Osoite puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_ZIP_AREA: 'Postinumero puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_ZIP_CODE: 'Kaupunki puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_FROM_DATE: 'Alkamispäivä puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_TO_DATE: 'Päättymispäivä puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_INVALID_FROM_DATE: 'Alkamispäivä ei voi olla tätä päivää aikaisempi. Löytyy solusta {{col}} riviltä {{row}}',
    EXCEL_INVALID_TO_DATE: 'Päättymispäivä ei voi olla ennen tätä päivää. Löytyy solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_NOTIFICATION_SMS: 'Huomautus-SMS puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_SIZE: 'Koko puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_MISSING_ORDERS: 'Laskentataulukossa ei ole tilauksia.',
    EXCEL_MISSING_COUNTRY: 'Maatunnus tai nimi puuttuu solusta {{col}} riviltä {{row}}',
    EXCEL_NO_ACCESS_DEPARTMENT: 'Ei pääsyä osastoon "{{dept_ref}}" rivin {{row}} mukaisesti',
    EXCEL_MISSING_DESCRIPTION: 'Kuvaus puuttuu kohdasta "{{cell}}" rivillä {{row}}',
    EXCEL_MISSING_PICKUP_INSTRUCTIONS: 'Noudon kuvaus puuttuu  solusta"{{cell}}" riviltä {{row}}',
    EXCEL_MISSING_DELIVERY_INSTRUCTIONS: 'Toimituksen kuvaus puuttuu solusta "{{cell}}" riviltä {{row}}',
    EXCEL_TOO_MUCH_DATA: 'Raportti on liian suuri. Harkitse vientiä kapeammalle aikavälille tai vähemmälle osastoille.',
    MISSING_PICKUP_LOCATION_AND_TIME: 'Noudon sijainti ja aika puuttuvat',
    MISSING_EARLIEST_PICKUP_DATE: 'Aikaisin noutoaika puuttuu',
    MISSING_LATEST_PICKUP_DATE: 'Myöhäisin noutoaika puuttuu',
    MISSING_EARLIEST_DELIVERY_DATE: 'Aikaisin toimituspäivä puuttuu',
    MISSING_LATEST_DELIVERY_DATE: 'Myöhäisin toimituspäivä puuttuu',
    INVALID_EARLIEST_PICKUP_DATE: 'Virheelinen noutopäivä',
    INVALID_LATEST_PICKUP_DATE: 'Virheelinen noutopäivä',
    INVALID_EARLIEST_DELIVERY_DATE: 'Virheellinen toimituspäivä',
    INVALID_LATEST_DELIVERY_DATE: 'Virheellinen toimituspäivä',
    CANNOT_MODIFY_ORDERS_FROM_DIFFERENT_SOURCE: 'Excelin API-tilauksia ei voi muokata',
    PICKUP_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST: 'Noutoajan tulee olla ennen toimitusaikaa',
    DELIVERY_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST: 'Aikaisin vientiaika täytyy olla ennen myöhäisintä vientiaikaa',
    CANNOT_DELIVER_ON_A_HOLIDAY: 'Toimitus ei ole mahdollista pyhinä',
    MISSING_TEMPLATE_ID: 'Sivupohjan ID puuttuu',
    TEMPLATE_DOES_NOT_EXIST: 'Sivupohjaa ei ole olemassa',
    TEMPLATE_CANNOT_BE_DELETED: 'Sivupohjaa ei voi poistaa',
    MISSING_TEMPLATE_SLOTS: 'Sivupohjasta puuttuu toimitusajankohta',
    TEMPLATE_NAME_ALREADY_EXISTS: 'Tämän niminen sivupohja on jo olemassa',
    COURIER_ALREADY_EXISTS: 'Lähetti, jolla on tämä puhelinnumero, on jo olemassa',
    ORDER_EXIST_FOR_SERVICE: 'Palvelua ei voi poistaa, koska tälle palvelulle on tilauksia',
    NO_SERVICE_FOUND: 'Lisää palvelu ennen asiakkaan mappauksen lisäämistä',
    CANNOT_DELETE_AS_SERVICE_EXIST: 'Poista asiakaspalvelun mappaus ennen palvelun poistamista',
    SLOT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Toimitusajankohta ei ole oikeassa tilassa tätä päivitystä varten',
    GRAPHHOPPER_UNASSIGNED:
      'Kaikkia lähetyksiä ei voitu määrittää (ajan, kapasiteetin tai muiden tekijöiden vuoksi), tiedot: {{details}}',
    GRAPHHOPPER_REQUEST_FAILED: 'Reitin optimointipyyntö epäonnistui',
    GRAPHHOPPER_LATEST_ARRIVAL_AT_DELIVERY_AFTER_EARLIEST_DEPARTURE:
      'Viimeisin saapumisaika toimitukseen ei voi olla aikaisimman lähtöajan jälkeen – onko noudon aikaikkuna menneisyydessä?',
    GRAPHHOPPER_EARLIEST_GREATER_THAN_LATEST:
      'Aikaisin aika ei voi olla myöhäisintä aikaa myöhempi – onko jokin ajoista menneisyydessä?',
    GRAPHHOPPER_PICKUP_EARLIEST_AFTER_LATEST:
      'Lähetyksen {{shipmentId}} noudon aikaikkuna ei voi olla menneisyydessä ({{pickupEarliest}} - {{pickupLatest}})',
    GRAPHHOPPER_DELIVERY_EARLIEST_AFTER_LATEST:
      'Lähetyksen {{shipmentId}} toimituksen aikaikkuna ei voi olla menneisyydessä ({{deliveryEarliest}} - {{deliveryLatest}})',
    SLOT_CANNOT_BE_EDITED: 'Toimitusajankohta ei ole oikeassa tilassa tätä päivitystä varten',
    INVALID_POSTCODE_AND_COUNTRY_CODE_CANNOT_BE_HANDLED: 'Virheellinen postinumero ja maatunnus',
    INVALID_BASIC_SERVICE_CODE: 'Virheellinen peruspalvelukoodi',
    INVALID_PICKUP_DATE_EARLIEST_FORMAT: 'Virheellinen aikaisimman noutoajan formaatti',
    INVALID_PICKUP_DATE_LATEST_FORMAT: 'Virheellinen myöhäisimmän noutoajan formaatti',
    INVALID_DELIVERY_DATE_LATEST_FORMAT: 'Virheellinen myöhäisimmän toimituspäivän formaatti',
    INVALID_DELIVERY_DATE_EARLIEST_FORMAT: 'Virheellinen aikaisimman toimituspäivän formaatti',
    INVALID_POSTAL_CODE: 'Virheellinen postinumero',
    INVALID_MEASUREMENT_UNIT: 'Virheellinen mittayksikkö',
    MISSING_CONSIGNMENT_SET: 'Tavaraerän asettaminen puuttuu',
    MISSING_UPDATE_INDICATOR: 'Päivitysindikaattori puuttuu',
    MISSING_CONSIGNMENT_ID: 'Tavaraerän ID puuttuu',
    MISSING_REFERENCE_NO: 'Viitteen ID puuttuu',
    MISSING_PACKAGE: 'Paketti puuttuu',
    MISSING_DELIVERY_DATE_EARLIEST: 'Aikaisin toimituspäivä puuttuu',
    MISSING_DELIVERY_DATE_LATEST: 'Myöhäisin toimituspäivä puuttuu',
    MISSING_CONSIGNEE: 'Tavaran vastaanottaja puuttuu',
    MISSING_CONSIGNOR: 'Tavaran lähettäjä puuttuu',
    MISSING_POSTAL_CODE: 'Postinumero puuttuu',
    MISSING_CITY: 'Postinumeroalue puuttuu',
    MISSING_PICKUP_DATE_LATEST: 'Myöhäisin noutoaika puuttuu',
    MISSING_PICKUP_DATE_EARLIEST: 'Aikaisin noutoaika puuttuu',
    MISSING_CONSIGNOR_PARTY_ID: 'Tavaran lähettäjän tyyppitunnus puuttuu',
    INVALID_CUSTOMER_NO_MAPPING: 'Virheellinen asiakasnumeron mappaus',
    INVALID_ROUTING: 'Virheellinen reititys',
    NO_SERVICE_MATCHING_SERVICE_CODE: 'Ei palvelukoodiin sopivaa palvelua',
    NO_SERVICE_MATCHING_DAY_OF_WEEK: 'Ei viikonpäivään sopivaa palvelua',
    NO_SERVICE_MATCHING_PICKUP_AND_DELIVERY_TIMES: 'Ei nouto- ja toimitusaikoihin sopivaa palvelua',
    ORDER_WAS_AFTER_CUTOFF_TIME: 'Tilaus tehtiin vastaanottamisajan päätyttyä',
    OPTIMUS_SERVICE_MUST_HAVE_PICKUP_AND_DELIVERY_TIMES: 'Nouto- ja toimitusajat pakollisia',
    ORDER_CANNOT_BE_MOVED: 'Lähetystä ei voi siirtää, sitä ei saa sijoittaa toimitusajankohtaan',
    MISSING_DESTINATION_DEPARTMENT_ID: 'Määräpaikan osasto puuttuu',
    SHIPMENT_NOT_FOUND: 'Lähetystä ei löydy',
    SHIPMENT_IN_INCORRECT_STATE: 'Lähetys on jo annettu reitille',
    DUPLICATE_EXCEL_IMPORT:
      'Sama tiedostonimi on jo tuotu tähän osastoon tänään. Näet tuonnin tulokset <0>täällä</0>. Muuta tiedostonimi, jos haluat tuoda uudelleen.',
    SHIPMENT_INVALID_QUERY:
      'Sesongin aikana haku mahdollisuuksia on rajoitettu toiminnan varmistamiseksi. Voit etsiä kaikki lähetykset yhdeltä päivältä tai lisää haku parametrejä.',
    DURATION_IS_MORE: 'Ole hyvä ja rajoita hakuasi {{maxDuration}} päivälle.',
    ADDRESS_CANNOT_BE_DELETED: 'Osoitetta käytetään oletus osoitteena joten sitä ei voida poistaa.',
    UNKOWN_ERROR: 'Muutoksia ei voitu tallentaa',
    INCORRECT_STATES_OR_ASSIGNED_TO_SLOT: 'Virheellinen tila tai määrätty reitille',
    CANNOT_MOVE_ORDERS: 'Tilauksia ei voi siirtää',
    DESTINATION_DEPARTMENT_INELIGIBLE: 'Määräysosasto ei kelpaa',
    DEPARTMENT_MISSING_ADDRESS_DETAILS: 'Osastolta puuttuu osoitetietoja',
    MISSING_DELIVERY_PHONE_NUMBER: 'Puhelinnumero puuttuu',
    INVALID_DELIVERY_PHONE_NUMBER: 'Puhelinnumero ei ole kelvollinen',
    ROLE_IN_USE: 'Roolia ei voida poistaa, koska se on käytössä.',
    INVALID_NAME: 'Roolin nimen on oltava yksilöllinen. Rooli tällä nimellä on jo olemassa.',
    BANNER_ALREADY_EXISTS: 'Bannerin nimen on oltava yksilöllinen. Tällä nimellä on jo olemassa banneri.',
    BANNER_NAME_TOO_BIG: 'Bannerin nimi on liian pitkä. Sen on oltava enintään 200 merkkiä.',
    CMS_NEWS_ALREADY_EXISTS: 'Päivityksen nimen on oltava yksilöllinen. Tämän niminen päivitys on jo olemassa.',
    CMS_NEWS_NAME_TOO_BIG: 'Päivityksen nimi on liian pitkä. Sen on oltava enintään 200 merkkiä',
    INVALID_CMS_NEWS_NAME: 'Virheellinen päivityksen nimi',
    TEXT_CANNOT_BE_DELETED:
      'Tekstiä käytetään palvelussa, eikä sitä voi poistaa. Irrota teksti palvelusta poistaaksesi sen.',
    INVALID_INVOICING_STATUS: 'Tilaus on tilassa, joka ei ole laskutukseen kelvollinen',
    ORDER_NOT_READY_FOR_INVOICING: 'Tilaus ei ole valmis laskutukseen',
    ORDER_IS_PAUSED_FROM_INVOICING: 'Tilaus on tauolla laskutuksesta',
    ORDER_IS_EXCLUDED_FROM_INVOICING: 'Tilaus on poissuljettu laskutuksesta',
    MISSING_ORDER_CORRECTION: 'Tilauksesta puuttuu korjaus',
    INVALID_MULTILEG_STATE_FOR_INVOICING: 'Multileg-ryhmässä on tilauksia, jotka eivät ole valmiita laskutukseen',
    DUPLICATE: 'Dublikaattitiedot',
    MISSING_DEPARTMENT_DETAILS: 'Osastolta puuttuu alue- ja postinumerotiedot. Lisää ne ennen jatkamista.',
    INVALID_BANNER_NAME: 'Virheellinen bannerin nimi.',
    INVALID_WHATS_THIS_NAME: 'Virheellinen Mikä tämä on -modaalin nimi.',
    INVALID_CREDIT_ORDER: 'Tilausta ei voi hyvittää, ellei sitä ole laskutettu tai se on jo hyvitetty.',
    OVERLAPPING_BANNERS: 'URL menee päällekkäin olemassa olevan bannerin kanssa.',
    OVERLAPPING_WHATS_THIS_MODALS: 'URL menee päällekkäin olemassa olevan Mikä tämä on -modaalin kanssa.',
    NO_SUGGESTIONS_FOUND_FOR_ORDERS: 'Tilauksille ei ole kelvollisia kuljettajia.',
    noOrdersForDateAndCourier: 'Valitulle päivämäärälle ja yksikölle ei ole tilauksia.',
    INVALID_ORDER_BILLING_CUSTOMER_NUMBER:
      '{{locale}}Tilauslaskutuksen asiakasnumero tyypille - {{orderBillingType}} on joko tyhjä tai virheellinen',
    MISSING_ORDER_BILLING_TYPE: 'Puuttuva tilauslaskutustyyppi.',
    INVALID_ORDER_BILLING_TYPE:
      'Tilauslaskutustyypin on oltava yksi seuraavista: {{orderBillingTypes}}, mutta se oli - {{orderBillingType}}.',
    INVALID_ORDER_BILLING_INFO: 'Virheelliset tilauslaskutustiedot.',
    SMS_SERVICE_NOT_ORDERED: 'SMS-palvelua ei ole tilattu.',
    CANNOT_SEND_SMS_FOR_MESTER_GRONN_FUNERAL: 'Mester Grønn -hautajaispalvelu on tilattu.',
    SLOT_ROUTED_IN_HAPPY_FLOW: 'Aikaväli on reititetty Happy Flow -järjestelmään.',
    SERVICE_LEVEL_SHOULD_NOT_BE_NONE: 'Palvelutaso on ei mitään seuraavalle:',
    SLOT_NAME_ALREADY_CREATED: 'Reitin nimi on jo olemassa.',
    ORDER_IN_INCORRECT_STATE: 'Tilaus on virheellisessä tilassa.',
    ORDER_IN_INCORRECT_STATE_other: 'Tilaus on virheellisessä tilassa.',
    INVALID_PARAMETERS: 'Virheelliset parametrit, {{description}}.',
    FAILED_DELETING_WEBHOOK_SUBSCRIPTION: 'Webhook-tilauksen poistaminen epäonnistui. Yritä myöhemmin uudelleen.',
    DEFAULT_ROLE_ALREADY_EXISTS: 'Toinen rooli {{name}} on jo oletus samalle käyttäjätyypille.',
    GRAPHHOPPER_INVALID_PICKUP_LOCATION:
      "Puuttuvat noutokoordinaatit lähetykselle {{shipmentId}}. Korjaa osoite 'Aseta koordinaatit' -sivulla.",
    GRAPHHOPPER_INVALID_DELIVERY_LOCATION:
      "Puuttuvat toimituskoordinaatit lähetykselle {{shipmentId}}. Korjaa osoite 'Aseta koordinaatit' -sivulla.",
    GRAPHHOPPER_REQUEST_LIMIT_VIOLATED:
      'Graphhopperiin tehtävien pyyntöjen enimmäismäärä on saavutettu, yritä uudelleen minuutin kuluttuafsa',
    VEHICLE_IN_USE:
      'Ajoneuvo on liitetty yksikköön {{units}} eikä sitä voi poistaa. Poista ajoneuvo yksiköstä ja yritä uudelleen.',
    DEPARTMENT_MATRIX_ALREADY_EXISTS: 'Vain yksi osastomatriisi on tuettu',
    CUTOFF_MATRIX_ALREADY_EXISTS: 'Vain yksi cutoff-matriisi on tuettu',
    MISSING_ACCESS_TO_DEPARTMENTS: 'Sinulla ei ole pääsyä osastoihin {{missingDepartments}}',
    DUPLICATE_PLANNED_STOP_LOCATION_NAME:
      'Osastolla ei voi olla useita samalla nimellä olevia suunniteltuja pysähdyspaikkoja. Käytä jokaiselle suunnitellulle pysähdyspaikalle yksilöllistä nimeä.',
    AREA_PINS_TOO_CLOSE:
      'Reitin karttapisteiden on oltava vähintään {{minDistanceInMeters}} metrin päässä toisistaan. Siirrä ne kauemmas toisistaan.',
    DUPLICATE_TEMPLATE_ROUTE_NAME:
      'Toisella tämän osaston toistuvalla reitillä on sama nimi. Samannimiset reitit yhdistetään yhdeksi reitiksi käyttöönoton yhteydessä, joten valitse eri nimi.',
    PLANNED_STOP_LOCATION_IN_USE:
      'Suunniteltuja pysähdyspaikkoja - [{{locations}}] ei voi muokata tai poistaa, koska ne ovat jo käytössä.',
    TEMPLATE_IS_DEFAULT_FOR_DEPARTMENT:
      'Mallia ei voi poistaa, koska se on asetettu osaston oletusmalliksi. Vaihda osaston oletusmalli ennen tämän mallin poistamista.'
  },
  customer: {
    useTerminalAddressModalHeading: 'Käytä terminaaliosoitetta',
    useTerminalAddressModalDescription:
      '"Kyllä" tarkoittaa, että tilauksia luotaessa käytetään osaston terminaaliosoitetta. "Ei" tarkoittaa, että terminaaliosoitteen käyttölogiikka ohitetaan.',
    settings: {
      webhook: {
        overviewTitle: 'Webhook-asetukset',
        count: '{{count}} tilaus',
        count_other: '{{count}} tilausta',
        noSubscriptions: 'Sinulla ei ole tilauksia tällä hetkellä',
        events: {
          prefix: 'Tilattu: ',
          all: 'kaikki',
          suffix: ' tapahtumat'
        },
        state: {
          running: 'Käynnissä',
          paused: 'Keskeytetty'
        },
        event: {
          CREATED: 'tilaus on rekisteröity',
          ROUTE_PLANNING_COMPLETE: 'toimitusreitti on vahvistettu',
          COLLECTED: 'kuljettaja nouti tavarat',
          DELIVERED: 'kuljettaja toimitti tavarat',
          DEVIATED: 'kuljettaja on lisännyt tilaukseen poikkeaman',
          SCANNED: 'tilaus on kulkenut välikuljetusterminaalin kautta',
          ARRIVED_AT_TERMINAL: 'tilaus on saapunut jakeluterminaaliin',
          DAMAGED: 'tilaus on vaurioitunut',
          RETURNED: 'kuljettaja palautti tavarat terminaaliin',
          PICKUP_ETA_SMS_SENT: 'SMS, jossa arvioitu noutoaika, on lähetetty',
          ETA_SMS_SENT: 'SMS, jossa arvioitu toimitusaika, on lähetetty',
          PRE_ADVICE_PULL_SMS_SENT: 'SMS, jossa mahdolliset toimitusikkunat, on lähetetty',
          DELIVERY_TIME_ORDERED: 'vastaanottaja on valinnut toimitusajan',
          PRE_ADVICE_PUSH_SMS_SENT: 'SMS, jossa tilattu toimitusikkuna, on lähetetty vastaanottajalle',
          PICKUP_SMS_SENT: 'SMS tulevasta toimituksesta on lähetetty vastaanottajalle',
          APARTMENT_INFORMATION_UPDATED: 'vastaanottaja on päivittänyt toimitustiedot'
        },
        create: 'Napsauta painiketta luodaksesi Webhook-määrityksen',
        delete: {
          title: 'Poista tilaus',
          description: 'Tätä toimintoa ei voi peruuttaa',
          successfullyDeleted: 'Webhook-tilaus poistettiin onnistuneesti'
        },
        newOrEdit: {
          createTitle: 'Luo uusi webhook-määritys',
          editTitle: 'Muokkaa webhook-määritystä',
          created: 'Uusi webhook-määritys luotiin onnistuneesti',
          updated: 'Webhook-määritys päivitettiin onnistuneesti',
          endpoint: 'Endpoint',
          endpointDescription: 'Anna URL-osoite, johon tapahtumatiedot lähetetään',
          httpAuthentication: 'HTTP Basic -todennus',
          username: 'Käyttäjätunnus',
          password: 'Salasana', // betterleaks:allow a form label, not a secret
          retryPolicy: 'Uudelleenyrityskäytäntö',
          retryPolicyDescription:
            'Jos webhook epäonnistuu, määritä uudelleenyritysten määrä ja viiveet niiden välillä.',
          retry: '{{count}} uudelleenyritys',
          retry_other: '{{count}} uudelleenyritystä',
          retryDescription: 'Uudelleenyritysten määrä',
          delay: {
            description: 'Viive ennen uudelleenyritystä',
            value: 'Viive {{seconds}} sekuntia'
          },
          pause: 'Keskeytä tämä tilaus toistaiseksi',
          pauseTooltip:
            'Keskeytys asettaa lähetettävät tapahtumat jonoon, kunnes keskeytys päätetään. Tämän jälkeen jonossa olevat tapahtumat lähetetään uudelleen.',
          validation: {
            endpointError: 'Anna kelvollinen URL-osoite',
            endpointRequired: 'URL-osoite on pakollinen',
            usernameRequired: 'Käyttäjätunnus on pakollinen',
            passwordRequired: 'Salasana on pakollinen',
            passwordNotLongEnoughError: 'Salasanan on oltava vähintään 8 merkkiä pitkä',
            noEventSelectedError: 'Valitse vähintään yksi tapahtuma',
            retryDelayRequired: 'Uudelleenyrityksen viive on pakollinen'
          }
        }
      }
    },
    returnLastLegUpdated: 'Palautuksen viimeisen osuuden tila päivitetty',
    returnLastLegModalHeading: 'Luo paluuosuus',
    returnLastLegModalDescription:
      'Valitsemalla "kyllä" tarkoittaa, että jaamme tilauksen kahteen osaan ja lisäämme palautusosuuden. "Ei" tarkoittaa, ettei palautusosuutta tarvitse luoda. "Ei määritetty" tarkoittaa, että palautuksen käsittelysääntöä ei ole määritelty tietylle asiakkaalle.',
    connectMatrices: 'Yhdistä matriisit',
    customerMatrices: 'Asiakasmatriisit',
    customerMatricesIngress: 'Yhdistä asiakasnumero olemassa oleviin matriiseihin.',
    useTerminalAddressUpdated: 'Terminaaliosoitteen käytön tila päivitetty',
    brandedTrackingModalHeading: 'Brändätty seurannan laskutus',
    scanToCreatePackages: {
      title: 'Skannaa luodaksesi paketteja',
      enabled: 'Käytössä',
      disabled: 'Poistettu käytöstä',
      label: 'Käytä skannausta pakettien luomiseen',
      details:
        'Kun skannaus pakettien luomista varten on käytössä, kuriirin on pakko skannata paketit noudon yhteydessä. Skannatut paketit päivittyvät automaattisesti lähetykselle',
      success: 'Skannaus pakettien luomista varten on päivitetty'
    },
    invoiceSplit: {
      title: 'Laskun jakaminen',
      legend: 'Selitys',
      label: 'Aseta laskun jako',
      NotSet: 'Ei asetettu',
      Department: 'Osasto',
      Service: 'Palvelu',
      Custom: 'Mukautettu',
      columLabel: 'Nimi',
      addedItems: 'Lisätyt laskutussäännöt ({{count}})',
      newItemLabel: 'Kirjoita laskun jako',
      existingItem: 'Teksti on jo olemassa. Kokeile hakea tekstiä alta.',
      existingItemShort: 'Teksti on jo olemassa.',
      emptyItem: 'Teksti ei voi olla tyhjä.',
      updated: 'Laskun jako lisättiin onnistuneesti'
    },
    activateNPSFromDate: 'Ota NPS käyttöön alkaen',
    activateNPSFromDateIngress:
      'Aseta aloituspäivämäärä NPS:n (Net Promoter Score) aktivoinnille Medalliasta. Tämä toiminto edellyttää, että asiakas on määritetty myös Medalliaan.',
    npsFromDateUpdated: 'NPS:n aloituspäivämäärä on muutettu',
    AddEdit: 'Lisää/muokkaa',
    startTypingPlaceHolder: 'Aloita kirjoittaminen',
    findCustomer: 'Löydä asiakas',
    manageCustomers: 'Hallitse asiakkaita',
    searchAndSelect: 'Etsi ja valitse asiakas',
    changeCustomer: 'Vaihda asiakasta',
    customerPlaceHolder: 'Hae asiakkaita',
    emailRecipients: 'Sähköpostin vastaanottajat',
    smsRecipients: 'SMS-vastaanottajat',
    addEditEmails: 'Lisää/muokkaa sähköposteja',
    addEditSms: 'Lisää/muokkaa SMS:iä',
    addEditDeviations: 'Lisää/muokkaa poikkeamia',
    live: 'Live',
    customer: 'Asiakas',
    groups: {
      titleSingular: 'Asiakasryhmä',
      titleWithCount: '{{count}} asiakasryhmää',
      name: 'Ryhmän nimi',
      description: 'Kuvaus',
      numberOfCustomers: 'Asiakkaiden määrä',
      none: 'Ei asiakasryhmiä',
      new: 'Uusi asiakasryhmä',
      edit: 'Muokkaa asiakasryhmää',
      searchCustomer: 'Etsi asiakas',
      members: 'Asiakkaat ryhmässä',
      save: 'Tallenna',
      deleteConfirm: 'Poistetaanko {{name}}?',
      deleteDescription: 'Tätä toimintoa ei voi peruuttaa',
      deleted: 'Asiakasryhmä poistettu',
      mustProvideName: 'Anna ryhmän nimi',
      cannotDelete: 'Asiakasryhmää ei voi poistaa, koska sitä käytetään ennakkoilmoitussäännössä.'
    },
    customerTitle: 'Asiakkaat',
    customerNo: 'Asiakasnumero',
    name: 'Nimi',
    emailToSender: 'Sähköposti lähettäjälle',
    emailSubscriptions: 'Sähköpostitilaukset',
    emailToSenderDescription:
      'Määritä oletusilmoitukset kaikille tämän asiakasnumeron tilauksille, esimerkiksi tilauksen rekisteröinti ja toimitukset.',
    deviations: 'Poikkeamat',
    deviationsDescription: 'Määritä asiakaskohtaiset poikkeamat lähettisovellukseen.',
    add: 'Lisätä',
    noOrders: "Ei tilauksia Glow'ssa",
    noOrdersDescription: "Glow'ssa  ei ole tilauksia niillä asiakkailla, joihin sinulla on pääsy.",
    choose: 'Ole hyvä ja valitse asiakas',
    search: 'Etsi',
    customerNumber: 'Asiakasnumero',
    customerNumberAlreadyExists: 'Asiakasnumero on jo olemassa',
    accountingType: 'Laskentatyyppi',
    accountingTags: 'Kirjanpidon tunnisteet',
    isDeleted: 'On poistettu',
    deletedCannotBeUsed: 'Asiakas on poistettu, eikä sitä voi käyttää. Valitse toinen asiakas.',
    scanOnPickup: {
      title: 'Skannaa paketit noudettaessa',
      ingress: 'Ota käyttöön, jos lähetti on pakotettava skannaamaan paketit noudettaessa.'
    },
    searchHint:
      'Etsi lähetyksiä lähetystunnuksella, asiakkaan viitteellä, paketin tunnuksella, toimituksen nimellä tai osoitteella.',
    senderName: 'Lähettäjän nimi',
    senderNameIngress: 'Ohita Glow’ssa asetettu asiakkaan nimi SMS-ilmoituksia lähetettäessä.',
    addSenderName: 'Lisää lähettäjän nimi',
    senderNameAdded: 'Lähettäjän nimi lisätty',
    addInvoiceHDOrdersFromDate: 'Lisää aloituspäivämäärä HD-tilausten laskutukselle Glow’n kautta',
    invoiceHDOrdersFromDate: 'Laskuta HD-tilaukset Glow’ssa alkaen',
    invoiceHDOrdersFromDateDescription:
      'Aseta päivämäärä, jolloin Glow Pricing Engine otetaan käyttöön HD-asiakkaille.',
    invoiceHDOrdersFromDateAdded: 'HD-tilausten Glow-laskutuksen aloituspäivämäärä on muutettu',
    billingCustomerNumber: 'Laskutusasiakasnumero',
    billingCustomerNumberIngress: 'Ohita laskunumero, jos laskutus tapahtuu eri asiakasnumerolle.',
    addBillingCustomerNumber: 'Lisää Laskutusasiakasnumero',
    billingCustomerNumberAdded: 'Laskutusasiakasnumero Lisätty',
    searchPage: {
      fromDate: 'Alkamispäivä',
      toDate: 'Päättymispäivä',
      today: 'Tänään',
      tomorrow: 'Huomenna',
      yesterday: 'Eilinen',
      last30days: 'Viimeiset 30 päivää',
      plusMinus15Days: '+/- 15 päivää',
      plusMinus30Days: '+/- 30 päivää'
    },
    smsText: {
      title: 'SMS Text',
      ingress: 'Määritä asiakaskohtaiset tekstit vastaanottajille lähetettäviin SMS-viesteihin.',
      addEditSmsText: 'Lisää/muokkaa tekstiviestiä',
      smsTextUpdated: 'SMS-teksti lisätty/päivitetty',
      en: 'ENG',
      se: 'RUO',
      no: 'NOR',
      fi: 'FIN',
      dk: 'TAN',
      fr: 'RAN',
      description: 'Kuvaus',
      smsType: 'Ilmoitustyyppi',
      smsTypeTexts: {
        common: 'SMS',
        preadvice: 'Ennakkoilmoitus',
        pickup: 'Seuranta-SMS',
        pre_pickup: 'Ennakkoseuranta-SMS',
        manual_delay: 'Manuaalinen viivästys-SMS',
        eta_pickup: 'ETA-nouto-SMS',
        eta_delivery: 'ETA-toimitus-SMS',
        flex_delivery_confirmation: 'Flex-toimituksen vahvistus-SMS',
        advise: 'Ilmoitus-SMS',
        delivery_confirmation: 'Toimitusvahvistus-SMS',
        pre_advice_push: 'Push-SMS',
        pre_advice_push_for_prebooked: 'Push-SMS ennakkoon varanneille asiakkaille',
        pre_advice_push_return: 'Push-palautus-SMS',
        pre_advice_push_email: 'Push-sähköposti',
        pre_advice_push_2nd: 'Push 2. ennakkoilmoitus -SMS',
        pre_advice_push_2nd_email: 'Push 2. ennakkoilmoitus -sähköposti',
        pre_advice_push_return_to_sender_email: 'Push palautus lähettäjälle -sähköposti',
        pre_advice_pull: 'Pull-SMS',
        pre_advice_pull_email: 'Pull-sähköposti',
        pre_advice_pull_reminder: 'Pull-muistutus-SMS',
        pre_advice_pull_reminder_email: 'Pull-muistutussähköposti',
        pre_advice_pull_reminder_to_sender_email: 'Pull-muistutus lähettäjälle -sähköposti',
        pre_advice_pull_return_to_sender_email: 'Pull palautus lähettäjälle -sähköposti',
        pre_advice_return: 'Palautustoimitus-SMS',
        pre_advice_return_email: 'Palautustoimitussähköposti',
        pre_advice_return_reminder: 'Palautustoimituksen muistutus-SMS',
        pre_advice_return_reminder_email: 'Palautustoimituksen muistutussähköposti',
        pre_advice_return_2nd: 'Palautustoimitus 2. ennakkoilmoitus -SMS',
        pre_advice_return_2nd_email: 'Palautustoimitus 2. ennakkoilmoitus -sähköposti',
        pre_advice_return_return_to_sender_email: 'Palautustoimitus palautus lähettäjälle -sähköposti',
        pre_advice_pup: 'PUP-SMS',
        pre_advice_pup_email: 'PUP-sähköposti',
        pre_advice_pup_reminder: 'PUP-muistutus-SMS',
        pre_advice_pup_reminder_email: 'PUP-muistutussähköposti',
        pre_advice_pup_reminder_to_sender_email: 'PUP-muistutus lähettäjälle -sähköposti',
        pre_advice_pup_return_to_sender_email: 'PUP palautus lähettäjälle -sähköposti',
        delivery: 'Toimitus SMS',
        deviated: 'Toimituspoikkeama-SMS',
        pre_advice_push_prebooked_recycle_sms: 'Push ennakkoon varattu kierrätys-SMS'
      }
    },
    showNotCollected: 'Ei noudettu',
    booking: {
      pickupReady: 'Nouto valmis',
      pickup: 'Nouto',
      delivery: 'Toimitus',
      deliveryAvailable: 'Toimitus saatavilla',
      serviceMessage: 'Lisää sekä nouto- että toimitustiedot nähdäksesi saatavilla olevat palvelut',
      priceComment: 'Sinua laskutetaan Bringin kanssa tehdyn asiakassopimuksesi mukaisesti. Hinta ei sisällä maksuja.',
      serviceUnavailable: 'Valittu palvelu ei ole saatavilla postinumerolle {{postalCode}}',
      recipientPrice: 'Tilaajan hinta:',
      customerContactPlaceholder: 'Tilaajan nimi (Etu ja sukunimi) – Tämä kenttä näkyy asiakkaan laskussa'
    },
    email: {
      addToList: 'Lisää sähköposti listaan',
      addChangesToList: 'Lisää sähköpostimuutokset listaan',
      emailTitle: 'Sähköposti asiakkaalle',
      getNotificationsFor: 'Vastaanota ilmoitukset',
      emailAddress: 'E-mail address',
      emailAddressError: 'Anna sähköpostiosoite',
      createdEvent: 'Rekisteröity',
      collectedEvent: 'Nouto',
      deliveredEvent: 'Toimitus',
      returnToSender: 'Palautus lähettäjälle',
      reminderToSender: 'Muistutus lähettäjälle',
      save: 'Tallenna',
      email: 'Sähköposti',
      edit: 'Muokkaa',
      delete: 'Poista',
      emailExists: 'Sähköposti on jo olemassa',
      invalidEmail: 'Virheellinen sähköposti',
      true: 'yes',
      false: 'no',
      claimsReported: 'Vastaanottajan ilmoittamat reklamaatiot',
      claims: 'Reklamaatiot',
      notificationType: {
        standard: 'Vakiotiedot',
        hdPreAdvice: 'HD-ennakkoilmoitus',
        reportsFromRecipients: 'Vastaanottajien ilmoitukset',
        error: 'Anna ilmoitusten tyyppi'
      },
      customizedNotifications: 'Mukautetut ilmoitukset ({{count}})',
      mustAddEmailToList:
        'Jotta sähköpostiosoitteet tallentuvat, kun painat Lisää asetus, sinun on lisättävä ne listaan',
      informationToCustomer: 'Tiedot asiakkaalle',
      returnToCustomer: 'Palautus asiakkaalle',
      addEmailToList: 'Lisää sähköposti listalle',
      registeredEmailSubscription: 'Rekisteröity sähköpostitilaus',
      updateEmail: 'Päivitä sähköposti',
      noRegisteredEmails: 'Ei rekisteröityjä sähköposteja',
      detailsSavedSuccessfully: 'Sähköposti lähettäjälle tallennettiin onnistuneesti'
    },
    customerDeviations: {
      new: 'Lisää uusi poikkeama',
      deviationTitle: 'Asiakkaan poikkeamat',
      addDeviation: 'Lisää uusi poikkeama',
      editDeviation: 'Muokkaa poikkeamaa',
      en: 'ENG',
      sv: 'RUO',
      nb: 'NOR',
      fi: 'FIN',
      dk: 'TAN',
      event: 'Tapahtuma',
      reason: 'Syy',
      action: 'Toimenpide',
      submit: 'Lähetä',
      deviationType: 'Poikkeaman syy',
      description: 'Kuvaus',
      code: 'Koodi',
      edit: 'Muokkaa',
      delete: 'Poista',
      deviationAdded: 'Poikkeama lisätty',
      deviationEdited: 'Poikkeamaa muokattu',
      deviationExists: 'Poikkeama on jo olemassa',
      deviationDeleted: 'Poikkeama poistettu',
      deviation: 'Poikkeama',
      deviationCode: 'Poikkeamakoodi',
      deviationCodesLabel: 'Poikkeamakoodit'
    },
    customerInfo: 'Asiakastiedot',
    customerInformation: 'Asiakastiedot',
    customerName: 'Asiakkaan Nimi',
    invoicingAddress: 'Laskutusosoite',
    organisationNumber: 'Organisaation Numero',
    visitingAddress: 'Käyntiosoite',
    creditBlocked: 'Luotto estetty',
    creditBlockedFrom: 'Luotto estetty päivämäärästä',
    creditBlockedFromInfo: 'Estä tämän asiakkaan luotto valitusta päivämäärästä alkaen',
    creditBlockedIngress: 'Aseta viimeinen päivämäärä, jolloin tälle asiakkaalle voi luoda tilauksia Glow’ssa.',
    from: 'Päivämäärä',
    address: 'Osoite',
    zipCode: 'Postinumero',
    zipArea: 'Paikka',
    country: 'Maa',
    edit: 'Muokata {{name}}',
    selectCountry: 'Valitse Maa',
    settingsInGlow: 'Asetukset Glow’ssa',
    addSetting: 'Lisää asetus',
    editSetting: 'Muokkaa asetusta',
    addNewCustomer: 'Lisää uusi asiakas',
    bookingPageModalHeading: 'Varaus Asiakasportaalissa',
    bookingPageModalDescription:
      'Asiakkaan tulisi pystyä varaamaan lähetyksiä tällä asiakastunnuksella Glow asiakas portaalissa',
    bookingActive: 'Päällä',
    bookingInactive: 'Pois päältä',
    brandedTrackingActive: 'Päällä',
    brandedTrackingInactive: 'Pois päältä',
    brandedTrackingAccessUpdated: 'Brändätyn seurannan laskutusstatus päivitetty',
    brandedTrackingModalDescription: 'Ota käyttöön aktivoidaksesi brändätyn seurannan laskutuksen.',
    bookingPageAvailable: 'Kyllä',
    bookingPageHidden: 'Ei',
    customerBookingPageAccessUpdated: 'Varaussivun käyttöoikeus päivitetty',
    token: {
      warningDark: 'Tämä asiakas on estetty eikä voi luoda varauksia. Poista esto aktivoidaksesi asiakkaan.',
      warningLight: 'Muista kopioida API-avain nyt. Et voi nähdä sitä uudelleen!',
      success: 'Olet jo luonut API-avaimen tälle asiakkaalle',
      allowApiKey: 'Salli API-avain asiakkaalle',
      allowApiKeyDescription:
        'Ennen kuin luot API-avaimen, sinun on ensin sallittava tämän toimenpiteen suorittaminen.',
      allowApiKeyButtonText: 'Salli API-avain',
      apiKeyCopied: 'API-avain on kopioitu',
      generateApiKeyDescription:
        'API-avain on ainutlaatuinen avain asiakasta kohden. Avain käytetään, kun asiakkaasi tekee varauksen asiakasportaalissa. Lue lisää API:stamme <0>täältä</0>.',
      generateApiKey: 'Luo API-avain'
    },
    addNPSFromDate: 'Lisää aloituspäivämäärä NPS:lle',
    bookingPage: 'Varaussivu',
    bookingPageCustomerPortal: 'Varaussivu asiakasportaalissa',
    bookingPageIngress:
      'Poista varaus käytöstä, jos asiakkaan ei pidä pystyä varaamaan lähetyksiä tällä asiakasnumerolla Glow-asiakasportaalissa.',
    returnAddressModalHeading: 'Palautusosoite',
    removeReturnAddressModalHeading: 'Poista nykyinen palautusosoite',
    removeReturnAddressConfirm: 'Haluatko varmasti poistaa nykyisen palautusosoitteen?',
    returnAddressModalDescription: 'Syötä palautusosoite, jota käytetään, kun tavaroita palautetaan terminaalista',
    returnAddressUpdated: 'Palautusosoite päivitetty',
    returnAddressRemoved: 'Palautusosoite poistettu',
    nonInvoiceable: 'Ei lasku',
    internalNonInvoiceable: 'Sisäinen / Asiakasta ei laskuteta'
  },
  texts: {
    tabTitle: 'Tekstit ja käännökset',
    successfullyAdded: 'Teksti lisättiin luetteloon onnistuneesti',
    successfullyUpdated: 'Teksti päivitettiin onnistuneesti',
    successfullyDeleted: 'Teksti poistettiin onnistuneesti',
    allTextsAndVases: 'Luettelo kaikista teksteistä ja käännöksistä',
    searchText: 'Hae tekstiä',
    deleteModalTitle: 'Poista teksti',
    deleteModalDescription: 'Tätä toimintoa ei voi peruuttaa',
    createNewText: 'Luo uusi teksti',
    title: 'Tekstit',
    update: 'Päivitä teksti',
    name: 'Tekstin nimi',
    group: 'Ryhmittely',
    edit: 'Muokkaa',
    delete: 'Poista',
    add: 'Lisää teksti',
    reset: 'Resetoi',
    confirmDelete: 'Haluatko varmasti poistaa tekstin?',
    added: 'Teksti lisätty',
    deleted: 'Teksti poistettu',
    updated: 'Teksti päivitetty',
    nameToolTip: 'Nimi näytetään, kun tekstiä linkitetään palveluun'
  },
  billingType: {
    day: 'päivä',
    evening: 'ilta',
    weekend: 'viikonloppu',
    weekendEvening: 'viikonloppuilta'
  },
  importExport: {
    dropText: 'Pudota tiedosto tähän ladataksesi',
    export: 'Siirrä',
    exportAddresses: 'Siirrä asiakkaan osoitteet exceliin',
    importExcel: 'Tuo Excel-tiedostosta',
    imported: 'tuodut osoitteet',
    or: 'tai',
    selectFile: 'Valitse tiedosto',
    uploadingFile: 'Lataaminen...'
  },
  customMeasurements: {
    name: 'Nimi',
    weight: 'Paino',
    height: 'Korkeus',
    length: 'Pituus',
    width: 'Leveys',
    heading: 'Mukautetut tavarat',
    error: 'Tallennus epäonnistui: ',
    confirmDelete: 'Oletko varma, että haluat poistaa tämän tavaratyypin?',
    new: 'Luo uusi',
    customGoodsTypes: 'Mukautetut tavarat',
    defaultGoodsTypes: 'Esitallennetut tavarat',
    invalidName: 'Nimessä on oltava vähintään yksi kirjain'
  },
  unresolved: {
    unresolvedAddresses: 'Selvittämättömiä osoitteita',
    allResolved: 'Selvittämättömiä osoitteita ei löytynyt!',
    address: 'Osoite',
    noOfShipments: 'Lähetysten määrä',
    shipment: 'lähetys',
    shipment_other: 'lähetykset',
    shipmentNumber: 'Lähetyksen numero',
    customerRef: 'Asiakkaan viite',
    senderName: 'Lähettäjän nimi',
    senderPhone: 'Lähettäjän puhelinnumero',
    recipientName: 'Vastaanottajan nimi',
    recipientPhone: 'Vastaanottajan puhelinnumero',
    searchAndSetLocation: 'Etsi ja kohdista osoite',
    setALocationToContinue: 'Kohdista osoite jatkaaksesi',
    resolveAddress: 'Selvitä osoite',
    suggestedAddressFound: 'Ehdotettu osoite',
    thereIsOneUnresolvedAddress: '{{count}} selvittämätön osoite',
    thereIsOneUnresolvedAddress_other: '{{count}} selvittämätöntä osoitetta'
  },
  optimizing: {
    title: 'Optimointi',
    optimizingId: 'Optimointi-ID',
    reqTime: 'Pyyntöaika',
    respTime: 'Vastausaika',
    showOnlyErrors: 'Näytä vain virheet',
    department: 'Osasto',
    userName: 'Käyttäjä',
    graphID: 'ID',
    request: 'Pyyntö',
    response: 'Vastaus',
    error: 'Virhe',
    viewReqResp: 'Näytä',
    status: 'Tila',
    totalTime: 'Aika',
    selectOptimizingObjective: 'Valitse optimointitavoite',
    cancelRequest: 'Peruuta pyyntö',
    noOptimizations: 'Valitulle haulle ei löytynyt optimointeja',
    viewRaw: 'Näytä raakadata',
    quality: {
      STANDARD: 'Vakiotaso',
      HIGH: 'Korkea',
      PREMIUM: 'Premium'
    },
    objectives: {
      completion_time: 'Lyhin kokonaiskuljetusaika (oletus)',
      min_vehicles: 'Pienin ajoneuvojen kokonaismäärä',
      work_time: 'Tasainen toimitusaika',
      number_of_deliveries: 'Tasainen toimitusten määrä',
      deliveries_and_work_time: 'Tasainen työaika ja toimitusten määrä'
    },
    kbSize: 'Pyynnön koko (KB)',
    showAll: 'Näytä kaikki',
    numberOfShipments: 'Lähetysten määrä',
    numberOfVehicles: 'Ajoneuvojen määrä',
    processingTime: 'Käsittelyaika',
    stats: 'Tilastot',
    addToCompare: 'Lisää ajo vertailuun',
    noRunsToCompare: 'Tälle päivälle ei ole muita valmiita ajoja',
    removeFromCompare: 'Poista vertailusta',
    noStats: 'Ei tilastoja',
    routesUsed: 'Käytetyt reitit',
    leftOut: 'Jätetty pois',
    stops: 'Pysähdykset',
    distanceKm: 'Etäisyys (km)',
    drivingTime: 'Ajoaika',
    waitingTime: 'Odotusaika',
    routeTime: 'Kokonaisreittiaika',
    longestRoute: 'Pisin reitti',
    type: 'Tyyppi'
  },
  date: {
    date: 'Päivämäärä',
    today: 'Tänään',
    tomorrow: 'Huomenna',
    yesterday: 'Eilen',
    dateAndTime: 'Päivä ja ajat',
    from: 'Alkaen',
    fromDate: 'Alkupäivämäärä',
    rangeOptions: {
      '15d': '+/- 15 päivää',
      '30d': '+/- 30 päivää',
      custom: 'Mukautetut päivämäärät',
      last30d: 'Viimeiset 30 päivää',
      last7d: 'Viimeiset 7 päivää',
      month: 'Kuukausi',
      months: 'Kuukaudet',
      today: 'Tänään',
      tomorrow: 'Huomenna',
      yesterday: 'Eilen',
      thisMonth: 'Tässä kuussa',
      lastMonth: 'Viime kuussa'
    },
    to: 'Asti',
    toDate: 'Loppupäivämäärä'
  },
  areaSequence: {
    title: 'Järjestysalue',
    description:
      'Lisää enintään {{max}} karttapistettä ohjaamaan toimitusjärjestystä. Kutakin pistettä lähimpänä oleva toimitus priorisoidaan valitussa järjestyksessä, ja pisteiden väliset toimitukset optimoidaan tehokkaimmaksi reitiksi. Tämä ohjaa järjestystä, mutta ei pakota kokonaisia alueita.',
    order: 'Alueiden järjestys',
    orderWhileEditing: 'Alueiden järjestys - vedä kortteja muuttaaksesi järjestystä',
    added: '{{count}}/{{max}} aluetta lisätty',
    save: 'Tallenna alue',
    unsaved: 'Tallenna tai peruuta kartta-alueiden muutokset ennen reitin tallentamista.',
    pin: 'Alue {{number}}',
    overlap: 'Alue {{number}} on päällekkäin alueen {{other}} kanssa. Siirrä toinen niistä kauemmas.',
    maxReached: 'Voit lisätä enintään {{max}} karttapistettä.',
    tool: {
      add: 'Lisää alue',
      move: 'Siirrä alueita',
      delete: 'Poista alueita'
    },
    hint: {
      add: 'Lisää alue napsauttamalla karttaa',
      move: 'Siirrä aluetta vetämällä merkkiä. Tallenna säilyttääksesi muutokset tai Peruuta hylätäksesi ne.',
      delete: 'Poista alue napsauttamalla merkkiä'
    }
  },
  routeReceipt: {
    printRouteReceiptList: 'Tulosta kuittauslista',
    noRoutesInfoAvailable: 'Reittitietoja ei ole saatavilla'
  },
  homeDeliveryRouteList: {
    receiptList: 'Kuittauslista',
    shipments: 'Toimitukset',
    weight: 'Paino',
    volume: 'Tilavuus',
    bookedWeight: 'Varattu paino{{unit}}',
    bookedVolume: 'Varattu tilavuus{{unit}}',
    sender: 'Lähettäjä',
    package: 'Lähetys',
    shipmentNo: 'Toimitusnumero',
    ref: 'Viite',
    recipient: 'Vastaanottaja',
    time: 'Aika',
    mobile: 'Puhelinnumero',
    other: 'Muuta',
    attemptedDelivery: 'Poikkeamat',
    receipt: 'Allekirjoitus',
    dateOfBirth: 'Syntymäaika',
    signature: 'Allekirjoitus',
    nameClarification: 'Nimi',
    goodsLine1: 'Muista tarkastaa lähetys näkyviltä vaurioilta ennen allekirjoittamista',
    goodsLine2: 'Jos näkyviä vaurioita löytyy, kuljettajan tulee merkitä ne ennen vastaanottajan allekirjoitusta',
    damage: 'Vaurio',
    missing: 'Puuttuu',
    packageNumber: 'Lähetysnumero',
    comments: 'Kommentti'
  },
  columnCategories: {
    aboutTheShipment: 'Tietoa lähetyksestä',
    goods: 'Tavarat',
    timeAndDate: 'Aika ja päivämäärä',
    planning: 'Suunnittelu',
    pickupInformation: 'Noutotiedot',
    customer: 'Asiakas',
    deliveryInformation: 'Toimitustiedot',
    originalSender: 'Alkuperäinen lähettäjä',
    originalDelivery: 'Alkuperäinen toimitus',
    service: 'Palvelu',
    preAdvice: 'Esi-ilmoitus',
    invoicingInformation: 'Laskutustiedot'
  },
  shipment: {
    offeredOrdersPending: 'Tarjotut tilaukset odottavat vastausta',
    shipment: 'Lähetys',
    multileg: 'multileg',
    pickupLeg: 'Nouto-osuus',
    deliveryLeg: 'Toimitusosuus',
    customer: 'Asiakas',
    customerContact: 'Asiakaskontakti',
    customerReference: 'Asiakkaan viite',
    customerNumber: 'Asiakasnumero',
    route: 'Reitti',
    service: 'Palvelu',
    additionalServices: 'Lisäpalvelut',
    quantity: 'Määrä',
    totalWeight: 'Kokonaispaino',
    totalVolume: 'Kokonaisvolyymi',
    totalLoadingMeters: 'Kokonaislatausmittarit',
    totalPalletFootPrints: 'Kokonais lavapaikka',
    goodsInfo: 'Tiedot tavarasta',
    packages: 'Pakettimäärä',
    pickupInfo: 'Noutotiedot',
    pickupDate: 'Noutopäivä',
    pickupTime: 'Noutoaika',
    pickupInstructions: 'Nouto-ohjeet',
    deliveryInfo: 'Toimitustiedot',
    deliveryDate: 'Toimituspäivä',
    deliveryTime: 'Toimitusaika',
    eta: 'ETA',
    ata: 'ATA',
    receiverReference: 'Vastaanottajan viite',
    deliveryInstructions: 'Toimitusohjeet',
    trackingPage: 'Vastaanottajan seurantasivu',
    internalNote: 'Sisäinen huomautus',
    name: 'Nimi',
    address: 'Osoite',
    zipCode: 'Postinumero',
    zipArea: 'Kaupunki',
    phone: 'Puhelin',
    secondPhone: 'Puhelin 2',
    email: 'Sähköposti'
  },
  bookingTimeWindow: {
    week: 'Viikko',
    bookButton: 'Tilaa',
    customButton: 'Muokattu aikaikkuna',
    removeBookingButton: 'Poista tilaus',
    noBookingYet: 'Ei vielä varausta',
    serverError: 'Tapahtui virhe. Yritä myöhemmin uudelleen.',
    previousButton: 'Takaisin',
    nextButton: 'Seuraava',
    noAvailableDeliveryTimes: 'Ei saatavilla olevia toimitusaikoja tässä kuussa',
    customTimeTitle: 'Aseta muokattu aikaikkuna lähetykselle',
    customDateLabel: 'Päivämäärä',
    errorEarliestNotBeforeLatest: 'Aikaisin toimitusaika ei voi olla ennen myöhäisintä toimitusaikaa',
    arrivedAtTerminal: 'Saapunut terminaaliin',
    bookCustomTimeSlot: 'Varaa aikaväli',
    shipmentBooked: 'Lähetys varattu',
    shipmentBookedWithCustomTimeWindow: 'Lähetys varattu mukautetulla aikavälillä',
    updateBooking: 'Päivitä varaus',
    bookingChanged: 'Varaus on muutettu onnistuneesti',
    bookingSuccessful: 'Varaus tehtiin onnistuneesti',
    customTimeWindowAdded: 'Mukautettu aikaväli lähetystä varten lisättiin onnistuneesti',
    timeFrom: 'Kello alkaen',
    timeTo: 'Kello asti',
    timeFieldError: 'Varhaisimman toimitusajan on oltava ennen viimeisintä',
    availableTimeSlot: 'Saatavilla olevat aikavälit',
    submitNotSelectedError: 'Sinun täytyy valita aikaväli'
  },
  manualOverride: {
    manuallyAddEvents: 'Lisää tapahtumia manuaalisesti',
    selectEvent: 'Valitse tapahtuma',
    shipmentEvent: 'Lähetyksen tapahtuma',
    terminalEvent: 'Terminaalitapahtuma',
    scannedFormDescription: 'Valitsemasi osasto käynnistää saapumisskannauksen tyypin.',
    suggestPageReload: 'Jokin meni vikaan. Lataa sivu uudelleen ja yritä uudelleen.',
    eventType: {
      delivered: 'Toimitettu',
      collected: 'Noudettu',
      returned: 'Palautettu',
      deviated: 'Poikkeama',
      scanned: 'Skannattu',
      preadvised: 'Preadvice yritys',
      'order-sorted': 'Lajiteltu',
      'not-arrived-at-distributing-terminal': 'Ei saapunut',
      'ready-for-pickup': 'Valmis noudettavaksi (PUP terminaalissa)'
    },
    selectEventType: 'Valitse tapahtuma',
    noEventSelected: 'Ei valittua tapahtumaa',
    selectManifest: 'Valitse lento',
    noManifestSelected: 'Lentoa ei ole valittu',
    disabledEventReason: {
      returned: ' - Poikkeama tarvitaan',
      collected: ' - Ajojärjestystä tarvitaan',
      default: ' - Ei sallittu',
      'order-sorted': 'Vain H2-tilauksille',
      'not-arrived-at-distributing-terminal': 'Vain HD-tilauksille'
    },
    fillDeliverOrReturnEventInfo: 'Täytä nimi, päivä ja aika',
    fillDeviationEventInfo: 'Valitse poikkeama ja täytä päivä ja aika',
    fillGeneralEventInfo: 'Täytä nimi, päivä ja aika',
    eventMessage: 'Tapahtuma luotu',
    allPackagesSelected: 'Kaikki paketit valittuja',
    noActiveDriverError: 'Ei aktiivisia kuljettajia yksikölle',
    selectPackages: 'Valitse paketit',
    selectDriver: 'Valitse kuljettaja',
    selectUnit: 'Valitse yksikkö',
    selectDepartment: 'Valita osasto'
  },
  zendesk: {
    email: 'Sähköposti:',
    confirmEmail: 'Sähköposti uudelleen:',
    send: 'Tallenna',
    missingEmail:
      'Uuden tuki portaalin käyttöä varten, sinun täytyy rekisteröidä Posten tai Bring sähköpostisi. Tämä tarvitsee tehdä vain kerran.'
  },
  shipmentFormPage: {
    activeOrders: 'Aktiiviset tilaukset',
    deletedOrders: 'Poistetut tilaukset',
    deletedOrdersDescription:
      'Poistettuja tilauksia haetaan erikseen, ja niissä voi olla eri tietoja kuin aktiivisissa tilauksissa.',
    searchPhraseError: 'Sinun on annettava vähintään 3 merkkiä',
    selectStateLabel: 'Valitse tila',
    selectDateLabel: 'Valitse päivämäärä pudotusvalikosta',
    submit: 'Näytä tulokset',
    inputPlaceholder: 'Hae lähetystunnusta, puhelinnumeroa, osoitetta, aluetta, postinumeroa ...',
    clearButtonLabel: 'Tyhjennä hakuphrase-painike',
    allStates: 'Kaikki tilat',
    customDate: 'Mukautettu',
    noDate: 'Ei päivämäärärajoitusta',
    withoutDeliveryDate: 'Ilman toimituspäivää',
    selectFromDate: 'Valitse päivämäärä',
    selectToDate: 'Valitse päivämäärä',
    include: 'Sisällytä',
    exclude: 'Poissulkea',
    tableColumn: 'Taulukon sarake',
    condition: 'Kunto',
    searchTerm: 'Hakusana',
    tableDropdown: 'Valitse taulukko-pudotusvalikko',
    conditionDropdown: 'Valitse kunto-pudotusvalikko',
    typeSearch: 'Kirjoita hakutermi',
    typeSearchCommaSeparated: 'Kirjoita hakutermit pilkulla erotettuina',
    addNewRow: 'Lisää uusi rivi',
    deleteRow: 'Poista nykyinen rivi',
    service: 'Palvelu',
    goodsDescription: 'Tavarakuvaus',
    unit: 'Yksikkö',
    deliveryArea: 'Toimitusalue',
    deliveryZipcode: 'Toimituspostinumero',
    state: '{{count}} Osavaltio',
    state_other: '{{count}} Tilat',
    today: 'Tänään',
    tomorrow: 'Huomenna',
    yesterday: 'Eilen',
    last30Days: 'Viimeiset 30 päivää',
    plusMinus15Days: '+/- 15 päivää',
    plusMinus30Days: '+/- 30 päivää',
    shipmentIds: 'Useita lähetyksiä',
    advancedFilter: 'Laajennettu suodatin',
    advancedSearch: 'Tarkennettu haku',
    closeAdvancedSearch: 'Sulje tarkennettu haku',
    selectTable: 'Valitse taulukko',
    selectCondition: 'Valitse ehto',
    orderId: 'Sisäinen tilausnumero',
    allAnd: 'Kaikki (ja)',
    anyOr: 'Mikä tahansa (tai)',
    customers: {
      placeholder: 'Kaikki asiakkaat',
      label: 'Valitse asiakkaat'
    },
    allOrderSources: 'Kaikki sisäiset tilauksen lähteet',
    orderSource: '{{count}} sisäinen tilauksen lähde',
    orderSource_other: '{{count}} sisäiset tilauksen lähteet',
    vasCodes: '{{count}} VAS-koodi',
    vasCodes_other: '{{count}} VAS-koodia',
    vasCodesPlaceholder: 'Hae VAS-koodilla tai nimellä',
    orderSourceOption: {
      GLOW: 'GLOW',
      GLOW_CUSTOMER_BOOKING: 'GLOW Asiakasvaraus',
      GLOW_EXCEL: 'GLOW Excel'
    }
  },
  shipmentResultPage: {
    deletedOrdersLimitReached: 'Näytetään {{limit}} viimeksi poistettua tilausta. Harkitse hakusi rajaamista.',
    noResultTitle: 'Ei tuloksia',
    batchLimitReached: 'Näytetään enintään 2000 lähetystä, harkitse hakusi supistamista',
    withoutDateLimitReached:
      'Etsittäessä ilman päivämäärää, näytämme enintään {{limit}} lähetystä. Harkitse hakusi rajaamista.',
    withoutDeliveryDateLimitReached:
      'Kun etsit lähetyksiä ilman toimituspäivää, näytämme enintään {{limit}} lähetystä. Harkitse haun tarkentamista.',
    findYourShipments: 'Etsi lähetyksiäsi',
    findYourShipmentsDescription:
      'Kirjoita hakemasi termi yllä olevaan hakukenttään. Lisää vaihtoehtoja löytyy tarkennetusta hausta',
    searchByShipmentIdsLimitReached:
      'Kun etsit lähetystunnuksilla, näytämme enintään {{limit}} lähetystä. Harkitse haun tarkentamista.',
    searchError: 'Haku epäonnistui. Yritä ladata sivu uudelleen tai muuta hakuehtoja'
  },
  shipmentResultActions: {
    confirmDeleteTitle: 'Poista lähetys?',
    confirmDeleteTitle_other: 'Poista valitut lähetykset?',
    confirmDuplicateTitle: 'Kopioi lähetys?',
    confirmDuplicateButton: 'Kopioi',
    deleteSuccess: 'Lähetys poistettiin onnistuneesti',
    deleteSuccess_other: 'Lähetykset poistettiin onnistuneesti',
    invoiceActions: 'Laskutustoiminnot',
    shipmentActions: 'Lähetystoiminnot',
    showInvoicePayloadDisableTooltip: 'Lähetysten on oltava laskutustilassa "epäonnistunut" tai "OK',
    manuallyPreAdviceSuccess: 'Ennakkoilmoituspyyntö tallennettu lähetykselle',
    manuallyPreAdviceSuccess_other: 'Ennakkoilmoituspyyntö tallennettu lähetyksille'
  },
  shipmentTable: {
    quantity: 'Määrä',
    delEta: 'LÄH ARV',
    delDuration: 'LÄH K',
    delDurationTitle: 'Toimituksen kesto',
    delPreparation: 'LÄH V',
    delPreparationTitle: 'Toimituksen valmistelu',
    delDeliveryFrom: 'LÄH A',
    delDeliveryFromTitle: 'Toimitusaika alkaen',
    delDeliveryTo: 'LÄH L',
    delDeliveryToTitle: 'Toimitusaika asti',
    timeOfDelivery: 'Toimituksen aika',
    puDuration: 'NOUTO K',
    puDurationTitle: 'Noudon kesto',
    puPreparation: 'NOUTO V',
    puPreparationTitle: 'Noudon valmistelu',
    puPickupFrom: 'NOUTO A',
    puPickupFromTitle: 'Noudon aika alkaen',
    puPickupTo: 'NOUTO L',
    puPickupToTitle: 'Noudon aika asti',
    timeOfPickup: 'Noudon aika',
    timeFrom: 'Aika A',
    timeFromTitle: 'Pysähdyksen aika alkaen',
    timeTo: 'Aika L',
    timeToTitle: 'Pysähdyksen aika asti',
    delEtaTitle: 'Arvioitu toimitusaika',
    recipientRef: 'Vastaanottajan viite',
    loading: 'Ladataan...',
    pickupName: 'Noutopaikan nimi',
    deliveryName: 'Toimituspaikan nimi',
    pickupColumn: 'Nouto: {{column}}',
    deliveryColumn: 'Toimitus: {{column}}',
    selectAllOnPage: 'Valitse kaikki sivulla ({{count}})',
    selectAll: 'Valitse kaikki ({{count}})',
    deselectAll: 'Poista kaikki valinnat',
    numSelectedShipments: '{{numSelected}} valittu',
    createLabels: 'Luo tarrat',
    yourSearchResult: 'Hakutuloksesi',
    numberOfShipmentsFound: '{{count}} lähetystä löydetty',
    orderedDeliveryDate: 'Tilattu toimituspäivä',
    vendorInvoice: 'Toimittajan lasku',
    customerInvoice: 'Asiakkaan lasku'
  },
  moveDepartmentModal: {
    errorMessage: 'Tilaus(t): {{orderIds}}, virhe: {{error}}',
    errorMessage_other: 'Tilaus/tilaukset: {{orderIds}}, virhe: {{error}}',
    ordersMovedText: 'Tilaus on siirretty osastolle {{department}}',
    ordersMovedText_other: 'Tilaukset on siirretty osastolle {{department}}',
    partialSuccessMessage: '{{count}} / {{fullCount}} lähetystä siirrettiin',
    title: 'Siirrä valitut lähetykset toiseen osastoon'
  },
  updateDeliveryTimeBulk: {
    menuItem: 'Muuta toimituspäivää ja -aikaa',
    heading: 'Muuta toimituspäivää ja -aikaa',
    buttonTitle: 'Muuta ja ilmoita vastaanottajille',
    smsDescription:
      'Vastaanottajat saavat tekstiviestin, jossa on uusi toimituspäivä ja uusi aikaikkuna sekä linkki, jonka kautta he voivat muuttaa niitä.',
    successMessage: '{{count}} lähetys päivitettiin',
    successMessage_other: '{{count}} lähetystä päivitettiin',
    notNotified:
      'Tekstiviestiä ei lähetetty lähetykselle {{shipmentIds}} - vastaanottajalla ei ole kelvollista puhelinnumeroa tai sähköpostiosoitetta',
    notNotified_other:
      'Tekstiviestiä ei lähetetty lähetyksille {{shipmentIds}} - vastaanottajilla ei ole kelvollista puhelinnumeroa tai sähköpostiosoitetta',
    disabledTooltip: 'Toimitusaikaa voi muuttaa vain ennen kuin lähetys on annettu reitille',
    dateInPast: 'Toimituspäivä ei voi olla menneisyydessä',
    invalidDate: 'Virheellinen päivämäärä'
  },
  sendManualDelaySmsModal: {
    errorMessage: '{{error}} {{shipmentIds}}',
    partialSuccessMessage: '{{count}}/{{fullCount}} viestiä lähetettiin',
    successMessage: 'Käsikäyttöinen viiveviesti lähetettiin onnistuneesti'
  },
  sendPrePickupSmsModal: {
    successMessage: 'Ennakkoseuranta-SMS lähetettiin onnistuneesti',
    'return-order': 'Tilaukset eivät voi olla palautustilauksia',
    'invalid-state': 'Tilausten on oltava tilassa "Osoitettu reitille"'
  },
  multistopModal: {
    title: 'Ryhmäinformaatio',
    description: 'Ryhmä näkymä tilauksille, jotka maksetaan yhdessä.',
    debitLines: 'Velkalinjat',
    notFound: 'Ryhmäinformaatiota ei löytynyt',
    shipmentId: 'Lähetystunnus',
    deliveryDate: 'Toimituspäivä',
    stopAddress: 'Pysäytysosoite',
    postalCode: 'Postinumero',
    noPrice: 'Ei hintatietoja saatavilla ryhmälle',
    priceUpdated: 'Ryhmän hinnat on päivitetty'
  },
  shipmentDetails: {
    notFoundTitle: 'Lähetystä ei löytynyt',
    notFoundDescription: 'Se on voitu poistaa.',
    overview: 'Yleiskatsaus',
    details: 'Tiedot',
    orderInformation: 'Tilauksen tiedot',
    volumeAndWeight: 'Tilavuus ja paino',
    references: 'Viitteet',
    goods: 'Tavarat',
    contactInformation: 'Yhteystiedot',
    pickupContactInformation: 'Noudon yhteystiedot',
    deliveryContactInformation: 'Toimituksen yhteystiedot',
    eventWasAdded: 'Tapahtuma lisättiin',
    issueSaving: 'Tallennuksessa ilmeni ongelma',
    noSelectedPackages: 'Paketteja ei valittu',
    pickupAndDelivery: 'Nouto ja toimitus',
    whereIsTheOrder: 'Missä tilaus on',
    communicationToRecipient: 'Viestintä vastaanottajalle',
    yesPremium: 'Kyllä, premium',
    alerts: 'Hälytykset',
    pickupDeliveryInfo: 'Noudon ja toimituksen tiedot',
    quickEdit: 'Pikamuokkaus',
    quickEditTitle: 'Muokkaa nouto- ja toimitustietoja',
    aboutShipment: 'Lähetyksestä',
    mapLinkText: 'Näytä karttakoordinaatit',
    copyShipment: 'Kopioi lähetys',
    editShipment: 'Muokkaa lähetystietoja',
    location: 'Sijainti',
    time: 'Aika',
    selectDate: 'Valitse päivämäärä',
    manualChangeEvent: 'Muuta tapahtumaa manuaalisesti',
    disabledEventReason: {
      returned: 'Palautettu: Poikkeama vaaditaan',
      collected: 'Noudettu: Tilaus on annettava reitille',
      default: 'Oletus: Ei sallittu'
    },
    selectDeviation: 'Valitse poikkeama',
    required: 'Pakollinen',
    allPackages: 'Kaikki paketit',
    packages: 'Paketit',
    package: 'Paketti',
    changeDepartment: 'Vaihda osasto',
    moveDepartment: 'Siirrä osastolle',
    shipmentMoved: 'Lähetys siirretty',
    shipmentMovedText: 'Lähetys {{shipmentId}} on siirretty osastolle {{department}}',
    shipmentMovedGoBack: 'Palaa hakusivulle',
    shipmentCouldNotBeMoved: 'Lähetystä ei voitu siirtää',
    moveShipmentDescription: 'Jos sinulla ei ole pääsyä osastolle, et voi löytää lähetystä sen siirron jälkeen',
    moveShipmentConfirmText: 'Siirrä lähetys toiseen osastoon?',
    addShipmentToSlot: 'Lisää lähetys paikkaan {{slot}}?',
    changeSlotConfirm: 'Vaihdetaanko lähetyksen reitiksi {{slot}}?',
    changeSlot: 'Vaihda reitti',
    selectSlot: 'Valitse reitti',
    AddToSlot: 'Lisää reitille',
    optimisationInProgress: 'Optimointi käynnissä. Et voi vaihtaa reittiä, kun reittiä optimoidaan.',
    removeFromSlot: 'Poista reitiltä',
    removeShipmentFromSlot: 'Poista lähetys reitiltä',
    removeShipmentFromSlotHeading: 'Poistetaanko lähetys tältä reitiltä?',
    successRemoveFromSlot: 'Lähetys poistettiin reitiltä',
    successChangeSlot: 'Lähetyksen reitti vaihdettiin',
    successAddToSlot: 'Lähetys lisättiin reitille',
    changeSlotDescription: 'Reitin vaihto tehdään ilman reittioptimointia.',
    addToSlotDescription:
      'Valittu reitti optimoidaan niin, että olemassa olevat lähetykset pysyvät samassa järjestyksessä',
    pickupOrDeliveryChange: 'Noudon tai toimituksen osoite on muuttunut',
    pickupOrDeliveryChangeDescription:
      'Noudon tai toimituksen osoite on muuttunut. Jos haluat muuttaa osoitteen takaisin, paina alla olevaa painiketta.',
    addressWasUnresolved: 'Osoite oli ratkaisematon',
    eventTimeCannotBeInFuture: 'Tapahtuma-aika ei voi olla tulevaisuudessa.',
    shipmentSuccessfullyUpdated: 'Lähetys päivitetty onnistuneesti',
    connectedShipments: 'Yhdistetyt lähetykset',
    goToShipment: 'Siirry lähetykseen',
    currentShipment: 'Nykyinen lähetys',
    duplicate: 'Duplikaatti'
  },
  terminal: 'Terminaali',
  location: 'Sijainti',
  scannedAtDelegatedDepartment: 'Skannattu delegoidulta osastolta.',
  pickupOrders: {
    acceptOrders: 'Hyväksy tilaukset',
    selected: 'valittu',
    handleOrders: 'Käsittele noutotilaukset',
    found: 'löydetty',
    accept: 'Hyväksy',
    reject: 'Hylkää',
    noResultText: 'Emme löytäneet tuloksia. Yritä haku toisella päivämäärällä.',
    last7d: 'Tänään + viimeiset 7 päivää',
    rejectOptions: {
      notFound: 'Lähettäjää ei löydy nouto-osoitteelta. Ei enää yrityksiä. Nouto suljettu.',
      terminatesPickupOrder: 'Lähettäjä keskeyttää noutotilauksen. Ei enää yrityksiä. Nouto suljetaan.',
      handedOver: 'Lähettäjä on luovuttanut noudon toiselle kuljettajalle. Ei enää yrityksiä. Nouto suljettu.',
      noMoreAttempts: 'Lähettäjä on muuttanut. Ei enää yrityksiä. Nouto suljettu.',
      pickupCorrected: 'Lähettäjä on muuttanut. Nouto korjattu ja lähetetty takaisin aliurakoitsijalle.',
      goodsNotReady: 'Tavaroita ei ole valmiina noudettavaksi. Ei enää yrityksiä. Nouto suljettu.',
      incorrectBooking: 'Virheellinen varaus. Nouto keskeytetty.',
      senderRefuses: 'Lähettäjä kieltäytyy luovuttamasta tavaroita. Ei enää yrityksiä. Nouto suljettu.',
      addressCorrected: 'Virheellinen nouto-osoite. Osoite korjattu.',
      incorrectAddressNoMoreAttempts: 'Virheellinen nouto-osoite. Ei enää yrityksiä. Nouto suljettu.',
      senderNotified: 'Virheellinen nouto-osoite. Ei enää yrityksiä. Nouto suljettu.',
      forbiddenGoods: 'Kielletyt tavarat. Ei enää yrityksiä. Nouto suljettu.',
      timeFrame: 'Noutoa ei voi suorittaa aikataulun puitteissa. Noutotilaus palautetaan varausosastolle.'
    },
    mustSelectReason: 'Sinun on valittava hylkäämisen syy',
    selectRejectReason: 'Valitse hylkäämisen syy*',
    selectReason: 'Valitse syy',
    commentPlaceholder: 'Valinnainen - lisää tietoja hylkäämiseen',
    acceptedSuccessToast: 'hyväksyttiin onnistuneesti',
    rejectedSuccessToast: 'hylättiin onnistuneesti',
    errorToast: 'Jotain meni pieleen',
    rejectOrders: 'Hylkää tilaukset',
    shipment: '{{count}} lähetys',
    shipment_other: '{{count}} lähetystä'
  },
  editShipments: {
    pickupShouldBeBeforeDeliveryForAllShipments:
      'Lähetys [{{shipmentIds}}] ei kelpaa, koska uusien ja nykyisten aikojen yhdistelmä ei ole kelvollinen. Poista virheellisen lähetyksen valinta ja yritä uudelleen.',
    pickupShouldBeBeforeDeliveryForAllShipments_other:
      '{{count}} lähetystä ei kelpaa, koska uusien ja nykyisten aikojen yhdistelmä ei ole kelvollinen. Poista virheellisten lähetysten valinta ja yritä uudelleen. Epäonnistuneet lähetystunnukset - {{shipmentIds}}',
    useExistingTimes: 'Käytä nykyisiä aikoja',
    pickupShouldBeBeforeDelivery: 'Noutoikkunan on oltava ennen toimitusikkunaa',
    pickupEarliestShouldBeBeforeLatest: 'Aikaisimman noutoajan on oltava ennen viimeisintä',
    deliveryEarliestShouldBeBeforeLatest: 'Aikaisimman toimitusajan on oltava ennen viimeisintä',
    success: 'Lähetysten tiedot päivitettiin onnistuneesti',
    mixedShipmentsSelected: 'Olet valinnut lähetyksiä päivämäärän kanssa ja ilman. Nouto- ja toimitustiedot vaaditaan.',
    fieldNotEditable: 'Tätä tietoa ei voi muokata tilauksille, jotka ovat tilassa "Osoitettu reitille" tai "Noudettu"',
    bulkActionDisabledReason:
      'Tilauksia, jotka ovat tilassa "Poikkeama", "Toimitettu", "Hylätty" tai "Palautettu", ei voi muokata',
    withoutDateDisabledReason:
      'Tilauksia, jotka ovat tilassa "Osoitettu reitille" tai "Noudettu" ja joilla ei ole päivämäärää, ei voi muokata yhdessä',
    pickupDateTime: 'Nouto päivä ja ajat',
    deliveryDateTime: 'Toimitus päivä ja ajat',
    earliestPickupTime: 'Aikaisin noutoaika',
    latestPickupTime: 'Myöhäisin noutoaika',
    earliestDeliveryTime: 'Aikaisin toimitusaika',
    latestDeliveryTime: 'Myöhäisin toimitusaika',
    pickupName: 'Nouto nimi',
    pickupPhoneNumber: 'Nouto puhelinnumero',
    deliveryName: 'Toimitus nimi',
    deliveryPhoneNumber: 'Toimitus puhelinnumero',
    pickupInstructions: 'Nouto-ohjeet',
    deliveryInstructions: 'Toimitusohjeet'
  },
  shipmentSelectColumn: {
    titleDeletedOrders: 'Mukauta poistettujen tilausten taulukkoa',
    title: 'Mukauta sarakeotsikoita',
    addColumnHeader: 'Lisää sarakkeiden otsikot',
    addColumnBody:
      'Valitse otsikot, jotka haluat näkyvän taulukossa. Vinkkimme on käyttää 10-15 eri otsikkoa, jotta tieto ei katkeaisi. Tarkka määrä riippuu laitteen koosta, jolla työskentelet.',
    orderOfTable: 'Sarakeotsikoiden järjestys'
  },
  bulkActions: {
    routeReceiptList: { disabledTooltip: 'Tilaukset eivät voi olla tilassa Ratkaistu tai Ratkaisematon' },
    unassignShipmentFromSlot: 'Poista lähetyspaikat paikoista',
    unassignShipmentFromSlotDisabledReason: 'Tilausten on oltava tilassa "Osoitettu reitille" tai "Tarjottu"',
    forceUnassignShipmentFromSlot: 'Pakota poistamaan lähetykset paikoista',
    disabledMoveDepartmentTooltip:
      'Tilausten on oltava tilassa Luotu, Ratkaistu, Ratkaisematon tai Hylätty siirtääksesi ne',
    deleteDisableTooltip:
      'Lähetystä ei voi poistaa, jos se on tilassa Luotu, Ratkaisematon, Ratkaistu, Tarjottu tai Määrätty',
    duplicateDisableTooltip:
      'Lähetyksen on oltava tilassa Poikennut tai Palautettu, ja osaston tyypin on oltava Kuriiri',
    onlyReleasePausedOrders: 'Voit vapauttaa vain keskeytettyjä tilauksia.',
    onlyOverrideTheseInvoicingStatuses:
      'Voit ohittaa vain tilauksia, joiden laskutustila on jokin seuraavista: {{statuses}}',
    shipmentForPauseDisableText:
      'Lähetysten on oltava tilassa, jossa on tilauskorjaus, "Ei laskutettu" tai "Laskutus epäonnistui"',
    creditDisableTooltip: 'Voit hyvittää vain tilauksia, joiden tila on "Laskutettu OK"',
    copyDisableTooltip:
      'Kopiointi laskutustilaukseen on sallittu vain tilauksille, joiden laskutustila on "Laskutettu OK"',
    createWaybills: 'Luo rahtikirjat',
    createWaybillsTooltip: 'Rahtikirjoja voi luoda vain IKEA-lähetyksille',
    createDeliveryNotes: 'Luo lähetteet',
    createDeliveryNotesTooltip: 'Lähetteitä voi luoda vain IKEA-lähetyksille',
    viewGroupDisabledTooltip: 'Tilaus on määritettävä ennen kuin voit tarkastella ja muokata sen ryhmää'
  },
  dispatchModal: {
    title: 'Noudot ja toimitukset reitillä {{name}}',
    overridePalletRule: {
      question: 'Ohitetaanko lavasääntö?',
      description:
        'Lähetys sisältää lavoja, mutta tämän reitin ajoneuvoa ei ole merkitty lavoja kuljettavaksi. Haluatko silti lisätä sen reitille?',
      confirm: 'Lisää silti'
    },
    palletRule: 'Lavasääntö',
    ignorePalletRule: 'Salli lavat ajoneuvoissa, jotka eivät voi kuljettaa lavoja',
    partialForcedOrderLabel: 'Määritä alueiden järjestys/alueelle',
    partialForcedOrderInfo:
      'Olet valinnut määrittää valittujen pysähdysten/alueiden järjestyksen. Muut pysähdykset optimoidaan näiden ympärille.',
    flex: 'Joustava',
    force: 'Pakota',
    partialForcedOrder: 'Valittu järjestys',
    optimizingEngine: 'Optimointimoottori',
    invalidRouteOrder: 'Toimitukset eivät voi olla ennen noutoja. Muuta reitin järjestystä',
    submitDisabled: 'Suunnittele reitti uudelleen aktivoidaksesi painikkeen',
    replanDisabled: 'Reitin järjestyksen on oltava kelvollinen uudelleensuunnittelua varten',
    replan: 'Suunnittele reitti uudelleen',
    noShipments: 'Ei lähetyksiä reitillä',
    openRowMenu: 'Avaa rivivalikko',
    openPlannedStopMenu: 'Avaa suunnitellun pysähdyksen valikko',
    newPositionForStop: 'Valitse uusi sijainti pysähdykselle',
    noShipmentsDescription:
      'Olet poistanut kaikki lähetykset reitiltä, paina <i>Vahvista reitti</i> tallentaaksesi muutokset',
    unassignBreakFromRoute: 'Napsauta poistaaksesi tauon reitiltä',
    editBreakOnRoute: 'Napsauta muokataksesi taukoa reitillä',
    routeEnd: 'Reitin loppu',
    routeStart: 'Reitin alku',
    earliestStartOfBreak: 'Tauon aikaisin aloitusaika',
    latestStartOfBreak: 'Tauon viimeisin aloitusaika',
    overrideOptimizingEngine: 'Ohita oletusoptimointimoottori',
    warning:
      'Olet valinnut olla käyttämättä optimointimoottoria tälle reitille. Tämä vaikuttaa vastaanottajan kokemukseen.',
    flexDisabled: 'Et voi <strong>joustaa</strong> yksittäisiä lähetyksiä ryhmässä',
    forceDisabled: 'Et voi <strong>pakottaa</strong> yksittäisiä lähetyksiä ryhmässä',
    removeDisabled: 'Et voi <strong>poistaa</strong> yksittäisiä lähetyksiä ryhmässä',
    orderDisabled: 'Et voi <strong>muuttaa järjestystä</strong> yksittäisille lähetyksille ryhmässä',
    plannedStopRowDisabled:
      'Et voi <strong>muuttaa järjestystä</strong> suunnitellulle pysähdykselle muokkaamisen aikana',
    showStops: 'Näytä pysähdykset',
    viewStopsOnSameAddress: 'Näytä samalla osoitteella olevat pysähdykset ryhmitettynä',
    addPlannedStopLocations: 'Lisää suunnitellut pysähdyspaikat',
    selectPlannedStopLocation: 'Valitse suunniteltu pysähdyspaikka',
    plannedStop: 'Suunniteltu pysähdys',
    visitEarliest: 'Aikaisin käynti',
    visitLatest: 'Viimeisin käynti',
    serviceTime: 'Kesto',
    addPlannedStop: 'Lisää pysähdys ja suunnittele uudelleen',
    updatePlannedStop: 'Päivitä pysähdys ja suunnittele uudelleen',
    editPlannedStopOnRoute: 'Muokkaa reitin suunniteltua pysähdystä',
    unassignPlannedStopFromRoute: 'Poista suunniteltu pysähdys reitiltä',
    settings: 'Asetukset',
    multipleRecipients: 'Useita vastaanottajia ({{number}})',
    multiplePickups: 'Useita noutoja ({{number}})',
    mustProvideStopLocation: 'Sinun on annettava pysäkkisijainti',
    editingLockBanner: 'Reittiä muokkaa {{name}} klo {{time}} alkaen.',
    editingLockBannerBody: 'Sinun on otettava reititys haltuun suunnitellaksesi reitin uudelleen.',
    takeOver: 'Ota haltuun',
    routeChangedByOtherUser: '{{name}} lopetti muokkauksen. Lataa uudelleen jatkaaksesi.',
    reloadRoute: 'Lataa reitti uudelleen',
    noShipmentsRouteUpdated: 'Lataa reitti uudelleen nähdäksesi lähetykset',
    duplicateTabBanner: 'Tämä reitti on auki toisessa välilehdessä (klo {{time}} alkaen).',
    duplicateTabBannerBody: 'Ota haltuun tässä välilehdessä muokataksesi.'
  },
  vehicle: {
    weightCapacity: 'Painokapasiteetti',
    volumeCapacity: 'Tilavuuskapasiteetti',
    maxRangeKm: 'Toimintasäde',
    createNewVehicle: 'Luo uusi ajoneuvo',
    vehiclesInDepartment: 'Ajoneuvot osastossa {{departmentName}}',
    listAllVehicle: 'Listaa kaikki ajoneuvot tässä osastossa',
    deleteSuccessMessage: 'Ajoneuvo poistettiin onnistuneesti',
    createdSuccessMessage: 'Ajoneuvo luotiin onnistuneesti',
    updatedSuccessMessage: 'Ajoneuvo päivitettiin onnistuneesti',
    deleteVehicle: 'Poista ajoneuvo',
    notRecover: 'Tätä toimintoa ei voi peruuttaa',
    createVehicle: 'Luo ajoneuvo',
    editVehicle: 'Muokkaa {{name}}',
    vehicleInformation: 'Ajoneuvotiedot',
    selectFuelType: 'Valitse polttoainetyyppi',
    selectEuroClass: 'Valitse Euro-luokka',
    settings: 'Asetukset',
    activeDriver: 'Aktiivinen kuljettaja',
    noVehicleControl: 'Ei ajoneuvon hallintaa',
    slower: 'Hitaampi',
    slow: 'Hidas',
    normal: 'Normaali',
    faster: 'Nopeampi',
    speedFactorVehicle: 'Ajoneuvon nopeuskerroin',
    driverSpeed: 'Kuljettajan nopeus',
    serviceSpeed: 'Palvelunopeus',
    defaultStartLocation: 'Oletusarvoinen lähtöpaikka on osaston osoite',
    specifyEndLocation: 'Määritä päätepiste',
    earliest: 'Aikaisin',
    latest: 'Myöhäisin'
  },
  lmEvents: {
    heading: 'LM-tapahtumat',
    event: 'Tapahtuma',
    lmEventReasonAction: 'LM-tapahtuma-syy-toimenpide',
    eventTime: 'Tapahtuma-aika',
    eventSentAt: 'Tapahtuma lähetetty',
    lmPayload: 'LM-payload',
    view: 'Näytä',
    enterShipmentId: 'Sinun on annettava lähetystunnus',
    searchForShipmentId: 'Hae lähetystunnusta'
  },
  cms: {
    scheduleBanner: 'Aikatauluta banner',
    cms: 'CMS',
    publicationDate: 'Julkaisupäivä',
    lastEdited: 'Viimeksi muokattu',
    dateForUnpublish: 'Poistopäivä',
    createNewBanner: 'Luo uusi banneri',
    createNewWhatsThisModal: 'Luo uusi "Mikä tämä on" -ikkuna',
    publish: 'Julkaise',
    schedule: 'Aikatauluta',
    unpublish: 'Poista julkaisu',
    savePublish: 'Tallenna ja julkaise',
    saveAsDraft: 'Tallenna luonnoksena',
    saveAsDraftUnpublish: 'Tallenna luonnoksena ja poista julkaisu',
    noBannersFound: 'Bannereita ei löytynyt',
    noModalsFound: 'Ikkunoita ei löytynyt',
    DRAFT: 'Luonnos',
    PUBLISHED: 'Julkaistu',
    SCHEDULED: 'Aikataulutettu',
    content: 'Sisältö',
    nameOfBanner: 'Bannerin nimi',
    placementOfBanner: 'Bannerin sijainti',
    placementOfBannerDescription:
      'Liitä Glow-URL, johon haluat lisätä bannerin. Jos haluat julkaista bannerin kaikille osastoilletai tietyille, voit joko painaa "Lisää URL" -painiketta tai muokata linkkiä itse.',
    urlToPageInGlow: 'URL sivulle Glowssa',
    addUrl: 'Lisää URL',
    typeOfBanner: 'Bannerin tyyppi',
    typeOfBannerDescription: 'Varoitus (oranssi), Neutraali (harmaa) tai Virhe (punainen).',
    bannerNeutral: 'Neutraali (harmaa)',
    bannerWarning: 'Varoitus (oranssi)',
    bannerError: 'Virhe (punainen)',
    links: 'Linkit',
    linksDescription:
      'Artikkelin linkki sijoitetaan heti leipätekstin jälkeen. Jos lisäät "Palaavanhalle sivulle" -linkin, se sijoitetaan ennen leipätekstiä.',
    goBackToOldPageLink: 'Linkki paluuseen vanhalle sivulle',
    messageInBanner: 'Viesti bannerissa',
    messageInBannerDescription:
      'Englanti on pakollinen. Jos muita kieliä ei valita, englanti toimii varakielenä kaikilla sivuilla.',
    addAdditionalLanguages: 'Lisää muitakieliä',
    bannerText: 'Teksti',
    nameOfLink: 'Linkin nimi',
    englishText: 'Englanninkielinen teksti',
    englishLinkText: 'Englanti: linkin nimi',
    selectLanguage: 'Valitsekieli',
    addNewLanguage: 'Lisää uusi kieli',
    deleteBanner: 'Poista {{name}}',
    bannerWasSaved: '{{name}} tallennettiin',
    bannerWasPublished: '{{name}} julkaistiin',
    bannerWasScheduled: '{{name}} aikataulutettiin',
    articleLink: 'Artikkelin linkki',
    goBackToOldPage: 'Palaa vanhalle sivulle',
    previousPageNote: 'Huom: käytäjokerimerkkejä *department-id* ja *date* tässä kentässä',
    selectTime: 'Valitse aika',
    setStartDate: 'Aseta bannerin aloituspäivä',
    setEndDate: 'Aseta bannerinlopetuspäivä',
    endTimeIsBeforeStartTime: 'Loppuaika ei voi olla ennen aloitusaikaa',
    endDateIsBeforeStartDate: 'Lopetuspäivä ei voi olla ennen aloituspäivää',
    oneBannerPerPageError:
      'Vain yksi banneri per sivu on sallittu. URL menee päällekkäin olemassa olevan bannerin kanssa: {{banners}}',
    mustProvideUrl: 'Sinun on annettavaURL',
    mustProvideNameOfBanner: 'Sinun on annettava bannerin nimi',
    mustProvideNameOfModal: 'Sinun on annettava ikkunan nimi',
    mustProvideEnglishText: 'Sinun on annettava englanninkielinen teksti',
    mustProvideArticleLink: 'Sinun on annettava artikkelin linkki',
    mustProvideNameOfArticleLink: 'Sinun on annettava artikkelin linkinnimi',
    mustProvideDate: 'Sinun on annettava päivämäärä',
    invalidArticleLink: 'Sinun on annettava kelvollinen artikkelinlinkki, esim. https://example.com',
    errorDuplicateBanner: 'Bannerin nimen on oltava yksilöllinen. Banneri tällä nimellä on jo olemassa.',
    draftScheduleTooltip: 'Poistaaikataulu tallentaaksesi luonnoksena',
    banner: 'Banneri',
    listOfBanners: 'Bannerilista',
    whatsThisModal: '"Mikä tämä on" -ikkuna',
    whatsThis: 'Mikä tämä on',
    listOfWhatsThisModals: 'Lista "Mikä tämä on" -ikkunoista',
    nameOfWhatsThisModal: '"Mikä tämä on" -ikkunan nimi',
    descriptionWhatsThisModal:
      'Nimen on oltavayksilöllinen. Vinkki: nimeä "Mikä tämä on" -ikkuna sijainnin mukaan, esim. "Admin Pre-advice" tai "Planner Live".',
    nameOfModal: 'Ikkunan nimi',
    pageLinkOfModal: 'Sivu, jolla ikkuna näytetään',
    pageLinkOfModalDescription:
      'Liitä Glow-URL, johon haluat lisätä ikkunan. Muista vaihtaa osaston ID:ksi * jotta ikkuna julkaistaan kaikilleosastoille.',
    linkToPageGlow: 'Linkki sivulle Glowssa',
    modalPreviewEmptyTitle: 'Ei tietoja vielä',
    modalPreviewEmptyDescription: 'Sinun on lisättävä tietoja nähdäksesiikkunan esikatselun',
    addTextForModal: 'Lisää tekstiä ikkunaan',
    addTextForModalDescription:
      'Englanti on pakollinen ja sitä käytetään varakielenä kaikissa ikkunoissa, jos et kirjoita tietoja muilla kielillä. Klikkaa "Mikä tämä on" -linkkiä saadaksesi vinkkejä linkin muotoiluun.',
    searchBannerPlaceholder: 'Etsi banneri',
    searchModalPlaceholder: 'Etsi ikkuna',
    cmsNews: 'Uutinen',
    cmsNewsLabel: 'Uutiset',
    listOfCMSNews: 'Uutislista',
    noCMSNewsFound: 'Uutisia ei löytynyt',
    searchCMSNewsPlaceholder: 'Etsi uutinen',
    cMSNewsSettingsTitle: 'Uutisen sijainti',
    cMSNewsSettingsDescription: 'Uutisesi näkyy etusivulla ja kaikille käyttäjille, kunhe kirjautuvat sisään Glow:hun.',
    nameOfCMSNews: 'Uutisen nimi',
    descriptionOfCMSNewsName: 'Nimeä päivityksesi, jotta löydät sen helposti. Nimen on oltavayksilöllinen.',
    typeOfCMSNews: 'Uutisen tyyppi',
    typeOfCMSNewsDescription: 'Valitse Palvelun tila, Uusi ominaisuus tai Informaatio.',
    selectTypeOfCMSNews: 'Valitseuutisen tyyppi',
    newFeatureCMSNews: 'Uusi ominaisuus',
    serviceStatusCMSNews: 'Palvelun tila',
    informationCMSNews: 'Tiedote',
    NEW_FEATURE: 'Uusi ominaisuus',
    SERVICE_STATUS: 'Palvelun tila',
    INFORMATION: 'Tiedote',
    scheduleCMSNews: 'Aikatauluta uutinen',
    scheduleCMSNewsDescription: 'Kun aikataulutat uutisen, et voi tallentaasitä luonnoksena.',
    setStartDateForCMSNews: 'Aseta uutisen aloituspäivä',
    setEndDateForCMSNews: 'Aseta uutisen lopetuspäivä',
    cMSNewsPreviewEmptyTitle: 'Ei tietojavielä',
    cMSNewsPreviewEmptyDescription: 'Sinun on lisättävä tietoja nähdäksesi uutisen esikatselun',
    addTextForCMSNews: 'Lisää tekstiä uutiseen',
    addTextForCMSNewsDescription:
      'Englanti on pakollinen ja sitä käytetään varakielenä kaikissa uutisissa, jos et kirjoita tietoja muilla kielillä. Klikkaa "Mikä tämä on" -linkkiä saadaksesi vinkkejä uutisen muotoiluun.',
    mustProvideNameOfCMSNews: 'Sinun on annettava uutisen nimi',
    createNewCMSNews: 'Luo uusi uutinen',
    continueToYourPage: 'Jatka sivullesi',
    clearSelection: 'Tyhjennä valinta'
  },
  invoicingStatus: {
    TO_BE_INVOICED: 'Ei laskutettu',
    INVOICING_FAILED: 'Laskutus epäonnistui',
    CORRECTION_PENDING: 'Oikaisu vireillä',
    INVOICING_PAUSED: 'Laskutus pysäytetty',
    EXCLUDED_FROM_INVOICING: 'Ulkopuolelle',
    NOT_READY_FOR_INVOICING: 'Ei valmis',
    INVOICED_OK: 'Laskutettu OK',
    ZERO_PRICE: 'Epätäydellinen hinta',
    AWAITING_ACKNOWLEDGEMENT: 'Odottaa vahvistusta',
    disallowedStatusLegend:
      'Tilauksia, joiden tila on "Laskutettu OK" ja "Odottaa vahvistusta", ei voi asettaa tilaan "Ei laskutettu" tai "Ulkopuolelle".'
  },
  invoice: {
    articleCode: 'Artikkeli',
    allOrdersInvoice: 'Kaikki tilaukset laskutetaan',
    allOrdersInvoiceDescription: 'Emme löytäneet laskuttamattomia tilauksia.',
    handledBy: 'Käsitellyt',
    invoicing: 'Laskutus',
    credit: 'Hyvitys',
    invoiceVerb: 'Laskuttaa',
    searchShipmentIdOrCustomerRef: 'Hae lähetystunnusta tai asiakkaan viitettä',
    state: '{{count}} tila',
    state_other: '{{count}} tilaa',
    invoiceOrderAction: 'Laskun tilaus',
    invoiceOrderAction_other: 'Laskuta tilaukset',
    quantity: 'Määrä',
    perUnitCustomer: 'Asiakkaan hinta per yksikkö',
    carrierPerUnitPrice: 'Kuljetusyhtiön hinta yksikköä kohden',
    enableCalculator: 'Ota käyttöön hinnan ja määrän kertolasku',
    mustBeNegative: 'Täytyy olla < 0',
    mustBePositive: 'Täytyy olla > 0',
    description: 'Kuvaus',
    customerAmount: 'Asiakkaan summa',
    carrierAmount: 'Yksikkön määrä',
    failedPriceListLink: 'Epäonnistunut hinnasto Pricing Enginessä',
    failedPriceList: 'Epäonnistunut hinnasto',
    priceFailureDetail: 'Hintavirheen tiedot',
    priceFailureReason: 'Hinnan epäonnistumisen syy',
    priceFailureReasons: {
      missingAttributeValue: 'Attribuutti puuttuu',
      matrixLookupMiss: 'Matriisivirhe',
      invalidExpression: 'Virheellinen lauseke',
      scriptError: 'Skriptivirhe'
    },
    invoiceFailureDetail: 'Laskun epäonnistumisen syy',
    invoiceDepartment: 'Laskutusosasto',
    invoiceDepartment_other: 'Laskutusosastot',
    invoiceDepartments: 'Laskutusosasto(t)',
    dashboard: 'Dashboard',
    invoicingJobsSummary: 'Laskutustyön yhteenveto',
    invoicingStatus: 'Laskutuksen tila',
    invoicingStatusDescription: 'Näytetään tilaukset viimeisen {{months}} kuukauden ajalta.',
    ordersOnPage: 'Näytetään {{count}} tilausta sivulla',
    ordersFoundCount: '{{count}} tilaus löydetty',
    ordersFoundCount_other: '{{count}} tilausta löytyi',
    ordersNotInvoiced: 'Tilaukset, joita ei ole vielä laskutettu',
    invoicingFailedDescription: 'Tilausten käsittely epäonnistui',
    text: 'Laskun teksti',
    correctionPendingDescription: 'Tilaukset odottavilla korjauksilla',
    ordersPausedFromInvoiced: 'Tilaukset, joiden laskutus on keskeytetty',
    invoicingZeroPriceDescription: 'Tilaukset, joissa on hyväksymättömiä nollarivejä',
    sendInvoices: 'Lähetä laskut',
    sendInvoicesDescription: 'Olet laskuttamassa: {{departments}}. Valitse laskutusjakson päivämäärä tai ajanjakso.',
    sendInvoiceDateValidationErrorOneMonth: 'Päivämäärän enimmäispituus on 1 kuukausi',
    invoicingInProgress: 'Laskutus osastolle {{departmentName}} on käynnissä, {{count}} laskutustyötä jäljellä',
    invoicingInFinished: 'Laskutus laitokselle {{departmentName}} on valmis',
    orderEnqueuedForInvoicing: 'Tilaus on jonossa laskutusta varten',
    orderEnqueuedForInvoicing_other: 'Tilaukset on jonossa laskutusta varten',
    orderSuccessNotInvoiced: 'Tilaus muutettiin laskuttamattomaksi',
    orderSuccessNotInvoiced_other: 'Tilaukset muutettiin laskuttamattomiksi',
    orderSuccessInvoicedOk: 'Tilaus merkittiin laskutetuksi OK',
    orderSuccessInvoicedOk_other: 'Tilaukset merkittiin laskutetuiksi OK',
    orderSuccessExcluded: 'Tilaus poistettiin laskutuksesta',
    orderSuccessExcluded_other: 'Tilaukset poistettiin laskutuksesta',
    howManyInvoices: 'Kuinka monta laskua lähetetään',
    fetchAmount: 'Hae summa',
    wantToResend: 'Tämä tilaus on jo laskutettu. Oletko varma, että haluat lähettää sen uudelleen?',
    adHocInvoiceOrder: 'Olet laskuttamassa tätä tilausta. Haluatko jatkaa?',
    adHocInvoiceOrder_other: 'Olet laskuttamassa näitä tilauksia. Haluatko jatkaa?',
    pauseOrders: 'Pysäytä tilaukset',
    datePeriod: 'Päivämääräjakso',
    ordersWereSuccessfullyPaused: '{{count}} tilauksen laskutuksen pysäytys onnistui',
    ordersWereSuccessfullyPaused_other: '{{count}} tilauksen laskutus keskeytettiin onnistuneesti',
    releaseOrders: 'Vapauta tilaukset',
    recalculatePrices: 'Laske hinnat uudelleen',
    ordersSentForPriceRecalculation: '{{count}} tilaus on lisätty jonoon uudelleenlaskentaa varten',
    ordersSentForPriceRecalculation_other: '{{count}} tilausta on lisätty jonoon uudelleenlaskentaa varten',
    ordersWereSuccessfullyReleased: '{{count}} tilaus lisättiin jonoon uudelleenlaskentaa varten',
    ordersWereSuccessfullyReleased_other: '{{count}} tilausta vapautettiin onnistuneesti laskutettavaksi',
    addUnit: 'Lisää yksikkö',
    overrideUnit: 'Ohita yksikkö',
    addUnitDescription: 'Lisää yksikkö valitsemiisi tilauksiin. Tämä yksikkö on se, jota tilitetään.',
    addUnitToOrders: 'Lisää yksikkö tilauksiin',
    addUnitToOrder: '{{unit}} lisättiin onnistuneesti {{count}} tilaukseen',
    addUnitToOrder_other: '{{unit}} lisättiin onnistuneesti {{count}} tilaukseen',
    addUnitBulkDisabled: 'Yksikkö voidaan lisätä vain tilauksiin, joissa ei ole yksikköä',
    approveIncompletePrices: 'Hyväksy epätäydellisillä hinnoilla',
    manualOverrideTitle: 'Manuaalinen ohitus laskutuksen tila',
    selectStatus: 'Valitse uusi laskutustila',
    status: 'Nykyinen tila on',
    status_other: 'Nykyiset tilat ovat',
    manualOverrideLegend: 'Olet korvaamassa yhden valitun tilauksen laskutustilan. Nykyinen tila on: {{statuses}}.',
    manualOverrideLegend_other:
      'Olet korvaamassa {{count}} valitun tilauksen laskutustilan. $t(invoice.status, {"count": {{statusCount}} }): {{statuses}}.',
    manualOverrideLegend2: 'Valitse tilauksen haluttu laskutustila alta.',
    manualOverrideLegend2_other: 'Valitse haluamasi laskutustila näille tilauksille alta.',
    unitId: 'Yksikkötunnus',
    bannerOldInvoicePage:
      'Elokuun 26. päivä <0>uusi laskutussivu</0> avautuu oletuksena. Suosittelemme aloittamaan uuden sivun käytön. Lisätietoja uudesta sivusta <1>täällä</1>.',
    acceptIncompletePricesTitle: 'Hyväksy epätäydelliset hinnat',
    acceptIncompletePricesModalQuestion:
      'Olet hyväksymässä {{count}} tilauksen, jonka hinnat ovat puutteelliset. Haluatko varmasti jatkaa?',
    acceptIncompletePricesModalQuestion_other:
      'Olet hyväksymässä {{count}} tilausta, joiden hinnat eivät ole täydellisiä. Haluatko varmasti jatkaa?',
    confirmCancelDialog: {
      title: 'Sinulla on tallentamattomia muutoksia',
      question: 'Sinulla on tallentamattomia muutoksia. Haluatko jatkaa?',
      abort: 'Pysy sivulla',
      confirm: 'Jatka tallentamatta'
    },
    download: 'Lataa lasku',
    downloadVendor: 'Lataa toimittajan lasku',
    downloadInvoiceTooltip: 'Lasku voidaan näyttää vasta, kun ulkoinen järjestelmä on antanut sen',
    multilegFilter: {
      label: 'Suodata osittainen multileg',
      ALL: 'Näytä kaikki',
      ONLY_PARTIALLY_READY_MULTILEG: 'Näytä vain osittain valmiit',
      EXCLUDE_PARTIALLY_READY_MULTILEG: 'Sulje pois osittain valmiit'
    },
    invoicingAwaitingAcknowledgementDescription:
      'Laskutetut tilaukset, jotka odottavat rekisteröinnin vahvistusta ulkoisesta järjestelmästä',
    invoicedOn: 'Viimeksi lähetetty',
    filterStates: 'Suodata tilat',
    filterDeliveryDate: 'Toimituspäivä',
    clearFilters: 'Tyhjennä suodattimet'
  },
  live: {
    onlyDeviated: 'Näytä vain poikkeamareitit',
    bannerOldLivePage:
      '<0>Kokeile</0> uutta Live-sivua, jossa on parannetut toiminnot ja uusi muotoilu. Suosittelemme käyttämään uutta live-sivua, jotta voit tottua siihen ennen kuin poistamme sivun kokonaan.',
    shipment: 'lähetys',
    shipmentFrom: 'Mistä',
    shipmentTo: 'Minne',
    confirm: 'Vahvista',
    unconfirm: 'Hylkää',
    confirmedBy: 'Vahvistanut {{name}} klo {{time}}',
    theCourier: 'Kuriiri',
    activeRoutes: 'Aktiiviset reitit',
    routeDeviation: 'Reitin poikkeama',
    routeDeviations: 'Reitin poikkeamat',
    multipleDeviations: 'Useita poikkeamia',
    recentDeviations: 'Viimeaikaiset poikkeamat',
    noRoutesFound: 'Reittejä ei löytynyt',
    noDeviationsFound: 'Poikkeamia ei löytynyt',
    consignmentDamage: 'Lähetyksen vahingot',
    shipmentDeviation: 'lähetyksen poikkeama',
    outsideServiceTime: 'Palveluajan ulkopuolella',
    outsideEstimatedTime: 'Arvioidun aikaikkunan ulkopuolella',
    deliveryLocationDeviation: 'Odottamaton sijainti',
    eventTextDeviationOne: 'Kuljettajalla {{name}} on lähetyksen poikkeamia.',
    eventTextDeviationMany: 'Kuljettajalla {{name}} on {{count}} toimituspoikkeamaa.',
    eventTextDamageOne: 'Kuljettajalla {{name}} on vaurioita {{count}} lähetyksessä.',
    eventTextDamageMany: 'Kuljettajalla {{name}} on vaurio lähetyksessä.',
    eventTextServiceTimeWindow: '{{name}} toimitetti palveluaikaikkunan ulkopuolella.',
    eventTextEstimatedTimeWindow: '{{name}} toimitetti arvioidun aikaikkunan ulkopuolella.',
    eventTextDeviated: '{{name}} on poikennut reitiltä.',
    eventTextDeliveryLocationDeviation:
      '{{name}} toimitettu/ yritetty toimittaa {{distance}} metriä odotetusta sijainnista.',
    eventHelpDeviation: 'Kuljettajalla {{name}} on poikkeama lähetysnumerossa {{shipmentId}}.',
    eventHelpDamage: 'Kuljettajalla {{name}} on vaurio lähetyksessä numero {{shipmentId}}.',
    filterOngoing: 'Jatkuva',
    filterNotStarted: 'Ei alkanut',
    filterFinished: 'valmis',
    filterOnlyDeviated: 'Vain poikkeamat',
    filterShipmentDeviations: 'lähetyksen poikkeamat',
    filterShipmentDamage: 'Lähetysvaurio',
    filterEstimatedTime: 'Arvioitu aika',
    filterServiceTime: 'Palveluaika',
    filterRouteDeviations: 'Reittipoikkeamat',
    filterDeliveryLocationDeviation: 'Odottamaton sijainti',
    filterConfirmed: 'vahvistettu',
    routeProgress: 'Valmis {{complete}} / {{total}}',
    routeDuration: '{{from}}–{{to}}',
    routeDelayed: 'viivästynyt',
    routeAhead: 'Eteenpäin',
    routeOnTime: 'Ajallaan',
    routeUnknown: 'Tuntematon',
    routeDeviationsNone: 'Ei poikkeamia',
    routeDeviationCount: '{{unhandledDeviations}} / {{totalDeviations}}',
    routeHasHandleDeviations: 'Reitillä on {{count}} käsiteltyä poikkeamaa',
    routeHasHandleDeviations_other: 'Reitillä on {{count}} käsiteltyä poikkeamaa',
    openRoute: 'Katso reitti',
    openShipment: 'Katso lähetys',
    viewRoute: 'Näytä reitti',
    deviated: 'poikkeama',
    offRoute: 'Pois reitiltä',
    onRoute: 'Tiellä',
    allRoutesStates: 'Kaikki reittitilat',
    selectedRouteStates: '{{count}} reitin tila',
    selectedRouteStates_other: '{{count}} reittitilaa',
    noSelectedStates: 'Ei valittuja tiloja',
    allDeviationTypes: 'Kaikki poikkeamatyypit',
    selectedDeviationTypes: '{{count}} poikkeamatyyppi',
    selectedDeviationTypes_other: '{{count}} poikkeamatyyppiä',
    showHandledDeviations: 'Näytä käsitellyt poikkeamat ({{count}})',
    noSelectedTypes: 'Ei valittuja tyyppejä',
    viewShipment: 'Näytä lähetys',
    selectAllRouteStates: 'Valitse kaikki reittitilat',
    noRoutesWithDeviations: 'Ei reittejä käytettävissä',
    selectAllDeviationTypes: 'Valitse kaikki poikkeamatyypit',
    noDeviationOnRoute: 'Ei poikkeamia reitillä',
    noDeviationAvailable: 'Ei poikkeamia käytettävissä',
    noDeviationsOnFilter: 'Valitulla suodattimella ei ole poikkeamia. Kokeile toista suodatinta',
    noRoutesOnFilter: 'Valitulle suodattimelle ei ole saatavilla reittejä. Kokeile toista suodatinta',
    eventHelpServiceTimeWindow:
      '{{name}} on toimittanut lähetysnumeron {{shipmentId}} klo {{actual}}, joka on palveluaikaikkunan {{earliest}}-{{latest}} ulkopuolella.',
    eventHelpEstimatedTimeWindow:
      '{{name}} on toimittanut lähetyksen numero {{shipmentId}} klo {{actual}}, mikä on arvioidun aikaikkunan {{earliest}}–{{latest}} ulkopuolella.',
    eventHelpDriverDeviated: '{{name}} on toimittanut lähetysnumeron {{shipmentId}} väärässä järjestyksessä.',
    eventHelpDriverDeviatedAtPickup: '{{name}} on noutanut lähetysnumeron {{shipmentId}} väärässä järjestyksessä.',
    eventHelpDriverDeviatedAtPickupBefore:
      '{{name}} on noutanut lähetysnumeron {{shipmentId}} väärässä järjestyksessä, pysähtyen noutoon #{{actual}} ennen noutoa #{{expected}}.',
    eventHelpDriverDeviatedAtPickupAfter:
      '{{name}} on noutanut lähetysnumeron {{shipmentId}} väärässä järjestyksessä, pysähtyen noutoon #{{actual}} noudon #{{expected}} jälkeen.',
    eventHelpDriverDeviatedBefore:
      '{{name}} on toimittanut lähetysnumeron {{shipmentId}} väärässä järjestyksessä, pysähtyen toimitukseen #{{actual}} ennen toimitusta #{{expected}}.',
    eventHelpDriverDeviatedAfter:
      '{{name}} on toimittanut lähetysnumeron {{shipmentId}} väärässä järjestyksessä, pysähtyen toimitukseen #{{actual}} toimituksen #{{expected}} jälkeen.',
    eventHelpDeliveryLocationDeviation: {
      withShipmentId:
        '{{name}} on toimittanut tai poikennut lähetysnumeron {{shipmentId}} <4>tänne</4>, {{distance}} metrin päähän <9>odotetusta sijainnista</9>.',
      withoutShipmentId:
        '{{name}} on toimittanut tai poikennut <4>tänne</4>, {{distance}} metrin päässä <9>odotetusta sijainnista</9>.'
    },
    search: 'Hae reitin, laitteen tai kuljettajan mukaan',
    unhandled: 'käsittelemättömät',
    deviations: 'poikkeamat',
    mostDeviations: 'Suurin osa poikkeamista',
    latestInTime: 'Viimeisin ajallaan',
    earliestInTime: 'Aikaisintaan',
    sortOn: 'Lajittele',
    late: 'myöhässä',
    early: 'etuajassa',
    stops: 'Pysähdykset: {{stops}}',
    deviatedFromRoute: 'Poikennut reitiltä',
    totalTimeMajorDeviations: 'Merkittävien poikkeamien kokonaisaika (≥5 min)',
    totalTimeMinorDeviations: 'Pienten poikkeamien kokonaisaika (<5 min)',
    lateOrEarlyFirstStop: 'Myöhässä tai etuajassa ensimmäiseen toimitukseen',
    showAdjusted: 'Näytä korjattu aika',
    showAdjustedTooltip: 'Korjattu aika näkyy vastaanottajan seurantasivulla',
    showDiff: 'Näytä aika pysähdysten välillä',
    diff: 'Aika pysähdysten välillä',
    showDiffTooltip: 'Ero suunnitellun (ETD) ja todellisen ajan välillä pysähdysten välillä',
    modalTableSummary: 'Kokonaisreittiaika',
    liveModalActualTooltip1: 'Verrattuna ETD:hen:',
    liveModalActualTooltip2: 'Vihreä: Enintään 15 min',
    liveModalActualTooltip3: 'Oranssi: 15–30 min',
    liveModalActualTooltip4: 'Punainen: Yli 30 min',
    routeStateFilter: 'Reitin tila',
    departmentFilter: 'Osastosuodatin',
    allDepartments: 'Kaikki osastot',
    deviationTypeFilter: 'Poikkeamatyyppisuodatin',
    showSummary: 'Näytä yhteenveto'
  },
  userRolesAdmin: {
    price: 'Hinta',
    searchPlaceholder: 'Etsi käyttäjäroolia',
    userRoles: 'Käyttäjäroolit',
    successCreateMessage: '{{name}} luotiin onnistuneesti',
    successUpdateMessage: '{{name}} päivitettiin onnistuneesti',
    saveRole: 'Tallenna rooli',
    editRole: 'Muokkaa {{name}}',
    createNewRole: 'Luo uusi rooli',
    nameOfRole: 'Roolin nimi',
    nameRequired: 'Nimi vaaditaan',
    descriptionRequired: 'Kuvaus vaaditaan',
    descriptionLabel: 'Kuvaus (max 240 merkkiä)',
    iconLabel: 'Valitse haluamasi ikoni käyttäjäroolille',
    selectRoleTitle: 'Valitse käyttöoikeus roolille',
    emptyState: 'Hakulauseella ei löytynyt rooleja',
    deleteConfirm: 'Oletko varma, että haluat poistaa {{name}}?',
    deleteSuccess: 'Rooli {{name}} poistettiin onnistuneesti',
    settings: 'Asetukset',
    accessRights: 'Käyttöoikeudet',
    settingsTitle: 'Asetukset roolille',
    settingsDescription: 'Englanti on pakollinen. Jos muita kieliä ei valita, käytetään varakielenä englantia.',
    additionalLanguagesTitle: 'Lisää muita kieliä',
    customerPortalAccess: 'Asiakasportaalin pääsy',
    defaultForUserRole: 'Käytä oletusroolina (valinnainen)',
    event: 'Tapahtuma',
    financialAccess: 'Rahoitusoikeudet',
    invoiceActions: 'Laskutoimenpiteet',
    orderAttributes: 'Tilausattribuutit',
    findApiOrder: 'Etsi API-tilaus',
    optimus: 'Optimus',
    noAccess: 'Ei pääsyä',
    noAccessToApiOrder: 'Ei pääsyä Etsi API-tilaukseen',
    noAccessToOptimus: 'Ei pääsyä Optimukseen',
    optimusViewDescription:
      'Käyttäjä voi tarkastella palveluja osastoilta ja asiakkailta, mutta ei voi tehdä muutoksia',
    optimusFullDescription: 'Käyttäjä voi lisätä ja muokata palveluja osastoille ja asiakkaille',
    ordersApiSearchRestrictedDescription:
      'Käyttäjä voi etsiä tilauksia osastoilta tai asiakkailta, joihin heillä on pääsy',
    ordersApiSearchFullDescription: 'Käyttäjä voi etsiä tilauksia kaikilta osastoilta ja asiakkailta',
    addRole: 'Lisää rooli',
    addedRole: 'Rooli lisätty',
    removeRole: 'Poista rooli',
    importExport: 'Tuo / Vie',
    importExportExtendedDescription: 'Sisältää pääsyn laajennettuun kuriiriraporttiin.',
    importExportExtendedSaaSDescription: 'Sisältää pääsyn päivän loppuraporttiin.',
    billingOrdersReadOnlyDescription: 'Rajoitettu lukuoikeus kohteisiin {{billingOrderTypes}}',
    billingOrdersDescription: 'Täysi pääsy kohteisiin {{billingOrderTypes}}'
  },
  webhook: {
    messages: {
      title: 'Webhook-viestit',
      resendConfirmation: 'Webhook-viesti lähetetty uudelleen'
    },
    resend: 'Lähetä uudelleen',
    requestedAfter: 'Pyydetty jälkeen',
    messageDetails: {
      title: 'Webhook-viesti',
      generalHeading: 'Yleiset tiedot',
      requestHeading: 'Pyynnön tiedot',
      loading: 'Haetaan webhook-viestiä...',
      copyTooltip: 'Kopioi payload',
      copied: 'Payload on kopioitu'
    },
    messageId: 'Viestin ID',
    messageCreatedAt: 'Viesti luotu',
    eventType: 'Tapahtumatyyppi',
    packageId: 'Paketin tunnus',
    shipmentId: 'Lähetystunnus',
    subscriptionUrl: 'Tilauksen URL',
    subscriptionId: 'Tilauksen ID',
    request: {
      at: 'Pyyntö klo',
      after: 'Pyyntö klo',
      retry: 'Viestin uudelleenyritys'
    },
    response: {
      heading: 'Vastauksen tiedot',
      at: 'Vastaus klo',
      status: 'Vastauksen tila'
    },
    responseCategories: {
      Informational: 'Informatiivinen (100-199)',
      Successful: 'Onnistunut (200-299)',
      Redirect: 'Uudelleenohjaus (300-399)',
      ClientError: 'Asiakasvirhe (400-499)',
      ServerError: 'Palvelinvirhe (500-599)',
      UnknownError: 'Tuntematon virhe',
      Pending: 'Odottaa'
    }
  },
  validationError: {
    provideEmail: 'Sinun täytyy antaa sähköposti',
    provideValidEmail: 'Sinun täytyy antaa kelvollinen sähköposti',
    youMustSelectCustomer: 'Sinun täytyy valita asiakas'
  },
  roles: {
    ADMIN_OPTIMIZING: 'Optimointi',
    ADMIN_LM_EVENTS: 'LM-tapahtumat',
    ADMIN_PH: 'ParcelHub',
    ADMIN_INTEGRATIONS: 'Integraatiot',
    ADMIN_NUMBER_SERIES: 'Numerosarjat',
    ADMIN_TEXTS: 'Palvelut',
    ADMIN_JOBS: 'Töiden seuranta',
    ADMIN_PRE_ADVICE: 'Ennakkoilmoitus',
    ADMIN_SETTINGS: 'Asetukset',
    ADMIN_SHD: 'SHD',
    ADMIN_CUSTOMER: 'Rajoitettu käyttöoikeus',
    ADMIN_CUSTOMER_GROUP: 'Asiakasryhmät',
    ADMIN_HOLIDAYS: 'Pyhäpäivät',
    ADMIN_MATRIX: 'Matriisi',
    ADMIN_USERS: 'Käyttäjät',
    ADMIN_DEPARTMENT: 'Osastot',
    ADMIN_DEPARTMENT_GROUP: 'Osastoryhmät',
    ADMIN_CUSTOMER_ALL: 'Täysi käyttöoikeus',
    ADMIN_VENDORS: 'Toimittajat',
    ADMIN_PRICE_ARTICLE: 'Luo ja ylläpidä artikkeleita',
    ADMIN_PRICE_ACCOUNTING: 'Muuta kirjanpitojärjestelmän asetuksia',
    ADMIN_PRODUCTION_TIME_WINDOW: 'Tuotannon aikaikkuna',
    OPTIMUS_VIEW: 'Lukuoikeus Optimukseen',
    OPTIMUS_EDIT: 'Täysi käyttöoikeus Optimukseen',
    ORDERS_API_SEARCH_RESTRICTED: 'Rajoitettu hakuoikeus Find API Orderiin',
    ORDERS_API_SEARCH_FULL: 'Täysi hakuoikeus Find API Orderiin',
    CUSTOMER_PORTAL: 'Asiakkaan käyttöoikeus asiakasportaaliin',
    CUSTOMER_PORTAL_ADMIN: 'Ylläpitäjän käyttöoikeus asiakasportaaliin',
    CUSTOMER_PORTAL_VIEW_PRICE: 'Näkee hinnat asiakasportaalissa',
    VIEW_PRICE: 'Näkee hinnat',
    VIEW_PRICE_EVENTS: 'Näkee hintatapahtumat',
    FINANCIAL_VIEW_CUSTOMER_AND_UNIT_PRICE: 'Näkee reittien hinnat',
    BOOK_SHIPMENT: 'Voi tilata lähetyksiä',
    PLANNER_ADDRESSES: 'Osoitteet',
    PLANNER_BILLING_ORDERS: 'Laskutustilaukset',
    PLANNER_BILLING_ORDERS_READ: 'Laskutustilaukset (vain luku)',
    PLANNER_BOOKING: 'Tilaus',
    PLANNER_CORRECTIONS: 'Muutokset',
    PLANNER_COURIERS: 'Lähetit',
    PLANNER_DISPATCHING: 'Ajojärjestely',
    PLANNER_IMPORT_EXPORT: 'Rajoitettu pääsy raportteihin',
    PLANNER_IMPORT_EXPORT_EXTENDED: 'Pääsy kaikkiin raportteihin',
    PLANNER_INVOICING: 'Laskutus',
    PLANNER_LIVE: 'Live',
    PLANNER_MANAGE_RETURNS: 'Hallinnoi palautuksia',
    PLANNER_PICKUP_ORDERS: 'Noutotilaukset',
    PLANNER_RECURRING_ORDERS: 'Vakiot',
    PLANNER_ROUTE_PLANNING: 'Reittisuunnittelu',
    PLANNER_SHIPMENTS: 'Lähetykset',
    PLANNER_UNITS: 'Yksiköt',
    PLANNER_UNITS_REMOVE: 'Poista yksiköitä osastolta',
    PLANNER_UNRESOLVED: 'Ei ratkaistu',
    PLANNER_REPORTS: 'Raportit',
    PLANNER_VEHICLES: 'Ajoneuvot',
    PLANNER_PRE_ADVICE: 'Ennakkoilmoitus',
    ADMIN_ALCOHOL_DELIVERY_EDUCATION: 'Voi lisätä alkoholin toimituskoulutuksen läheteille',
    FINANCIAL_SHOW_INVOICING_PAYLOAD: 'Näytä laskun payload',
    FINANCIAL_DOWNLOAD_INVOICE: 'Lataa lasku',
    FINANCIAL_CREDIT_NOTE: 'Hyvityslasku',
    FINANCIAL_COPY_TO_BILLING_ORDER: 'Kopioi laskutustilaukseen',
    FINANCIAL_VIEW_GROUP: 'Näytä ryhmä',
    FINANCIAL_VIEW_MULTILEG: 'Näytä multileg',
    FINANCIAL_REINVOICE_INVOICED_ORDERS: 'Laskuta laskutetut tilaukset uudelleen',
    FINANCIAL_INVOICE_ACTIONS: 'Laskutoiminnot lähetyksille',
    PRICING_ENGINE: 'Hinnoittelutyökalu',
    READ_ANY_SHIPMENT: 'Lähetys'
  },
  manageReturns: {
    title: 'Hallinnoi palautuksia',
    typesOfReturns: 'Palautustyypit',
    ordersOverAPeriod: 'Näytetään tilaukset viime kuukaudelta.',
    ordersOverAPeriod_other: 'Näytetään tilaukset viimeiseltä {{count}} kuukaudelta.',
    pickedUpByCustomer: 'Noudettu asiakkaan toimesta',
    pickedUpByCustomerDescription: 'Palautukset, jotka asiakas noutaa',
    transferToDifferentTerminal: 'Siirrä eri terminaaliin',
    transferToDifferentTerminalDescription: 'Palautukset, jotka lähetetään toiseen terminaaliin',
    environmentalReturns: 'Ympäristöpalautukset',
    environmentalReturnsDescription: 'Kierrätettävät palautukset, kerätty konttiin',
    returnForDelivery: 'Palautus toimitettavaksi',
    returnForDeliveryDescription: 'Palautukset, jotka reititetään ja toimitetaan',
    MANUAL_RETURNS: 'Manuaaliset palautukset',
    manualReturnsDescription: 'Tilaus, jossa palautusvaihetta ei ole vielä luotu',
    returnToSenderTitle: 'Haluatko palauttaa lähetykset lähettäjälle',
    manuallyMarkAsHandled: 'Merkitse manuaalisesti käsitellyksi',
    manuallyMarkAsHandledTooltip: 'Kun lähetys on merkitty käsitellyksi, se poistuu listalta',
    ordersFoundCount: '{{count}} tilaus löydetty',
    ordersFoundCount_other: '{{count}} tilausta löydetty',
    PICKED_UP_BY_CUSTOMER: 'Noudettu asiakkaan toimesta',
    TRANSFER_TO_DIFFERENT_TERMINAL: 'Siirrä eri terminaaliin',
    ENVIRONMENTAL_RETURNS: 'Ympäristöpalautukset',
    RETURN_FOR_DELIVERY: 'Palautus toimitettavaksi',
    ordersAlreadyHandled: 'Kaikki tilaukset on käsitelty',
    ordersAlreadyHandledDescription: 'Emme löytäneet käsittelemättömiä tilauksia.',
    manuallyMarkAsHandledModal: {
      title: 'Merkitse manuaalisesti käsitellyksi',
      shipmentsCount: '{{count}} lähetys',
      shipmentsCount_other: '{{count}} lähetystä',
      description:
        'Kun lähetykset on merkitty käsitellyiksi, ne poistuvat listalta. Tätä toimintoa ei voi perua. Lähetykset löytyvät hakusivulta.',
      confirm: 'Merkitse käsitellyksi'
    },
    manuallyMarkAsHandledSuccess: '{{count}} lähetys merkittiin käsitellyksi',
    manuallyMarkAsHandledSuccess_other: '{{count}} lähetystä merkittiin käsitellyksi',
    returnToSenderSuccess: '{{count}} lähetys palautettiin lähettäjälle',
    returnToSenderSuccess_other: '{{count}} lähetystä palautettiin lähettäjälle',
    selectCustomer: 'Valitse asiakas',
    customer: 'Asiakas',
    customer_other: 'Asiakkaat',
    allCustomers: 'Kaikki asiakkaat',
    selectDestination: 'Valitse määränpää',
    destination: 'Loppumääränpää',
    destinationDIP: 'Määränpää DIP',
    returnShipmentColumns: 'Palautustiedot',
    allDestinations: 'Kaikki määränpäät',
    noDate: 'Kaikki',
    zeroDays: '0 päivää',
    oneTo6Days: '1–6 päivää',
    moreThan7Days: '> 7 päivää',
    moreThan15Days: '> 15 päivää',
    moreThan30Days: '> 30 päivää',
    customerDate: 'Mukautettu',
    daysOnTerminal: 'Päiviä terminaalissa',
    months: 'Kuukaudet',
    lastMonths: 'Viimeinen {{count}} kuukausi',
    lastMonths_other: 'Viimeiset {{count}} kuukautta',
    printList: 'Tulosta lista',
    returnToSender: 'Palauta lähettäjälle',
    returnToSenderQueued: 'Palautus lähettäjälle on jonossa',
    returnToSenderConfirmation: 'Haluatko palauttaa tämän lähetyksen lähettäjälle?',
    returnToSenderFailed: 'Lähetystä ei voitu palauttaa lähettäjälle',
    returnToSenderDisabledTooltip:
      'Et voi palauttaa lähetyksiä, jotka ovat poikenneet reitiltään, toimitettu tai jotka on jo merkitty palautettaviksi',
    senderDIP: 'Lähettäjä DIP',
    createReturnLabel: 'Luo palautusetiketti'
  },
  parcelHubAdmin: {
    title: 'ParcelHub',
    startTitle: 'Hae lähetystä',
    startDescription: 'Syötä lähetysnumero ja paina hae.',
    noResultsTitle: 'Viestejä ei löytynyt',
    loadFailedTitle: 'Viestien haku epäonnistui',
    loadFailedDescription: 'ParcelHub-consumer ei vastannut. Yritä uudelleen tai tarkista, että palvelu on käynnissä.',
    payloadLoadFailed: 'Tämän viestin payloadin haku epäonnistui.',
    shipment: 'Lähetys',
    topic: 'Topic',
    partition: 'Osio',
    offset: 'Offset',
    operation: 'Toiminto',
    packageId: 'Kollin ID',
    timestamp: 'Aikaleima',
    payload: 'Payload',
    viewPayload: 'Näytä payload',
    consignmentEvents: 'Lähetystapahtuma',
    consignmentItemEvents: 'Kollitapahtuma',
    eventCode: 'Tapahtumakoodi',
    event: 'Tapahtuma',
    receivedAt: 'Vastaanotettu',
    queuedAt: 'Asetettu jonoon',
    processed: 'Käsitelty',
    processedAt: 'Käsitelty',
    processingLag: 'Käsittelyviive',
    eventsNoResultsTitle: 'Tapahtumia ei löytynyt',
    eventsLoadFailedTitle: 'Tapahtumien haku epäonnistui',
    eventsLoadFailedDescription: 'Tapahtumien haku epäonnistui. Yritä uudelleen.',
    eventPayloadLoadFailed: 'Tämän tapahtuman payloadin haku epäonnistui.'
  },
  apolloAdmin: {
    title: 'Integraatiot',
    emptyTitle: 'Ei pyyntöjä',
    emptyDescription: 'Valitse haluamasi päivämäärät ja paina hae.',
    reqType: 'Pyynnön tyyppi',
    routeId: 'Reitin id',
    routeName: 'Reitin nimi'
  },
  preAdviceFollowup: {
    title: 'Hallitse ennakkoilmoitusta',
    toBeHandled: 'Käsiteltävä',
    failedOrders: 'Epäonnistuneet tilaukset',
    failedOrdersDescription: 'Vastaanottaja ei ole saanut ilmoitusta',
    manualPreAdvice: 'Manuaalinen ennakkoilmoitus',
    manualPreAdviceDescription: 'Tilaukset, joissa on manuaalinen laukaisu ylläpitosivulla',
    preAdviceLocked: 'Ennakkoilmoitus lukittu',
    preAdviceLockedDescription: 'Tilaukset, jotka ovat pidossa ja odottavat toimia',
    missingRules: 'Puuttuvat säännöt',
    missingRulesDescription: 'Tilauksilta puuttuu ennakkoilmoituksen sääntö.',
    inProgress: 'Käynnissä',
    inProgressDescription: 'Tilaukset, joilla ennakkoilmoitus on käynnissä',
    notStarted: 'Ei aloitettu',
    notStartedDescription: 'Tilaukset, joilla on sääntö mutta ennakkoilmoitusta ei ole aloitettu',
    ordersFoundCount: '{{count}} tilaus löytyi',
    ordersFoundCount_other: '{{count}} tilausta löytyi',
    FAILED_ORDERS: 'Epäonnistuneet tilaukset',
    MANUAL_PRE_ADVICE: 'Manuaalinen ennakkoilmoitus',
    PRE_ADVICE_LOCKED: 'Ennakkoilmoitus lukittu',
    MISSING_RULES: 'Puuttuvat säännöt',
    IN_PROGRESS: 'Käynnissä',
    NOT_STARTED: 'Ei aloitettu',
    ordersAlreadyHandled: 'Kaikki tilaukset on käsitelty',
    ordersAlreadyHandledDescription: 'Emme löytäneet käsittelemättömiä tilauksia.',
    updatePhoneNumber: 'Vaihda tai lisää puhelinnumero',
    updateEmailAddress: 'Vaihda tai lisää sähköpostiosoite',
    removeShipmentFromPreAdvice: 'Poista lähetys ennakkoilmoituksesta',
    bookDateAndTime: 'Varaa päivämäärä ja aika',
    manuallyPreAdvice: 'Manuaalinen ennakkoilmoitus',
    unlockPreAdvice: 'Avaa ennakkoilmoitus',
    lockPreAdvice: 'Lukitse ennakkoilmoitus',
    triggerPreAdvice: 'Käynnistä ennakkoilmoitus',
    selectedCustomers: '{{count}} asiakas',
    selectedCustomers_other: '{{count}} asiakasta',
    allCustomers: 'Kaikki asiakkaat',
    selectRowWithOrderId: 'Valitse rivi tilaus-ID:llä {{id}}',
    updateRecipientPhoneNumber: 'Päivitä puhelinnumero',
    phoneNumberUpdated: 'Puhelinnumero päivitetty lähetys-ID:lle: {{shipmentId}}',
    phoneNumberUpdatedAndPreAdviceSent:
      'Puhelinnumero päivitetty ja ennakkoilmoitus lähetetty lähetys-ID:lle: {{shipmentId}}',
    samePhoneNumberAlreadySet: 'Sama puhelinnumero on jo asetettu lähetykselle.',
    updateRecipientEmailAddress: 'Päivitä sähköpostiosoite',
    emailAddressUpdated: 'Sähköpostiosoite päivitetty lähetys-ID:lle: {{shipmentId}}',
    emailAddressUpdatedAndPreAdviceSent:
      'Sähköpostiosoite päivitetty ja ennakkoilmoitus lähetetty lähetys-ID:lle: {{shipmentId}}',
    emailAddressUpdatedBulk: 'Sähköpostiosoite päivitetty {{count}} lähetykselle',
    emailAddressUpdatedBulk_other: 'Sähköpostiosoite päivitetty {{count}} lähetykselle',
    emailAddressUpdatedAndPreAdviceSentBulk:
      'Sähköpostiosoite päivitetty ja ennakkoilmoitus lähetetty {{count}} lähetykselle',
    emailAddressUpdatedAndPreAdviceSentBulk_other:
      'Sähköpostiosoite päivitetty ja ennakkoilmoitus lähetetty {{count}} lähetykselle',
    sameEmailAddressAlreadySet: 'Sama sähköpostiosoite on jo asetettu lähetykselle.',
    manuallyPreAdvicedSuccess: 'Onnistuneesti käynnistetty ennakkoilmoitus {{count}} lähetykselle',
    nrOfSelected: '{{count}} valittu',
    nrOfSelected_other: '{{count}} valittu',
    sendPreAdvice: 'Lähetä ennakkoilmoitus',
    unlockPreAdviceSuccess: 'Onnistuneesti avattu ennakkoilmoitus {{count}} lähetykselle',
    unlockPreAdviceAndPreAdviceSent: 'Onnistuneesti avattu ja lähetetty ennakkoilmoitus {{count}} lähetykselle',
    lockPreAdviceSuccess: 'Onnistuneesti lukittu ennakkoilmoitus {{count}} lähetykselle',
    saveAndSendPreAdvice: 'Tallenna ja lähetä ennakkoilmoitus',
    finishPreAdviceFollowupSuccess: 'Onnistuneesti poistettu {{count}} lähetystä ennakkoilmoituksesta'
  },
  articles: {
    title: 'Artikkelit',
    number: 'Artikkelinumero',
    name: 'Artikkelin nimi',
    quantity: 'Määrä',
    shipmentArticles: 'Lähetyksen artikkelit',
    noArticlesPresent: 'Ei artikkeleita'
  },
  deliveryNote: {
    title: 'Lähete',
    vatNumber: 'ALV-numero',
    orderNumber: 'Tilausnumero',
    sender: 'Lähettäjä',
    receiver: 'Vastaanottaja',
    phone: 'Puhelin',
    shipmentId: 'Lähetystunnus',
    articles: 'Artikkelit',
    orderDate: 'Tilauspäivä',
    deliveryDate: 'Toimituspäivä',
    deliveryTime: 'Toimitusaika',
    printedDate: 'Tulostuspäivä',
    receiversReference: 'Vastaanottajan viite',
    receiversReferenceNote: 'Käytä tätä numeroa kaikessa yhteydenpidossa kanssamme',
    articleNumber: 'Numero',
    articleName: 'Nimi',
    articlePrice: 'Yksikköhinta',
    articleQuantity: 'Määrä',
    numberOfPackages: 'Pakettien lukumäärä',
    totalWeight: 'Kokonaispaino',
    totalVolume: 'Kokonaisvolyymi',
    print: 'Tulosta lähete'
  },
  coordinates: {
    setCoordinates: 'Aseta koordinaatit',
    title: 'Aseta osoitteiden koordinaatit',
    setCoordinatesCount: 'Aseta koordinaatit ({{count}})',
    zipCodeRange: 'Postinumeroalue',
    goodJob: 'Hyvää työtä',
    noUnresolvedShipments: 'Tälle osastolle tai osastoryhmälle ei löytynyt ratkaisemattomia lähetyksiä',
    coordinateSaved: 'Koordinaatit tallennettu osoitteelle {{address}}',
    checkMapProvider: 'Tarkista {{name}}',
    noDeliveryDate: 'Ei toimituspäivää',
    created: 'Luotu',
    withDeliveryDate: 'Toimituspäivällä ({{count}})',
    withoutDeliveryDate: 'Ilman toimituspäivää ({{count}})',
    applyFilter: 'Käytä suodatinta',
    thereAreUnsetCoordinates: 'Sinulla on {{count}} koordinaatti asetettavana.',
    thereAreUnsetCoordinates_other: 'Sinulla on {{count}} koordinaattia asetettavana.',
    noCoordinateFound:
      'Emme löytäneet koordinaatteja annetulle osoitteelle. Hae osoitetta tai syötä koordinaatit (esim. 59.289976807684084, 18.010318840107406) hakukenttään.'
  },
  relatedOrders: {
    NONE: 'Ei liittyviä tilauksia',
    MULTILEG: 'Multileg',
    PICKUP: 'Nouto',
    DELIVERY: 'Toimitus',
    TRANSPORT: 'Transport',
    CUSTOMER: 'Asiakastilaus'
  },
  vendors: {
    title: 'Toimittajat',
    viewDetails: 'Näytä tiedot',
    searchLabel: 'Etsi toimittajan nimi, toimittajan ID tai yksikön ID',
    searchVendorPlaceholder: 'Etsi toimittajan nimi tai toimittajan ID',
    searchUnitPlaceholder: 'Hae yksikön ID',
    vendorOption: 'Toimittajan nimi/ID',
    unitOption: 'Yksikön ID',
    notFound: 'Hakusanalla ei löytynyt toimittajia',
    initialSearch: 'Etsi toimittajia',
    informationAboutTheVendor: 'Tietoja toimittajasta',
    connectUnit: 'Yhdistä yksikkö',
    connectUnits: 'Yhdistä yksiköt',
    connectedUnits: 'Yhdistetty yksikkö ({{count}})',
    connectedUnits_other: 'Yhdistetyt yksiköt ({{count}})',
    unitsConnected: '{{count}} Yhdistetty yksikkö',
    unitsConnected_other: '{{count}} Yhdistetyt yksiköt',
    unitsConnected_zero: 'Ei yhdistetyt yksiköt',
    paymentTerms: 'Maksuehdot',
    connected: 'Yhdistetty',
    searchForUnitDescription: 'Yksikön valitseminen tarkoittaa, että yksikön osasto vastaa kustannuksista.',
    searchForUnitTitle: '{{vendorSite}} varten {{operatingUnitName}}',
    successToast: 'Päivitetyt yhdistetyt yksiköt toimittajaan {{name}}',
    showConnectedUnits: 'Näytä yhdistetyt yksiköt',
    editConnectedUnits: 'Muokkaa yhdistettyjä yksiköitä',
    searchForUnit: 'Etsi yksikköä',
    searchPage: 'Hakusivu',
    currencyCode: 'Valuuttakoodi',
    connectedToCompany: 'Yhdistetty tähän yritykseen',
    noConnection: 'Ei yhteyttä',
    connectedTo: 'Yhdistetty',
    nothingHereYet: 'Ei vielä mitään',
    emptyStateSelectedVendor: 'Valitse sijaintikoodi yhdistääksesi yksiköitä tai nähdäksesi olemassa olevat yhteydet.',
    selfBilling: 'Tasauslaskutus',
    setUnitSettingsTitle: 'Päivitä yksikön asetukset kohteelle {{name}}',
    setUnitSettingsSelfBillingInternalTrade: 'Tasauslaskutus ja sisäinen kauppatapahtuma ovat aktiivisia.',
    setUnitSettingsNone: 'Tasauslaskutus ja sisäinen kauppatapahtuma eivät ole aktiivisia.',
    setUnitSettingsInternalTrade: 'Tasauslaskutus ei ole aktiivinen, mutta sisäinen kauppatapahtuma on aktiivinen.',
    state: {
      COMPLETE: 'Täydellinen',
      INCOMPLETE: 'Epätäydellinen',
      ALL: 'Kaikki',
      label: 'Valitse toimittajan tila'
    }
  },
  shdAdmin: {
    successfullyDeleted: 'Aikamatriisi poistettiin onnistuneesti',
    successfullyUploaded: 'Aikamatriisi ladattiin onnistuneesti',
    timeWindowForHomeDelivery: 'Aikaväli kotiinkuljetukseen',
    filterByCustomerData: 'Etsi asiakastiedon, alikunden tai asiakasnumeron mukaan',
    uploadTimeMatrixFile: 'Lataa aikamatriisitiedosto',
    downloadExcelTemplate: 'Lataa Excel-malli',
    clickHereOrDragAndDrop: 'Napsauta tästä tai raahaa ja pudota',
    allowedFormats: 'Sallitut muodot ovat XLS ja XLSX',
    existingCustomers: 'Olemassa olevat asiakkaat SHD:llä',
    customerPriceTooltip: 'Jos loppuasiakkaan hinta pitäisi näyttää, aseta liukusäädin päälle',
    deleteModalTitle: 'Poista aikaväli',
    deleteModalDescription:
      'Jos poistat tämän aikavälin, se poistaa kaikki SHD-aikavälit tältä asiakkaalta. Et voi palauttaa tätä toimintoa.',
    exportToExcel: 'Vie Exceliin',
    toggleLabel: 'Vaihda asiakkaan hinta',
    customerNumber: 'Asiakasnumero',
    subCustomer: 'Alikunde',
    customerName: 'Asiakas',
    amountOfPostalCodes: 'Postinumeroiden määrä',
    lastUpdatedAt: 'Viimeksi päivitetty',
    showCustomerPrice: 'Näytä asiakkaan hinta',
    uploadMaximumFileSizeLimit: 'Tiedoston koko ei voi olla suurempi kuin {{size}} KB'
  },
  serviceMapping: {
    title: 'Palvelut',
    serviceName: 'Palvelun nimi',
    pickupTime: 'Noutoaika',
    pickupDuration: 'Noudon kesto',
    pickupPreparation: 'Noudon valmistelu',
    deliveryTime: 'Toimitusaika',
    deliveryDuration: 'Toimituksen kesto',
    deliveryPreparation: 'Toimituksen valmistelu',
    internalName: 'Sisäinen nimi',
    internalDescription: 'Sisäinen kuvaus',
    externalName: 'Ulkoasu nimi',
    externalDescription: 'Ulkoasu kuvaus',
    allowFlexDelivery: 'Salli joustava toimitus',
    timeWindow: 'Aikaväli',
    serviceMappingType: 'Tyyppi',
    serviceLevel: 'Palvelutaso',
    service: 'Palvelu',
    vas: 'VAS',
    stopsBeforeShowEta: 'ETA-pysäkit',
    minutesUntilDelivery: 'ETA minuutteina',
    sendAutomaticEtaSmsHeading: 'ETA SMS',
    createNew: 'Luo uusi',
    serviceAndVasCodes: 'Palvelut ja VAS-koodit',
    successfullyAdded: 'Palvelukartoitus lisätty onnistuneesti listalle',
    successfullyUpdated: 'Palvelukartoitus päivitetty onnistuneesti',
    successfullyDeleted: 'Palvelukartoitus poistettu onnistuneesti',
    editService: 'Muokkaa palvelua',
    createNewService: 'Luo uusi palvelu',
    settingsHeading: 'Palvelun tai VAS:n asetukset',
    selectLevel: 'Valitse taso',
    standardLevel: 'Vakiotaso',
    customerLevel: 'Asiakastaso',
    customerSpecific: 'Asiakaskohtainen',
    selectServiceType: 'Valitse palvelun tyyppi',
    vasToolTip: 'Arvonlisäpalvelu esim. ID-tarkastus',
    customerNumber: 'Asiakastunnus',
    pickupTimeInSeconds: 'Noutopalveluaika (sekunteina)',
    pickupPreparationTime: 'Noutojen valmisteluaika (sekunteina)',
    deliveryTimeInSeconds: 'Jakelupalveluaika (sekunteina)',
    deliveryPreparationTime: 'Jakelujen valmisteluaika (sekunteina)',
    pickupDurationSecondsApartment: 'Noutoaika huoneistoissa (sekunteina)',
    deliveryDurationSecondsApartment: 'Toimitusaika huoneistoissa (sekunteina)',
    deliveryDurationApartmentHeading: 'Toimitusaika huoneistoissa (tällä hetkellä vain H2)',
    timeWindowInMinutes: 'Aikaväli (minuutteina)',
    stopsLeftHeading: 'Milloin haluat näyttää tarkan ETA:n asiakkaalle?',
    stopsLeftDescription: 'Jos jätät tämän kentän tyhjäksi, aikaväli näytetään',
    amountOfStops: 'Pysäkkien määrä',
    flexibleDelivery: 'Joustava toimitus',
    flexibleDeliveryDescription: 'Salli vastaanottajalle valita, että paketti jätetään oven ulkopuolelle',
    flexibleDeliveryCheckboxText: 'Kyllä, vastaanottaja saa valita',
    flexOptions: 'Flex-vaihtoehdot',
    flexOptionsDescription:
      'Tarjoamme asiakkaille kaksi erilaista Flex-toimitusvaihtoehtoa. Ensimmäinen vaihtoehto, Laajennettu Flex, antaa kuljettajan jättää tavarat eri sovittuihin paikkoihin toimitusosoitteessa. Toinen vaihtoehto, Flex, on yksinkertaisempi vaihtoehto, jossa tavarat sijoitetaan vain kiinteistön rajalle. Laajennettu Flex on oletusvaihtoehto, mutta asiakkaat voivat halutessaan vaihtaa yksinkertaisempaan Flex-vaihtoehtoon.',
    unattendedFlex: 'Flex (Valvomaton)',
    extendedFlex: 'Laajennettu Flex (Flex)',
    linkTextToService: 'Linkitä teksti palveluun',
    linkTextToServiceDescription: 'Jos tekstiä ei valita, käytetään oletustekstiä',
    defaultText: 'Oletusteksti',
    listOfServicesAndVases: 'Palveluiden ja VAS-koodien lista',
    searchService: 'Etsi palvelua, VAS tai asiakastunnusta',
    customizedText: 'Mukautettu teksti',
    deleteModalTitle: 'Poista palvelukartoitus',
    deleteModalDescription: 'Tätä toimintoa ei voida peruuttaa',
    infoModal: {
      title: 'Mitä näytetään missä Glow:ssa',
      subHeading1: 'Suunnittelijat ja kuljettajat',
      description1: 'Sisäinen nimi: Palvelun nimi, esim. "Kotitoimitus"',
      description2:
        'Sisäinen kuvaus: Laajennettu tietoa palvelusta, esim. "Tämä pitää toimittaa vastaanottajan valitsemaan huoneeseen."',
      subHeading2: 'Asiakkaat ja vastaanottajat',
      description3: 'Ulkoasu nimi: Palvelun nimi, esim. "Kotitoimitus"',
      description4:
        'Ulkoasu kuvaus: Laajennettu tietoa palvelusta, esim. "Tuotteesi toimitetaan valitsemaasi huoneeseen".'
    },
    routeOptimizing: 'Reitin optimointi',
    routeOptimizingDescription:
      'Tähän antamasi tiedot ohittavat oletusajan ja vaikuttavat reittioptimointiin. Valmisteluaikaa voidaan käyttää palveluissa, joissa useita lähetyksiä toimitetaan samalle vastaanottajalle. Ensimmäisen lähetyksen toimitusaika koostuu tällöin valmisteluajasta ja toimitusajasta, kun taas lisälähetyksillä samalle vastaanottajalle on vain toimitusaika. <br><br>Noutojen oletusasetuksena on 15 sekunnin valmisteluaika ja 1 sekunti lähetystä kohden.<br>Toimitusten oletusasetuksena on 180 sekunnin valmisteluaika ja 10 sekuntia lähetystä kohden.<br><strong>Huomioithan, että muutosten näkymisessä järjestelmässä voi kestää jopa 10 minuuttia.</strong>',
    settingsRecipientTrackingPage: 'Vastaanottajan seurantasivu',
    etaComponentHeading: 'Näytä tarkka ETA vastaanottajan sivulla',
    etaComponentDescription:
      'Tämän aktivoiminen antaa sinun päättää, milloin tarkka ETA näytetään vastaanottajalle aikarajan sijaan.',
    displayExactEta: 'Kyllä, näytä tarkka ETA',
    stopsLeftSelected: 'Pysäkkien määrä jäljellä toimitukseen',
    minutesLeftSelected: 'Minuuttien määrä jäljellä toimitukseen',
    numberOfMinutes: 'Minuuttien määrä',
    numberOfStops: 'Pysäkkien määrä',
    sendAutomaticEtaSmsTitle: 'Lähetä automaattinen SMS vastaanottajalle',
    sendAutomaticEtaSmsDescription:
      'Tämän aktivoiminen poistaa myös mahdollisuuden kuljettajalle lähettää SMS:ää kuljettajan sovelluksesta.',
    sendAutomaticEtaSms: 'Lähetä SMS automaattisesti',
    missingNumberOfStops: 'Syötä kelvollinen pysäkkien määrä, kun "Lähetä SMS automaattisesti" on valittu',
    missingNumberOfMinutes: 'Syötä kelvollinen minuuttimäärä, kun "Lähetä SMS automaattisesti" on valittu',
    minutesNotInRange: 'Määritä minuuttimäärä välillä {{from}} ja {{to}}',
    serviceDeliveryType: 'Palvelun toimitustyyppi',
    noServiceDeliveryTypeSelected: 'Ei asetettu',
    serviceDeliveryTypes: { Delivery: 'Toimitus', Return: 'Palautus', PickupPoint: 'Noutopiste' },
    Delivery: 'Toimitus',
    Pickup: 'Nouto',
    Return: 'Palautus',
    PickupPoint: 'Noutopiste',
    courierApp: 'Kuljettajan sovellus',
    allowCourierDescription: 'Salli kuljettajan hyväksyä tai hylätä lähetykset tämän palvelukoodin kanssa',
    allowCourierCheckbox: 'Kyllä, kuljettajalle sallitaan',
    none: 'Ei mitään'
  },
  matrix: {
    title: 'Matriisi',
    id: 'ID',
    pageTitle: 'Matriisin hallinta',
    name: 'Nimi',
    filename: 'Tiedoston nimi',
    uploaded: 'Ladattu',
    uploadedBy: 'Ladannut',
    downloadTemplate: 'Lataa malli',
    byUser: 'Käyttäjältä',
    country: 'Maa',
    ROUTING: 'Reititys',
    LINEHAUL: 'Linehaul',
    HUB: 'Keskus',
    DELIVERY: 'Toimitus',
    VAS: 'VAS',
    DEPARTMENT: 'Osasto',
    CUTOFF: 'Cutoff',
    PARCEL_DELIVERY: 'Pakettitoimitus',
    parcelDelivery: {
      searchLabel: 'Hae postinumeroa, osastoa tai keskusta',
      noRouting: 'Tässä matriisissa ei ole vielä reititysrivejä'
    },
    terminals: 'Terminaalit',
    searchLabel: 'Etsi nimellä tai asiakasnumerolla',
    bookingLimitsSearchLabel: 'Etsi terminaalin nimellä',
    'baggage-delivery': 'Matkatavarat',
    baggage: {
      title: 'Matkatavaramatriisit',
      name: 'Matkatavarat {{country}}',
      legend: "Jos haluat päivittää olemassa olevia matkatavaramatriiseja, tee se valitsemalla 'lataa matriisitiedot'.",
      uploadTitle: 'maalle {{country}}',
      custom: 'Mukautettu DS-koodimatriisi',
      uploadCustomTitle: 'mukautetuille DS-koodeille',
      status: 'Tila',
      uploadFail: '{{label}} ei hyväksytty virheellisen tiedon vuoksi. Muokkaa tietoja ja lataa matriisi uudelleen.',
      statuses: { accepted: 'Hyväksytty', pending: 'Odottaa', rejected: 'Hylätty' }
    },
    cutoff: {
      departments: 'Pakettiosastot ({{count}})',
      searchDepartment: 'Hae osastoa tai keskusta',
      hubCount: '{{count}} keskus',
      hubCount_other: '{{count}} keskusta',
      department: 'Pakettiosasto',
      selectDepartment: 'Valitse pakettiosasto',
      noDepartments: 'Pakettiosastoja ei löytynyt',
      hubName: 'Keskuksen nimi',
      hubId: 'Keskuksen ID',
      addHub: 'Lisää keskus',
      sameDay: 'Toimitus samana päivänä',
      noHubs: 'Tälle osastolle ei ole vielä rekisteröity keskuksia',
      saved: 'Cutoff-ajat tallennettiin',
      deleted: 'Keskus poistettiin',
      delete: {
        question: 'Poistetaanko {{hubName}}?',
        description: 'Keskus ja sen cutoff-aika poistetaan tältä osastolta.'
      },
      unsaved: {
        question: 'Hylätäänkö tallentamattomat cutoff-ajat?',
        description: 'Tälle osastolle tekemiäsi muutoksia ei ole tallennettu. Jos vaihdat osastoa, muutokset hylätään.',
        discard: 'Hylkää muutokset'
      }
    },
    terminalDetails: {
      details: 'Tiedot',
      alystraDepartmentId: 'Alystra-osaston tunnus',
      matrices: 'Matriisit',
      type: 'Tyyppi',
      noMatrices: 'Tähän terminaaliin ei viitata missään matriisissa',
      aliases: 'Aliakset',
      departmentId: 'Osaston tunnus',
      createdAt: 'Luotu',
      noAliases: 'Tällä terminaalilla ei ole aliaksia'
    },
    bookingLimits: {
      title: 'Varauksen rajat',
      header: '{{name}} - Muokkaa varauksen rajoja',
      rules: '#Säännöt',
      total: 'Yhteensä',
      rank: 'Prioriteetti',
      customer: 'Asiakas',
      customerNo: 'Asiakasnumero',
      serviceCode: 'Palvelu',
      timeWindow: 'Aikaraja',
      selectTimeWindow: 'Valitse aikaraja',
      noTimeWindow: 'Ei aikarajaa',
      noCustomer: 'Ei asiakasta',
      bookingLimit: 'Varauksen raja',
      removeLimit: 'Poista raja',
      addMoreLimits: 'Lisää lisää rajoja',
      delete: 'Poista varauksen rajat',
      deleteModalDescription: 'Et voi palauttaa tätä toimintoa',
      deleted: 'Varauksen rajat poistettiin onnistuneesti',
      updated: 'Varauksen rajat päivitettiin onnistuneesti'
    },
    master: 'Master',
    select: 'Valitse {{matrix}} matriisi...',
    overflow: '+{{overflow}} lisää..',
    vasCodes: 'VAS-koodit',
    connectedCustomers: {
      title: 'Liitetyt asiakkaat',
      button: 'Näytä {{connectedCustomers}} liitettyä asiakasta',
      search: 'Hae asiakasnimen tai numeron mukaan',
      subcustomer: 'Ala-asiakas'
    },
    upload: {
      success: 'Matriisitiedot ladattiin onnistuneesti',
      question: 'Lataa matriisitiedot',
      text: 'Lataa Excel',
      description: 'Lataa Excel-taulukko, jossa on tiedot tälle matriisille',
      error: 'Virhe ladattaessa tietoja {{name}}:hin. {{error}}',
      invalidformat: 'Virheellinen tiedostomuoto'
    },
    delete: {
      question: 'Poista matriisi {{name}}',
      description: 'Tätä ei voi peruuttaa',
      success: 'Matriisi {{name}} poistettiin onnistuneesti',
      error: 'Virhe poistettaessa {{name}}. {{error}}'
    },
    new: {
      question: 'Luo uusi matriisi',
      description: 'Luo uusi matriisi',
      success: 'Matriisi {{name}} luotiin onnistuneesti',
      error: 'Virhe matriisin luomisessa. {{error}}'
    },
    edit: {
      question: 'Muokkaa¨matriisia {{name}}',
      error: 'Virhe päivittäessä {{name}}. {{error}}',
      success: 'Matriisi {{name}} tallennettiin onnistuneesti'
    },
    type: 'Valitse tyyppi',
    day: { monday: 'Ma', tuesday: 'Ti', wednesday: 'Ke', thursday: 'To', friday: 'Pe', saturday: 'La', sunday: 'Su' },
    leadTime: 'Toimitusaika',
    terminal: 'Terminaali',
    terminalFrom: 'Terminaali alkaen',
    terminalTo: 'Terminaali asti',
    postalCode: 'Postinumero',
    postalCodeFrom: 'Postinumero alkaen',
    postalCodeTo: 'Kohdepostinumero',
    offsetDays: 'Viivepäivät',
    cutoffTime: 'Cutoff-aika',
    city: 'Kaupunki',
    error: {
      duplicateName: 'Nimi on jo olemassa',
      duplicateServiceCode: 'Varausrajoitukset on jo määritelty tälle asiakkaan ja palvelukoodin yhdistelmälle',
      duplicateTimeWindow: 'Päällekkäinen aikajakso'
    }
  },
  shipmentDetailsBilling: {
    finanicalStakeholder: 'Taloudelliset sidosryhmät',
    item: 'Tuote',
    customerTotal: 'Asiakkaan kokonaissumma',
    unitTotal: 'Yksikkösumma',
    orderTotal: 'Tilauksen kokonaissumma',
    disconnectToOrginalOrder: 'Irrota alkuperäisestä lähetysnumerosta'
  },
  upsalesRulesAdmin: {
    title: 'Lisämyyntisäännöt',
    titleSingular: 'Lisämyyntisääntö',
    name: 'Nimi',
    type: 'Tyyppi',
    searchPlaceholder: 'Hae lisämyyntisäännöt',
    settings: 'Asetukset',
    successfullyAdded: '{{name}} lisättiin onnistuneesti luetteloon',
    successfullyUpdated: '{{name}} päivitettiin onnistuneesti',
    createNewRule: 'Luo uusi lisämyyntisääntö',
    edit: 'Muokkaa',
    serviceUpgrade: 'Palvelun päivitys',
    SERVICE_UPGRADE: '$t(upsalesRulesAdmin.serviceUpgrade)',
    shorterTimeWindow: 'Lyhyempi aikaikkuna',
    SHORTER_TIME_WINDOW: '$t(upsalesRulesAdmin.shorterTimeWindow)',
    ruleName: 'Lisämyyntisäännön nimi',
    serviceUpgradeDescription1: 'Palvelu päivitetään 3123:sta 2870:een.',
    serviceUpgradeDescription2: 'VAS 1381 lisätään automaattisesti, jotta kuljettaja saa oikean maksun.',
    zipCodeRangeTitle: 'Postinumero',
    zipCodeRangeDescription:
      'Valitse postinumerot, jotka haluat sisällyttää tai jättää pois säännössä. Jos haluat poistaa tietyn postinumeron tai alueen sisällytetystä alueesta, käytä poissulkemisvaihtoehtoa valintasi tarkentamiseen.',
    fromZipCode: 'Postinumero alkaen',
    toZipCode: 'Postinumero asti',
    addRange: 'Lisää postinumeroalue',
    addZipCode: 'Lisää postinumero',
    noZipCodeRangesAdded: 'Sinun on annettava postinumeroalue',
    zipCodeRangeError: '"Postinumero alkaen" ei saa olla suurempi kuin "Postinumero asti"',
    deleteModalTitle: 'Poista lisämyyntisääntö',
    deleteModalDescription: 'Et voi peruuttaa tätä toimintoa',
    successfullyDeleted: 'Lisämyyntisääntö poistettiin onnistuneesti',
    shorterTimeWindowDescription1: 'Lyhyempi aikaikkuna on saatavilla kohteelle 3332',
    windowOnlyInEvening: 'Lyhyempi aikaikkuna tulee olla saatavilla vain iltaisin',
    timeWindowOffer: 'Mikä aikaikkuna tulisi tarjota vastaanottajalle?',
    oneHour: '1 tunti',
    twoHours: '2 tuntia',
    threeHours: '3 tuntia',
    mustSelectTimeWindow: 'Sinun on annettava vastaanottajalle tarjottu aikaikkuna',
    include: 'Sisällytä',
    exclude: 'Poissulje',
    zipCodeRangeType: 'Tyyppi',
    exactZipCode: 'Tarkka',
    zipCodeRange: 'Alue',
    zipCode: 'Postinumero',
    mustSelectCountry: 'Sinun on valittava maa ensin',
    includedZipCodes: 'Sisällytetyt postinumerot ({{count}})',
    excludedZipCodes: 'Poissuljetut postinumerot ({{count}})',
    noZipCodesAddedYet: 'Postinumeroita ei ole vielä lisätty',
    noMatchOnZipCodeSearch: 'Postinumeroa ei löytynyt. Kokeile suodattaa toisella postinumeroalueella.',
    zipCodesFound: '{{count}} postinumero löytyi',
    zipCodesFound_other: '{{count}} postinumeroa löytyi',
    filterOnDepartments: 'Suodata osastojen mukaan',
    UPSALES_RULE_COLLISION_OCCURRED:
      'Sääntö on jo olemassa! Poista joko seuraavat osastot: {{departments}} tai seuraavat asiakkaat: {{customers}}',
    status: 'Tila',
    active: 'Aktiivinen',
    paused: 'Keskeytetty',
    pauseRule: 'Keskeytä sääntö',
    activateRule: 'Aktivoi sääntö',
    activateRuleModalDescription:
      'Olet aktivoimassa sääntöä. Tämä tarkoittaa, että lisämyynti on saatavilla vastaanottajille. Haluatko jatkaa?',
    pauseRuleModalDescription:
      'Olet keskeyttämässä sääntöä. Tämä tarkoittaa, että lisämyynti ei ole saatavilla vastaanottajille. Haluatko jatkaa?',
    successfullyActivated: 'Lisämyyntisääntö aktivoitiin onnistuneesti',
    successfullyPaused: 'Lisämyyntisääntö keskeytettiin onnistuneesti'
  },
  billingOrder: {
    create: 'Luo laskutustilaus',
    copyTo: 'Kopioi laskutustilaukseksi',
    copyToBillingOrder: 'Kopioi laskutustilaukseksi',
    keepConnection: 'Säilytä yhteys',
    disconnect: 'Katkaise yhteys',
    creditMode: 'Hyvitys',
    debitMode: 'Veloitus',
    createCredit: 'Luo hyvityslasku',
    credit: 'Hyvityslasku',
    done: 'Laskutustilaus luotiin onnistuneesti. Lähetystunnus: {{shipmentId}}',
    invalidOrderForEdit:
      'Tätä tilausta ei voi muokata. Vain laskutus- tai hyvitystilauksia, joita ei ole vielä laskutettu, voidaan muokata.',
    cannotBeCredited: 'Et voi hyvittää tilausta, joka on laskutettu järjestelmässä {{systemId}}.',
    invalidOrderForCopy: 'Hyvityslaskua ei voi kopioida.',
    standaloneInvoice: 'Erillinen lasku',
    standaloneInvoiceLabel:
      'Haluan, että tämä tilaus käsitellään erikseen eikä yhdistetä muihin tilauksiin laskutusta varten.',
    noUnitNotSelfBilled: 'Tilauksia ilman yksikköä ei hyvitetä.',
    manualInvoiceInformation: {
      label: 'Manuaalinen laskunkäsittely',
      descriptionText: 'Jos tähän kenttään on täytetty laskutustiedot, tilausta ei laskuteta automaattisesti'
    },
    expensive: 'Syötetty hinta vaikuttaa poikkeuksellisen korkealta',
    creditInvoiceText: 'Hyvitys lähetykselle {{shipmentId}}',
    creditInvoiceLegText: {
      CUSTOMER_ORDER: 'Asiakashyvitus lähetykselle {{shipmentId}}',
      PICKUP_LEG: 'Hyvitys lähetyksen noudosta {{shipmentId}}',
      DELIVERY_LEG: 'Hyvitys lähetyksen toimituksesta {{shipmentId}}'
    },
    legSelectionLabel: 'Valitse kuljetusosuus',
    legSelectionError: 'Valitse, mikä kuljetusosuus hyvitetään',
    legSelection: {
      NONE: 'Ei mitään',
      CUSTOMER_ORDER: 'Asiakastilaus',
      PICKUP_LEG: 'Nouto',
      DELIVERY_LEG: 'Toimitus'
    },
    wrongPageWarning: 'Laskutustilauksia ei voi avata tältä sivulta',
    wrongPageLink: 'Siirry laskutustilauksen tietosivulle',
    type: {
      Invoice: 'Laskutustilaus',
      Invoice_other: 'Laskutustilaukset',
      Credit: 'Hyvityslasku',
      Credit_other: 'Hyvityslaskut',
      InternalTrade: 'Sisäisen kaupan tilaus',
      InternalTrade_other: 'Sisäisen kaupan tilaukset'
    }
  },
  welcomeToGlowWithName: "Tervetuloa Glow'hun, {{name}}!",
  welcomeToGlowDescription: 'Käytä vasemmalla olevaa navigointia aloittaaksesi työsi!',
  glowGlobeImage: 'Glow maapallon kuva',
  latestUpdatesHere: 'Tässä ovat uusimmat päivitykset',
  formValidation: {
    mustProvideName: 'Sinun on annettava nimi',
    mustProvideDescription: 'Sinun on annettava kuvaus',
    mustProvideServiceCode: 'Sinun on annettava palvelukoodi',
    mustProvideCalendarDays: 'Sinun on annettava kalenteripäivät',
    mustProvideCutOffTime: 'Sinun on annettava katkaisuajankohta',
    mustProvideCutOffMinutes: 'Sinun on annettava katkaisuminuutit',
    mustProvideDeliveryAttempts: 'Sinun on annettava toimitusyritykset',
    mustProvideCustomer: 'Sinun on annettava asiakas',
    mustProvideQuantity: 'Sinun on annettava määrä',
    mustProvideArticle: 'Sinun on annettava artikkeli',
    mustProvideDate: 'Sinun on annettava päivämäärä',
    mustProvideTime: 'Sinun on annettava aika',
    mustProvideDuration: 'Sinun on annettava kesto',
    mustProvideCustomerOrUnitAmount: 'Sinun on annettava asiakas- tai yksikkömäärä',
    allowedRangeIs: 'Sallittu alue on {{min}} - {{max}}'
  },
  units: {
    title: 'Yksiköt',
    new: 'Luo uusi yksikkö',
    connectFromOtherDepartments: 'Yhdistä muista osastoista',
    connect: {
      title: 'Yhdistä yksiköt nykyiseen osastoon',
      description: 'Voit etsiä yksiköitä vain niistä osastoista, joihin sinulla on pääsy',
      selected: 'Valitut yksiköt',
      noneSelected: 'Ei yksiköitä',
      submit: 'Yhdistä'
    },
    assigned: 'Yksikkö/yksiköt yhdistettiin onnistuneesti'
  },
  productionTimeWindow: {
    addNew: 'Lisää uusi tuotantoaikaikkuna',
    search: 'Hae tuotantoaikaikkunoita',
    description:
      'Täällä voit asettaa tuotantoaikaikkunan tilauksille, joilla on vastaanottajatunnus. Voit hakea vastaanottajatunnuksella tai postinumeroalueella - postinumeroalueella haettaessa sinun on myös valittava maa. Lisätäksesi tuotantoaikaikkunan, klikkaa "Lisää uusi" tai hae olemassa oleva muokataksesi.',
    addNewDescription:
      'Lisää aikaikkuna sille, milloin voimme toimittaa paketteja vastaanottajatunnukselle. Jos tuotantoaikaikkuna on lisätty, näitä tietoja käytetään reitityksessä palveluaikaikkunan sijaan.',
    recipientId: 'Vastaanottajatunnus',
    searchForRecipientId: 'Hae vastaanottajatunnuksella',
    recipientName: 'Vastaanottajan nimi',
    address: 'Osoite',
    postalCode: 'Postinumero',
    country: 'Maa',
    selectCountry: 'Valitse maa',
    addedSuccess: 'Tuotantoaikaikkuna kohteelle {{recipientId}} lisättiin onnistuneesti.',
    recipientIdValidation: 'Sinun täytyy antaa vastaanottaja tunnus',
    timeWindowValidation: 'Sinun täytyy antaa aikaväli',
    invalidRecipientId: 'Virheellinen vastaanottajatunnus',
    postalCodeRangeRequiredTogether: 'Postinumeroalueen alku ja loppu on molemmat täytettävä',
    postalCodeRangeRequiresCountry: 'Valitse maa hakeaksesi postinumeroalueella',
    createdAt: 'Luotu',
    from: 'Aikaväli alkaen',
    to: 'Aikaväli asti',
    editSuccess: 'Tuotantoaikaikkuna kohteelle {{recipientId}} muutettiin onnistuneesti.',
    delete: 'Poistetaanko tuotantoaikaikkuna kohteelle {{recipientId}}?',
    deleteDescription:
      'Tuotantoaikaikkunan poistaminen tarkoittaa, että palveluaikaikkunaa käytetään reitityksessä tälle vastaanottajatunnukselle. Haluatko jatkaa?',
    deleteSuccess: 'Tuotantoaikaikkuna kohteelle {{recipientId}} poistettiin onnistuneesti.',
    noResults: 'Tuotantoaikaikkunaa ei löytynyt',
    noResultsDescription:
      'Kokeile hakea toisella vastaanottajatunnuksella tai hae postinumeroalueella sen sijaan. Voit myös luoda uuden tuotantoaikaikkunan painamalla oikeassa yläkulmassa olevaa painiketta.',
    noResultsPostalCodeDescription:
      'Mikään tuotantoaikaikkuna ei vastaa tätä postinumeroaluetta. Kokeile hakea vastaanottajatunnuksella ilman postinumeroaluetta.',
    fromTimeAfterToTime: "'Alkaen'-ajan täytyy olla ennen 'päättyen'-aikaa"
  },
  loadCarrierModal: {
    title: 'Kuormalavaryhmä: {{loadCarrierId}}',
    description: 'Lähetykset ryhmässä'
  },
  routesOverview: {
    palletRuleOverridden: 'Lavasääntö ohitettu',
    routeNotFoundTitle: 'Reittiä ei löytynyt',
    routeNotFoundDescription: 'Se on voitu poistaa.',
    shipmentStatus: {
      CREATED: 'Luotu',
      ASSIGNED: 'Assigned',
      UNASSIGNED: 'Unassigned',
      COLLECTED: 'Noudettu',
      DELIVERED: 'Toimitettu',
      DEVIATED: 'Poikkeama',
      COMMENT: 'Kommentti',
      RESOLVED: 'Ratkaistu',
      UNRESOLVED: 'Ei ratkaistu',
      OFFERED: 'Tarjottu',
      REJECTED: 'Hylätty',
      ACCEPTED: 'Hyväksytty',
      RETURNED: 'Palautettu',
      DELETED: 'Poistetut',
      UNCONFIRMED: 'Vahvistamaton',
      REFUSED: 'Hylätty'
    },
    offeredAtTime: 'Tilaus tarjottu klo {{time}}',
    plannedRoute: 'Suunniteltu reitti',
    routes: 'Reitit',
    routesCount: '{{filtered}} / {{total}} reittiä',
    searchRouteOrDriver: 'Hae reitin nimi tai kuljettajan nimi',
    manuallyAdjustRoute: 'Säädä reitti manuaalisesti',
    changeRoute: 'Vaihda reitti',
    plannedRouteTime: 'Suunniteltu reittiaika',
    notOptimized: {
      title: 'Reittiä ei ole optimoitu',
      optimizationFailed:
        'Reitin optimointi epäonnistui, joten reitti käyttää optimoimatonta varavaihtoehtoa. ETA ja ETD eivät ole saatavilla.',
      manuallyPlanned: 'Reitti suunniteltiin manuaalisesti ilman optimointia, joten ETA ja ETD eivät ole saatavilla.'
    },
    statusOfRoute: 'Reitin tila',
    incorrectETA: 'Vastaanottajan seurantasivu näyttää virheellisiä ETA‑aikoja',
    adjustedFinishTime: 'Korjattu aika viimeiselle toimitukselle: {{time}}',
    driverIsDelayed: 'Kuljettaja on myöhässä {{delayed}} min {{suffix}}.',
    deviations: '{{count}} poikkeama',
    deviations_other: '{{count}} poikkeamaa',
    successfullyDeleted: '{{name}} poistettiin onnistuneesti',
    successfullyReversedDeliveryOrder: 'Toimitusjärjestys käännettiin onnistuneesti',
    colorPicker: 'Värivalitsin',
    deleteAllRoutesConfirmDialogText: 'Oletko varma, että haluat poistaa kaikki reitit?',
    stops: 'Stops',
    stop: 'Stop',
    waitingTime: 'Odotusaika',
    totalWaitingTime: 'Kokonaisodotusaika',
    stopsAfterPlannedEndTime: '{{count}} toimitus suunnitellun ruttiajan jälkeen ({{time}}).',
    stopsAfterPlannedEndTime_other: '{{count}} toimitusta suunnitellun ruttiajan jälkeen ({{time}}).',
    unassignShipmentFromRoute: 'Poista lähetys reitiltä',
    unassign: 'Poista',
    priceInformation: 'Hintatiedot',
    billingOrderShipment: 'Laskutustilaus',
    trips: 'Matkat',
    routeSettings: 'Reittiasetukset',
    driverPhoneNumber: 'Kuljettajan puhelinnumero',
    selectVehicle: 'Valitse ajoneuvo',
    nameOfRoute: 'Reitin nimi',
    setStartTime: 'Aseta aloitusaika',
    setEndDate: 'Päättymispäivä',
    setEndTime: 'Aseta lopetusaika',
    endDateValidationError: 'Päättymispäivän on oltava reitin päivä tai sitä seuraava päivä',
    endTimeValidationError: 'Lopetusajan on oltava aloitusajan jälkeen',
    addMapArea: 'Lisää kartta‐alue',
    editMapArea: 'Muokkaa kartta‐aluetta',
    areaWasUpdated: 'Kartta‐alue {{name}} päivitettiin onnistuneesti',
    areaWasCreated: 'Kartta‐alue lisättiin kohteeseen {{name}} onnistuneesti',
    areaWasDeleted: 'Kartta‐alue poistettiin kohteesta {{name}} onnistuneesti',
    addAreaRoute: 'Lisää alue reitille',
    updateAreaRoute: 'Päivitä alue reitille',
    deleteMapArea: 'Poista kartta‐alue',
    templates: 'Mallipohjat',
    loadTemplate: 'Lataa malli',
    deleteTemplate: 'Poista malli',
    saveAsTemplate: 'Tallenna mallina',
    saveTemplate: 'Tallenna malli',
    templateWasCreated: '{{name}} luotiin onnistuneesti',
    templateWasLoaded: '{{name}} ladattiin onnistuneesti',
    templateWasDeleted: '{{name}} poistettiin onnistuneesti',
    loadTemplateSubHeading: 'Valitse malli jonka haluat lisätä.',
    createANew: 'Luo uusi',
    orUpdateExisting: 'tai päivitä olemassa oleva',
    saveTemplateRulesNote:
      'Vain reittisääntöön liitetyt postinumerot tallennetaan malliin. Erillisiä postinumeroita ei tallenneta.',
    saveTemplateDepartmentGroupNote:
      'Tämä näkymä kattaa useita osastoja. Muiden osastojen reittisääntöjä ei tallenneta tähän malliin.',
    deleteTemplateSubHeading: 'Valitse malli jonka haluat poistaa.',
    defaultTemplate: 'Oletusmalli',
    defaultTemplateSubHeading:
      'Valitse malli, jota haluat käyttää oletuksena. Tätä mallia voidaan käyttää automaattiseen reittien luontiin, joka aktivoidaan Osastot-osiossa Hallinta-valikossa.',
    setDefaultTemplates: 'Aseta oletusmalli',
    selectDefaultTemplate: 'Valitse oletusmalli osastolle {{department}}',
    defaultTemplates: 'Oletusmallit',
    normalTemplates: 'Normaalit mallit',
    templateDefaultsSet: 'Oletusmallit asetettu',
    selectTemplate: 'Valitse malli',
    selectTemplateToOverride: 'Valitse malli yliajettavaksi',
    nameOfTemplate: 'Mallin nimi',
    templateIsRequired: 'Malli täytyy valita',
    templateOrNameIsRequired: 'Malli tai nimi täytyy valita',
    areYouDonePlanning: 'Oletko valmis reittisuunnittelun kanssa',
    noBackPage: 'Ei, takaisin sivulle',
    yesDone: 'Kyllä, olen valmis',
    manageRouteRules: 'Reittisääntöjen hallinta',
    eligibleForAutoDispatch: 'Kelvollinen noutotilausten auto-dispatchiin',
    postalCodeRangesSet: 'Postinumeroalueet asetettu',
    unsavedPostalCodeRule: 'Lisää postinumerosääntö ennen tallentamista',
    applyToConnectedRule: 'Käytä näitä muutoksia liitettyyn reittisääntöön "{{name}}"',
    serviceExclusionDescription:
      'Tilauksia, joilla on jokin näistä palvelukoodeista, ei koskaan lisätä tälle reitille auto-dispatchissa.',
    postalCodeRulesSaved: 'Postinumerosäännöt päivitettiin onnistuneesti',
    postalCodeRulesSavedAndApplied:
      'Postinumerosäännöt päivitettiin onnistuneesti ja niitä käytettiin myös säännössä "{{name}}"',
    postalCodesTab: 'Postinumerot',
    routeRuleTab: 'Reittisääntö',
    connectRouteRuleSubHeading:
      'Liitä reittisääntö tähän reittiin. Reitin postinumerosäännöt korvataan valitun reittisäännön säännöillä.',
    selectRouteRule: 'Valitse reittisääntö',
    routeRuleIsRequired: 'Reittisääntö on valittava',
    routeRuleConnected: 'Postinumerosäännöt korvattiin reittisäännöstä "{{name}}"',
    postalCodeRuleType: 'Säännön tyyppi',
    includePostalCodes: 'Sisällytä',
    excludePostalCodes: 'Sulje pois',
    postalCodeRange: 'Väli',
    exactPostalCode: 'Tarkka postinumero',
    postalCodeFrom: 'Postinumero alkaen',
    postalCodeTo: 'Postinumero asti',
    addPostalCodeRule: 'Lisää postinumerosääntö',
    noPostalCodeRules: 'Ei vielä lisätty',
    savedPostalCodeRules: 'Tallennetut postinumerosäännöt',
    postalCodeRuleRequired: 'Postinumero vaaditaan',
    postalCodeRuleConflict: {
      duplicate: 'Tämä postinumerosääntö on jo olemassa',
      overlap: 'Sääntö on päällekkäinen olemassa olevan säännön "{{rule}}" kanssa',
      excludeNotContained: 'Poissulkusäännön "{{rule}}" on oltava sisällytysalueen sisällä',
      excludeCoversInclude: 'Poissulkusääntö ei voi kattaa koko sisällytysaluetta "{{rule}}"'
    },
    skipAutoDispatch: 'Poista auto-dispatch käytöstä',
    enableAutoDispatch: 'Ota auto-dispatch käyttöön',
    skipAutoDispatchSuccess: 'Auto-dispatch poistettiin käytöstä kohteelta {{name}} onnistuneesti',
    enableAutoDispatchSuccess: '{{name}} aktivoitiin auto-dispatchiin onnistuneesti',
    completedRoute: '{{name}} on suoritettu',
    routeCreatedMessage: 'Reitti tallennettiin ja lisättiin reittilistaan onnistuneesti',
    createRoute: 'Luo reitti',
    saveAndCreateRoute: 'Tallenna ja luo uusi reitti',
    routeWasDeleted: 'Reitti poistettiin onnistuneesti',
    routeWasUpdated: 'Reitti päivitettiin onnistuneesti',
    routeWasUpdated_other: 'Reitit päivitettiin onnistuneesti',
    routeWasDeleted_other: 'Reitit poistettiin onnistuneesti',
    sendPrePickupSms: 'Lähetä ennakko‑seuranta SMS',
    deleteAllRoutes: 'Poista kaikki reitit',
    routesNotStarted: 'Reitit ei aloitettu',
    noRoutes: 'Reittejä ei ole vielä luotu',
    viewStopsGrouped: 'Ryhmittele pysähdykset',
    showCompletedDeliveries: 'Näytä suoritetut',
    showRemainingDeliveries: 'Näytä jäljellä olevat',
    orders: 'Tilaukset',
    onlyUnaccepted: 'vain hyväksymättömät',
    onlyRoutesWithUnacceptedOrders: 'Näytä vain reitit, joilla on hyväksymättömiä tilauksia',
    activeFilters: 'Aktiiviset suodattimet',
    clearFilters: 'Tyhjennä suodatin',
    clearSearch: 'Tyhjennä haku',
    removeFilter: 'Poista suodatin {{name}}',
    selectedCount: '{{count}} valittu',
    selectedCount_other: '{{count}} valittu',
    selectedCount_zero: 'ei valittuja',
    routeState: 'Reitin tila',
    routeLabels: 'Reittitunnisteet',
    state: 'Tila',
    routeNameAZ: 'Reitin nimi A–Ö',
    routeNameZA: 'Reitin nimi Ö–A',
    routeStartedAZ: 'Reitti aloitettu A-Ö',
    routeNotStartedAZ: 'Reitti ei aloitettu A-Ö',
    deletePlannedStopFromSlot: 'Poista suunniteltu pysähdys slotista',
    deleteBreakFromSlot: 'Poista taukoaika slotista',
    plannedStopDeletedFromSlot: 'Suunniteltu pysähdys poistettiin onnistuneesti slotista',
    movedOrderToRouteSuccess: 'Tilaus siirrettiin reitille {{routeName}}',
    movedOrderToRouteSuccess_other: '{{count}} tilausta siirrettiin reitille {{routeName}}',
    moveOrderToRouteQuestion: 'Siirrä tilaus reitille {{routeName}}?',
    moveOrderToRouteQuestion_other: 'Siirrä {{count}} tilausta reitille {{routeName}}?',
    couldNotMoveOrderToRoute: 'Tilausta ei voitu siirtää reitille {{routeName}}',
    failedToOptimizeSlotAfterDeletingPlannedStop:
      'Reitin optimointi epäonnistui suunnitellun pysähdyksen poistamisen jälkeen',
    actionsForAllShipments: 'Toiminnot kaikille lähetyksille',
    removePlannedStopFromRouteAndReoptimize:
      'Suunniteltu pysähdys poistetaan reitiltä ja reitti optimoidaan automaattisesti uudelleen.',
    unassignShipmentFromRouteAndReoptimize:
      'Lähetys poistetaan reitiltä ja reitti optimoidaan automaattisesti uudelleen.',
    unassignShipmentFromRouteAndReoptimize_other:
      'Lähetykset poistetaan reitiltä ja reitti optimoidaan automaattisesti uudelleen.',
    quickEditDisabledTooltip: 'Sinulla ei ole pääsyä tämän tilauksen osastolle.',
    routeLabel: 'Reittitunniste',
    selectRouteLabel: 'Valitse reittitunniste',
    labelFilter: {
      title: 'Suodata reitit tunnisteilla',
      description:
        'Tällä osastolla on reittitunnisteita. Valitse yksi tai useampi tunniste rajataksesi näytettäviä reittejä.',
      selectLabels: 'Valitse tunnisteet',
      apply: 'Käytä suodatinta',
      showAll: 'Näytä kaikki reitit',
      or: 'TAI',
      and: 'JA'
    },
    mustSelectVehicle: 'Valitse ajoneuvo'
  },
  reports: {
    serviceTimeWindow: 'Toimitettu palveluaikaikkunan sisällä',
    estimatedTimeWindow: 'Toimitettu arvioidun ajan sisällä',
    correctLocation: 'Toimitettu oikeaan paikkaan',
    withinSTW: 'STW:n sisällä',
    withinETD: 'ETD:n sisällä',
    withinPAW: 'PAW:n sisällä',
    followedRoutes: 'Seuratut reitit',
    departmentTitle: '{{name}}n raportti',
    serviceWindow: 'Palveluikkuna',
    estimatedWindow: 'Arvioitu ikkuna',
    quality: 'Laatu',
    scrollToStop: 'Vieritä pysähdykseen',
    stopGraphLabel: 'Pysähdysdata',
    hiddenStopsTooltip: 'Tämä kaavio sisältää piilotettuja pysähdyksiä. Klikkaa nähdäksesi mitkä pysähdykset',
    graphContainsHiddenStops: 'Tämä kaavio sisältää piilotettuja pysähdyksiä',
    stopWasHiddenDueToDeliveryDateSetTo: 'Pysähdys {{stopNumber}} piilotettiin, koska toimituspäivä oli {{date}}',
    stopWasHiddenDueToDeliveryDateNotSet: 'Pysähdys {{stopNumber}} piilotettiin, koska sitä ei suoritettu loppuun',
    productionAccuracy: 'Tuotantoikkuna',
    productionAccuracyTimeWindow: 'Toimitettu tuotantoikkunassa',
    actualStop: 'Todellinen pysähdysjärjestys',
    plannedStop: 'Suunniteltu pysähdysjärjestys',
    serviceTimeWindowTooltip: '{{number}} pysähdystä toimitettiin palveluaikaikkunassa.',
    estimatedTimeWindowTooltip: '{{number}} pysähdystä toimitettiin arvioidussa aikaikkunassa.',
    correctLocationTooltip: '{{number}} pysähdystä toimitettiin oikeaan sijaintiin.',
    followedRoutesTooltipStops: '{{number}} pysähdystä tehtiin oikeassa järjestyksessä.',
    followedRoutesTooltipOrders: '{{number}} tilausta toimitettiin oikeassa järjestyksessä.',
    productionAccuracyTooltip: '{{number}} pysähdys toimitettiin tuotantoikkunassa.'
  },
  settings: {
    profile: 'Profiili',
    departmentsSaved: 'Osastosi tallennettiin'
  },
  iamOnboarding: {
    description:
      'Näyttää siltä, ettei tiliisi ole vielä liitetty osastoja. Voit lisätä tarvitsemasi osastot vasemmalla olevan valikon Asetukset-kohdasta.',
    goToSettings: 'Siirry Asetuksiin'
  },
  iamMigrationModal: {
    title: 'Toimenpide vaaditaan: hae Glow One Identity -roolia',
    body: 'Posten- ja Bring-työntekijänä tarvitset nyt alla olevan roolin kirjautuaksesi Glowiin. Hae tätä roolia One Identityssä.',
    instructions:
      'Siirry osoitteeseen <a>{{iamUrl}}</a> ja hae roolia. Kun hakemuksesi on hyväksytty, voit kirjautua Glowiin Posten-tililläsi.',
    roleLabel: 'Haettava rooli',
    copyRole: 'Kopioi roolin nimi',
    copied: 'Kopioitu',
    applyForRole: 'Hae roolia',
    confirmCheckbox: 'Vahvistan hakeneeni roolia F_APP_S55475-GLOW_USR',
    confirm: 'Jatka'
  }
}
export default fi
